// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AuditControllerGetEntityAuditsData, AuditControllerGetEntityAuditsResponses, AuditControllerGetInvestmentAuditsData, AuditControllerGetInvestmentAuditsResponses, AuditControllerGetPersonAuditsData, AuditControllerGetPersonAuditsResponses, AuthControllerCancelChangeEmailRequestData, AuthControllerCancelChangeEmailRequestResponses, AuthControllerCanChangeCredentialsData, AuthControllerCanChangeCredentialsResponses, AuthControllerChangeEmailRequestData, AuthControllerChangeEmailRequestResponses, AuthControllerDeleteChangeEmailRequestData, AuthControllerDeleteChangeEmailRequestResponses, AuthControllerRenewInvitationData, AuthControllerRenewInvitationResponses, AuthControllerStartHostedAuthKitData, AuthControllerStartHostedAuthKitResponses, AuthControllerUpdateEmailData, AuthControllerUpdateEmailResponses, BankAccountControllerCreateMipBankAccountData, BankAccountControllerCreateMipBankAccountResponses, BankAccountControllerDeleteMipBankAccountData, BankAccountControllerDeleteMipBankAccountResponses, BankAccountControllerGetMipBankAccountData, BankAccountControllerGetMipBankAccountResponses, BankAccountControllerUpdateMipBankAccountData, BankAccountControllerUpdateMipBankAccountResponses, BankAccountControllerValidateBankAccountData, BankAccountControllerValidateBankAccountResponses, BankAccountFormatRuleControllerGetFormatRulesData, BankAccountFormatRuleControllerGetFormatRulesResponses, BankAccountFormatRuleControllerGetSupportedCountriesData, BankAccountFormatRuleControllerGetSupportedCountriesResponses, BankAccountLifecycleDebugControllerGetStateTransitionsData, BankAccountLifecycleDebugControllerGetStateTransitionsResponses, BankAccountLifecycleDebugControllerGetVerificationLogsData, BankAccountLifecycleDebugControllerGetVerificationLogsResponses, CapTableControllerDownloadExcelData, CapTableControllerDownloadExcelResponses, CapTableControllerExportDealHoldingsJsonData, CapTableControllerExportDealHoldingsJsonResponses, CapTableControllerGetCapDetailsData, CapTableControllerGetCapDetailsResponses, CapTableControllerGetCapTransactionsValidationDetailsData, CapTableControllerGetCapTransactionsValidationDetailsResponses, CapTableControllerPostCapTableDataData, CapTableControllerPostCapTableDataResponses, CapTableControllerPostGroupStructureDataData, CapTableControllerPostGroupStructureDataResponses, CapTableControllerPostGroupStructurePositionsData, CapTableControllerPostGroupStructurePositionsResponses, CapTableControllerPostSecuritiesForGroupStructureDataData, CapTableControllerPostSecuritiesForGroupStructureDataResponses, CapTableControllerUpdateGroupStructurePositionsData, CapTableControllerUpdateGroupStructurePositionsResponses, ClassifierControllerGetAllClassifiersData, ClassifierControllerGetAllClassifiersResponses, ClassifierControllerGetDealClassifiersData, ClassifierControllerGetDealClassifiersResponses, ClassifierControllerPostDealClassifiersData, ClassifierControllerPostDealClassifiersResponses, ConfigProviderControllerGetConfigData, ConfigProviderControllerGetConfigResponses, ContractControllerGetContractAndDocumentWorkflowFileNamesData, ContractControllerGetContractAndDocumentWorkflowFileNamesResponses, ContractDraftControllerCreateContractData, ContractDraftControllerCreateContractResponses, ContractDraftControllerDeleteContractData, ContractDraftControllerDeleteContractResponses, ContractDraftControllerGetContractsData, ContractDraftControllerGetContractsResponses, ContractDraftControllerUpdateContractData, ContractDraftControllerUpdateContractResponses, CspReportControllerCollectReportData, CspReportControllerCollectReportResponses, CustomDetailControllerCreateSingleCustomDetailData, CustomDetailControllerCreateSingleCustomDetailResponses, CustomDetailControllerDeleteSingleCustomDetailData, CustomDetailControllerDeleteSingleCustomDetailResponses, CustomDetailControllerGetAllMipCustomDetailData, CustomDetailControllerGetAllMipCustomDetailResponses, CustomDetailControllerGetKycWorkflowCustomDetailsData, CustomDetailControllerGetKycWorkflowCustomDetailsResponses, CustomDetailControllerToggleArchivedData, CustomDetailControllerToggleArchivedResponses, CustomDetailControllerUpdateKycWorkflowCustomDetailData, CustomDetailControllerUpdateKycWorkflowCustomDetailResponses, CustomDetailControllerUpdateSingleCustomDetailData, CustomDetailControllerUpdateSingleCustomDetailResponses, DealControllerCreateDealClassifiersData, DealControllerCreateDealClassifiersResponses, DealControllerCreateDealData, DealControllerCreateDealResponses, DealControllerGetDealBasicDataData, DealControllerGetDealBasicDataResponses, DealControllerGetDealClassifiersData, DealControllerGetDealClassifiersResponses, DealControllerGetDealData, DealControllerGetDealDetailsData, DealControllerGetDealDetailsResponses, DealControllerGetDealResponses, DealControllerGetListData, DealControllerGetListResponses, DealControllerSetDealRestrictionData, DealControllerSetDealRestrictionResponses, DealControllerSoftDeleteDealData, DealControllerSoftDeleteDealResponses, DealControllerUpdateCompanyRepresentativeData, DealControllerUpdateCompanyRepresentativeResponses, DealControllerUpdateDealClassifiersData, DealControllerUpdateDealClassifiersResponses, DealControllerUpdateDealData, DealControllerUpdateDealResponses, DealControllerUpdateProjectRepresentativeData, DealControllerUpdateProjectRepresentativeResponses, DealDocumentTemplatesControllerListData, DealDocumentTemplatesControllerListResponses, DealEmailTemplateControllerGetOneData, DealEmailTemplateControllerGetOneResponses, DealEmailTemplateControllerListData, DealEmailTemplateControllerListResponses, DealEmailTemplateControllerPreviewData, DealEmailTemplateControllerPreviewResponses, DealEmailTemplateControllerResetData, DealEmailTemplateControllerResetResponses, DealEmailTemplateControllerTestSendData, DealEmailTemplateControllerTestSendResponses, DealEmailTemplateControllerUpdateData, DealEmailTemplateControllerUpdateResponses, DealEventLogControllerExportDealEventsData, DealEventLogControllerExportDealEventsResponses, DealEventLogControllerGetDealEventDailyCountsData, DealEventLogControllerGetDealEventDailyCountsResponses, DealEventLogControllerGetDealEventMessageData, DealEventLogControllerGetDealEventMessageResponses, DealEventLogControllerGetDealEventRecipientsData, DealEventLogControllerGetDealEventRecipientsResponses, DealEventLogControllerGetDealEventsData, DealEventLogControllerGetDealEventSendersData, DealEventLogControllerGetDealEventSendersResponses, DealEventLogControllerGetDealEventsResponses, DealEventLogControllerGetDealEventSubjectsData, DealEventLogControllerGetDealEventSubjectsResponses, DealEventLogControllerGetUnreadData, DealEventLogControllerGetUnreadResponses, DealEventLogControllerMarkViewedData, DealEventLogControllerMarkViewedResponses, DealUsersControllerDeleteUserFromDealData, DealUsersControllerDeleteUserFromDealResponses, DealUsersControllerGetDealUserData, DealUsersControllerGetDealUserResponses, DealUsersControllerGetDealUsersData, DealUsersControllerGetDealUsersResponses, DealUsersControllerInviteUserToDealData, DealUsersControllerInviteUserToDealResponses, DealUsersControllerSyncUserInDealToAllProgrammesData, DealUsersControllerSyncUserInDealToAllProgrammesResponses, DocumentControllerCreateDocumentsData, DocumentControllerCreateDocumentsResponses, DocumentControllerCreateUploadPreSignedUrlsData, DocumentControllerCreateUploadPreSignedUrlsResponses, DocumentControllerFindRelatedDocumentsData, DocumentControllerFindRelatedDocumentsResponses, DocumentControllerFindRelatedFilesInDealData, DocumentControllerFindRelatedFilesInDealResponses, DocumentControllerGetDocumentData, DocumentControllerGetDocumentResponses, DocumentControllerGetDocumentsData, DocumentControllerGetDocumentsResponses, DocumentControllerRemoveDocumentData, DocumentControllerRemoveDocumentPersonLinkData, DocumentControllerRemoveDocumentPersonLinkResponses, DocumentControllerRemoveDocumentResponses, DocumentControllerRemoveDocumentTransactionLinkData, DocumentControllerRemoveDocumentTransactionLinkResponses, DocumentControllerUpdateData, DocumentControllerUpdateRelatedDocumentsData, DocumentControllerUpdateRelatedDocumentsResponses, DocumentControllerUpdateResponses, DocumentLibraryControllerAddPersonsToDocumentData, DocumentLibraryControllerAddPersonsToDocumentResponses, DocumentLibraryControllerAddPersonsToDocumentsData, DocumentLibraryControllerAddPersonsToDocumentsResponses, DocumentLibraryControllerBulkClassifyDocumentsData, DocumentLibraryControllerBulkClassifyDocumentsResponses, DocumentLibraryControllerBulkDeleteDocumentsData, DocumentLibraryControllerBulkDeleteDocumentsResponses, DocumentLibraryControllerBulkDownloadDocumentFilesData, DocumentLibraryControllerBulkDownloadDocumentFilesResponses, DocumentLibraryControllerGetDealClassifiersByGroupsData, DocumentLibraryControllerGetDealClassifiersByGroupsResponses, DocumentLibraryControllerGetDocumentDetailsData, DocumentLibraryControllerGetDocumentDetailsResponses, DocumentLibraryControllerGetDocumentsWithFilteringData, DocumentLibraryControllerGetDocumentsWithFilteringResponses, DocumentLibraryControllerGetPersonsInDealData, DocumentLibraryControllerGetPersonsInDealResponses, DocumentLibraryControllerRemovePersonsFromDocumentData, DocumentLibraryControllerRemovePersonsFromDocumentResponses, DocumentLibraryControllerRemovePersonsFromDocumentsData, DocumentLibraryControllerRemovePersonsFromDocumentsResponses, DocumentLibraryControllerSetPersonDocumentVisibilityData, DocumentLibraryControllerSetPersonDocumentVisibilityResponses, DocumentLibraryControllerUpdateDocumentData, DocumentLibraryControllerUpdateDocumentResponses, DocumentParsingControllerGetBatchDocumentsData, DocumentParsingControllerGetBatchDocumentsResponses, DocumentParsingControllerGetBatchOverviewData, DocumentParsingControllerGetBatchOverviewResponses, DocumentParsingControllerGetBatchPeopleData, DocumentParsingControllerGetBatchPeopleResponses, DocumentParsingControllerGetBatchSecuritiesData, DocumentParsingControllerGetBatchSecuritiesResponses, DocumentParsingControllerGetBatchTransactionsData, DocumentParsingControllerGetBatchTransactionsResponses, DocumentParsingControllerGetDocumentTransactionsData, DocumentParsingControllerGetDocumentTransactionsResponses, DocumentParsingControllerGetExtractionResultData, DocumentParsingControllerGetExtractionResultResponses, DocumentParsingControllerGetExtractionStatusData, DocumentParsingControllerGetExtractionStatusResponses, DocumentParsingControllerListBatchesData, DocumentParsingControllerListBatchesResponses, DocumentParsingControllerListDealBatchesData, DocumentParsingControllerListDealBatchesResponses, DocumentParsingControllerMatchBatchPersonData, DocumentParsingControllerMatchBatchPersonResponses, DocumentParsingControllerMatchBatchSecurityData, DocumentParsingControllerMatchBatchSecurityResponses, DocumentParsingControllerReextractBatchData, DocumentParsingControllerReextractBatchResponses, DocumentParsingControllerSaveBatchExtractionOverridesData, DocumentParsingControllerSaveBatchExtractionOverridesResponses, DocumentParsingControllerStartExtractionData, DocumentParsingControllerStartExtractionResponses, DocumentParsingControllerUpdateBatchTitleData, DocumentParsingControllerUpdateBatchTitleResponses, DocumentParsingControllerUploadExtractionDocumentData, DocumentParsingControllerUploadExtractionDocumentResponses, DocumentTemplatesControllerCreateData, DocumentTemplatesControllerCreateResponses, DocumentTemplatesControllerGetAvailabilityData, DocumentTemplatesControllerGetAvailabilityResponses, DocumentTemplatesControllerGetByIdData, DocumentTemplatesControllerGetByIdResponses, DocumentTemplatesControllerGetDocxFlowDocumentData, DocumentTemplatesControllerGetDocxFlowDocumentResponses, DocumentTemplatesControllerGetFieldBindingCatalogueData, DocumentTemplatesControllerGetFieldBindingCatalogueResponses, DocumentTemplatesControllerGetFieldBindingsData, DocumentTemplatesControllerGetFieldBindingsResponses, DocumentTemplatesControllerListData, DocumentTemplatesControllerListResponses, DocumentTemplatesControllerPreviewFieldBindingsData, DocumentTemplatesControllerPreviewFieldBindingsResponses, DocumentTemplatesControllerRenderDocxTemplateData, DocumentTemplatesControllerRenderDocxTemplateResponses, DocumentTemplatesControllerSaveDocxFlowDocumentData, DocumentTemplatesControllerSaveDocxFlowDocumentResponses, DocumentTemplatesControllerSetAvailabilityData, DocumentTemplatesControllerSetAvailabilityResponses, DocumentTemplatesControllerSoftDeleteData, DocumentTemplatesControllerSoftDeleteResponses, DocumentTemplatesControllerUpdateData, DocumentTemplatesControllerUpdateFieldBindingsData, DocumentTemplatesControllerUpdateFieldBindingsResponses, DocumentTemplatesControllerUpdateResponses, DocumentWorkflowBulkSigningControllerEidEasyBulkCompleteData, DocumentWorkflowBulkSigningControllerEidEasyBulkCompleteResponses, DocumentWorkflowBulkSigningControllerEidEasyBulkPrepareData, DocumentWorkflowBulkSigningControllerEidEasyBulkPrepareResponses, DocumentWorkflowBulkSigningControllerEidEasyBulkSignCompleteData, DocumentWorkflowBulkSigningControllerEidEasyBulkSignCompleteResponses, DocumentWorkflowBulkSigningControllerEidEasyBulkSignInitiateData, DocumentWorkflowBulkSigningControllerEidEasyBulkSignInitiateResponses, DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusData, DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusResponses, DocumentWorkflowControllerAddCounterpartyData, DocumentWorkflowControllerAddCounterpartyResponses, DocumentWorkflowControllerAddInvestorsData, DocumentWorkflowControllerAddInvestorsResponses, DocumentWorkflowControllerApplyDateCompleteData, DocumentWorkflowControllerApplyDateCompleteResponses, DocumentWorkflowControllerApplyDatePrepareData, DocumentWorkflowControllerApplyDatePrepareResponses, DocumentWorkflowControllerAssignUserToSignerData, DocumentWorkflowControllerAssignUserToSignerResponses, DocumentWorkflowControllerBulkAddCounterpartyData, DocumentWorkflowControllerBulkAddCounterpartyPreviewData, DocumentWorkflowControllerBulkAddCounterpartyPreviewResponses, DocumentWorkflowControllerBulkAddCounterpartyResponses, DocumentWorkflowControllerBulkAddCounterpartyStatusData, DocumentWorkflowControllerBulkAddCounterpartyStatusResponses, DocumentWorkflowControllerBulkApplyDateData, DocumentWorkflowControllerBulkApplyDateResponses, DocumentWorkflowControllerBulkApplyDateStatusData, DocumentWorkflowControllerBulkApplyDateStatusResponses, DocumentWorkflowControllerBulkAssignCounterpartiesPreviewData, DocumentWorkflowControllerBulkAssignCounterpartiesPreviewResponses, DocumentWorkflowControllerBulkAssignCounterpartyData, DocumentWorkflowControllerBulkAssignCounterpartyResponses, DocumentWorkflowControllerBulkAssignCounterpartyStatusData, DocumentWorkflowControllerBulkAssignCounterpartyStatusResponses, DocumentWorkflowControllerBulkClaimGenerationStatusData, DocumentWorkflowControllerBulkClaimGenerationStatusResponses, DocumentWorkflowControllerBulkClaimOnBehalfData, DocumentWorkflowControllerBulkClaimOnBehalfPreviewData, DocumentWorkflowControllerBulkClaimOnBehalfPreviewResponses, DocumentWorkflowControllerBulkClaimOnBehalfResponses, DocumentWorkflowControllerBulkDownloadFilesData, DocumentWorkflowControllerBulkDownloadFilesResponses, DocumentWorkflowControllerBulkExportToExcelData, DocumentWorkflowControllerBulkExportToExcelResponses, DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewData, DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewResponses, DocumentWorkflowControllerBulkInviteAuthorisedSignatoryData, DocumentWorkflowControllerBulkInviteAuthorisedSignatoryResponses, DocumentWorkflowControllerBulkReissueDocumentsData, DocumentWorkflowControllerBulkReissueDocumentsResponses, DocumentWorkflowControllerBulkRemindSignersData, DocumentWorkflowControllerBulkRemindSignersResponses, DocumentWorkflowControllerBulkRemindSignersStatusData, DocumentWorkflowControllerBulkRemindSignersStatusResponses, DocumentWorkflowControllerBulkRevokeSimpleDocumentsData, DocumentWorkflowControllerBulkRevokeSimpleDocumentsResponses, DocumentWorkflowControllerBulkSetSignerRequiresWitnessData, DocumentWorkflowControllerBulkSetSignerRequiresWitnessResponses, DocumentWorkflowControllerBulkSetSignerSecurityLevelData, DocumentWorkflowControllerBulkSetSignerSecurityLevelResponses, DocumentWorkflowControllerCancelAuthorisedSignatoryData, DocumentWorkflowControllerCancelAuthorisedSignatoryResponses, DocumentWorkflowControllerClaimSignerData, DocumentWorkflowControllerClaimSignerResponses, DocumentWorkflowControllerCloseDocumentWithoutSignatureData, DocumentWorkflowControllerCloseDocumentWithoutSignatureResponses, DocumentWorkflowControllerEidEasyCompleteData, DocumentWorkflowControllerEidEasyCompleteResponses, DocumentWorkflowControllerEidEasyPrepareData, DocumentWorkflowControllerEidEasyPrepareResponses, DocumentWorkflowControllerFindDocumentWorkflowEventsData, DocumentWorkflowControllerFindDocumentWorkflowEventsResponses, DocumentWorkflowControllerFindInvestmentProgrammeDocumentData, DocumentWorkflowControllerFindInvestmentProgrammeDocumentResponses, DocumentWorkflowControllerFindInvestmentProgrammeDocumentsData, DocumentWorkflowControllerFindInvestmentProgrammeDocumentsResponses, DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesData, DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesResponses, DocumentWorkflowControllerGetAddCounterpartyEligibilityData, DocumentWorkflowControllerGetAddCounterpartyEligibilityResponses, DocumentWorkflowControllerGetAddInvestorEligibilityData, DocumentWorkflowControllerGetAddInvestorEligibilityResponses, DocumentWorkflowControllerInviteAuthorisedSignatoryData, DocumentWorkflowControllerInviteAuthorisedSignatoryResponses, DocumentWorkflowControllerInviteRepresentativeData, DocumentWorkflowControllerInviteRepresentativeResponses, DocumentWorkflowControllerInviteWitnessData, DocumentWorkflowControllerInviteWitnessResponses, DocumentWorkflowControllerRemoveSignerData, DocumentWorkflowControllerRemoveSignerResponses, DocumentWorkflowControllerRemoveSubmittedFormData, DocumentWorkflowControllerRemoveSubmittedFormResponses, DocumentWorkflowControllerReplaceDocumentFileData, DocumentWorkflowControllerReplaceDocumentFileResponses, DocumentWorkflowControllerResendInvitationData, DocumentWorkflowControllerResendInvitationResponses, DocumentWorkflowControllerSetSignerRequiresWitnessData, DocumentWorkflowControllerSetSignerRequiresWitnessResponses, DocumentWorkflowControllerSetSignerSecurityLevelData, DocumentWorkflowControllerSetSignerSecurityLevelResponses, DocumentWorkflowControllerSignWetInkDocumentData, DocumentWorkflowControllerSignWetInkDocumentResponses, DocumentWorkflowControllerSignWetInkDocumentUploadData, DocumentWorkflowControllerSignWetInkDocumentUploadResponses, DocumentWorkflowControllerStreamProgrammeDocumentsData, DocumentWorkflowControllerStreamProgrammeDocumentsResponses, DocumentWorkflowControllerSubmitFormData, DocumentWorkflowControllerSubmitFormResponses, DocumentWorkflowControllerSubmitFormUploadData, DocumentWorkflowControllerSubmitFormUploadResponses, DocumentWorkflowControllerUnassignUserFromSignerData, DocumentWorkflowControllerUnassignUserFromSignerResponses, DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesData, DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesResponses, DocumentWorkflowKycFormControllerAttachFormData, DocumentWorkflowKycFormControllerAttachFormResponses, DocumentWorkflowKycFormControllerGetFormsForKycWorkflowData, DocumentWorkflowKycFormControllerGetFormsForKycWorkflowResponses, DocumentWorkflowKycFormControllerGetInvestorFormsData, DocumentWorkflowKycFormControllerGetInvestorFormsResponses, DocumentWorkflowKycFormControllerRemoveFormData, DocumentWorkflowKycFormControllerRemoveFormResponses, DocumentWorkflowKycFormControllerResetFormData, DocumentWorkflowKycFormControllerResetFormResponses, DocumentWorkflowKycFormControllerReviewFormData, DocumentWorkflowKycFormControllerReviewFormResponses, DocumentWorkflowMasterDocumentsControllerBulkArchiveData, DocumentWorkflowMasterDocumentsControllerBulkArchiveResponses, DocumentWorkflowMasterDocumentsControllerBulkDeleteData, DocumentWorkflowMasterDocumentsControllerBulkDeleteResponses, DocumentWorkflowMasterDocumentsControllerCreateData, DocumentWorkflowMasterDocumentsControllerCreateResponses, DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesData, DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesResponses, DocumentWorkflowMasterDocumentsControllerGetByIdData, DocumentWorkflowMasterDocumentsControllerGetByIdResponses, DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentData, DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentResponses, DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueData, DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueResponses, DocumentWorkflowMasterDocumentsControllerGetFieldBindingsData, DocumentWorkflowMasterDocumentsControllerGetFieldBindingsResponses, DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsData, DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsResponses, DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsData, DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsResponses, DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateData, DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewData, DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewResponses, DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateResponses, DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentData, DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentResponses, DocumentWorkflowMasterDocumentsControllerSoftDeleteMasterDocumentData, DocumentWorkflowMasterDocumentsControllerSoftDeleteMasterDocumentResponses, DocumentWorkflowMasterDocumentsControllerUpdateArchivedData, DocumentWorkflowMasterDocumentsControllerUpdateArchivedResponses, DocumentWorkflowMasterDocumentsControllerUpdateFieldBindingsData, DocumentWorkflowMasterDocumentsControllerUpdateFieldBindingsResponses, DocumentWorkflowMasterDocumentsControllerUpdateMasterDocumentData, DocumentWorkflowMasterDocumentsControllerUpdateMasterDocumentResponses, E2eControllerAcceptWorkOsInvitationData, E2eControllerAcceptWorkOsInvitationResponses, E2eControllerAuthenticateUserData, E2eControllerAuthenticateUserResponses, E2eControllerChangeWorkOsUserEmailData, E2eControllerChangeWorkOsUserEmailResponses, E2eControllerCreateUserData, E2eControllerCreateUserResponses, E2eControllerCreateWorkOsUserData, E2eControllerCreateWorkOsUserResponses, E2eControllerDisableMipKycData, E2eControllerDisableMipKycResponses, E2eControllerGetChangeEmailVerificationCodeData, E2eControllerGetChangeEmailVerificationCodeResponses, E2eControllerGetSentEmailsData, E2eControllerGetSentEmailsResponses, E2eControllerGetSsoFixtureData, E2eControllerGetSsoFixtureResponses, E2eControllerGetWorkOsEmailVerificationCodeData, E2eControllerGetWorkOsEmailVerificationCodeResponses, E2eControllerGetWorkOsMagicAuthCodeData, E2eControllerGetWorkOsMagicAuthCodeResponses, E2eControllerGetWorkOsPasswordResetLinkData, E2eControllerGetWorkOsPasswordResetLinkResponses, E2eControllerGetWorkOsUserData, E2eControllerGetWorkOsUserResponses, E2eControllerPollWorkOsEventsData, E2eControllerPollWorkOsEventsResponses, E2eControllerResetSsoOrganizationData, E2eControllerResetSsoOrganizationResponses, E2eControllerWarmupPoolData, E2eControllerWarmupPoolResponses, EidEasyMockControllerCompleteData, EidEasyMockControllerCompleteResponses, EidEasyMockControllerSignPageData, EidEasyMockControllerSignPageResponses, EidEasyMockControllerVerifyOtpData, EidEasyMockControllerVerifyOtpResponses, EidEasyWebhookControllerCustomSignatureImageData, EidEasyWebhookControllerCustomSignatureImageResponses, EidEasyWebhookControllerDocumentSignedData, EidEasyWebhookControllerDocumentSignedResponses, EmailChangeEligibilityControllerGetEmailChangeEligibilityData, EmailChangeEligibilityControllerGetEmailChangeEligibilityResponses, EmailSchedulerControllerCancelData, EmailSchedulerControllerCancelResponses, EmailSchedulerControllerCreateScheduleData, EmailSchedulerControllerCreateScheduleResponses, EmailSchedulerControllerListConfigsData, EmailSchedulerControllerListConfigsResponses, EmailSchedulerControllerListSchedulesData, EmailSchedulerControllerListSchedulesResponses, EmailSchedulerControllerRescheduleData, EmailSchedulerControllerRescheduleResponses, EmailSchedulerControllerRestartData, EmailSchedulerControllerRestartResponses, EmailSchedulerControllerSendNowData, EmailSchedulerControllerSendNowResponses, EmailSchedulerControllerSetEndDateData, EmailSchedulerControllerSetEndDateResponses, EmailSchedulerControllerUpsertConfigData, EmailSchedulerControllerUpsertConfigResponses, EmploymentEmployersControllerGetEmployersData, EmploymentEmployersControllerGetEmployersResponses, EmploymentRecordControllerDeleteEmploymentRecordData, EmploymentRecordControllerDeleteEmploymentRecordResponses, EmploymentRecordControllerGetEmploymentRecordData, EmploymentRecordControllerGetEmploymentRecordResponses, EmploymentRecordControllerUpdateEmploymentRecordData, EmploymentRecordControllerUpdateEmploymentRecordResponses, FileControllerBulkDownloadFilesData, FileControllerBulkDownloadFilesResponses, FileControllerCreateFileData, FileControllerCreateFileResponses, FileControllerCreateSignatureFileData, FileControllerCreateSignatureFileResponses, FileControllerDownloadFileData, FileControllerDownloadFileResponses, FileControllerDownloadPreSignedUrlData, FileControllerDownloadPreSignedUrlResponses, FileControllerGetFileDownloadUrlData, FileControllerGetFileDownloadUrlResponses, ForeignExchangeControllerGetCurrenciesUsedInValuationData, ForeignExchangeControllerGetCurrenciesUsedInValuationResponses, ForeignExchangeControllerGetHistoricalAndCustomExchangeRateData, ForeignExchangeControllerGetHistoricalAndCustomExchangeRateResponses, ForeignExchangeControllerGetLatestExchangeRateData, ForeignExchangeControllerGetLatestExchangeRateResponses, ForeignExchangeControllerPutCustomExchangeRateData, ForeignExchangeControllerPutCustomExchangeRateResponses, FundControllerCreateFundData, FundControllerCreateFundResponses, FundControllerGetAllFundsData, FundControllerGetAllFundsResponses, FundControllerGetAvailableDealsForFundData, FundControllerGetAvailableDealsForFundResponses, FundControllerGetAvailableDealsForPersonFundLinkData, FundControllerGetAvailableDealsForPersonFundLinkResponses, FundControllerGetFundByDealData, FundControllerGetFundByDealResponses, FundControllerGetFundData, FundControllerGetFundLinkedDealsData, FundControllerGetFundLinkedDealsResponses, FundControllerGetFundLinksForPersonData, FundControllerGetFundLinksForPersonResponses, FundControllerGetFundResponses, FundControllerLinkFundToDealData, FundControllerLinkFundToDealResponses, FundControllerLinkPersonToFundData, FundControllerLinkPersonToFundResponses, FundControllerUnlinkFundFromDealData, FundControllerUnlinkFundFromDealResponses, FundControllerUnlinkPersonFromFundData, FundControllerUnlinkPersonFromFundResponses, FundControllerUpdateFundData, FundControllerUpdateFundResponses, GeneratableDocumentsControllerAssignProjectToGeneratableDocumentTemplateData, GeneratableDocumentsControllerAssignProjectToGeneratableDocumentTemplateResponses, GeneratableDocumentsControllerCreateGdwtCustomDetailsDefinitionsData, GeneratableDocumentsControllerCreateGdwtCustomDetailsDefinitionsResponses, GeneratableDocumentsControllerDeleteCustomDetailsDefinitionsData, GeneratableDocumentsControllerDeleteCustomDetailsDefinitionsResponses, GeneratableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeData, GeneratableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeResponses, GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesData, GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesResponses, GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsData, GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsResponses, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsData, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsResponses, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateData, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateResponses, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsData, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsResponses, GeneratableDocumentsControllerUnassignProjectToGeneratableDocumentTemplateData, GeneratableDocumentsControllerUnassignProjectToGeneratableDocumentTemplateResponses, GeneratableDocumentsControllerUpdateGdwtCustomDetailsDefinitionsData, GeneratableDocumentsControllerUpdateGdwtCustomDetailsDefinitionsResponses, GeneratableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFieldsData, GeneratableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFieldsResponses, GeneratableDocumentsControllerUpdateGeneratableDocumentTemplateData, GeneratableDocumentsControllerUpdateGeneratableDocumentTemplateResponses, GodmodeControllerBulkCreateTsaForMipData, GodmodeControllerBulkCreateTsaForMipResponses, GodmodeControllerChangeDealData, GodmodeControllerChangeDealResponses, GodmodeControllerCreateCustomDetailsData, GodmodeControllerCreateCustomDetailsResponses, GodmodeControllerDeleteUserSoftData, GodmodeControllerDeleteUserSoftResponses, GodmodeControllerDownloadFileData, GodmodeControllerDownloadFileResponses, GodmodeControllerGetActiveMipsData, GodmodeControllerGetActiveMipsResponses, GodmodeControllerGetAllInvestorDataData, GodmodeControllerGetAllInvestorDataResponses, GodmodeControllerGetAllInvestorsData, GodmodeControllerGetAllInvestorsForMipData, GodmodeControllerGetAllInvestorsForMipResponses, GodmodeControllerGetAllInvestorsResponses, GodmodeControllerGetAllNotDeletedProjectsData, GodmodeControllerGetAllNotDeletedProjectsResponses, GodmodeControllerGetDealData, GodmodeControllerGetDealResponses, GodmodeControllerGetDealsListData, GodmodeControllerGetDealsListResponses, GodmodeControllerGetDealWithActiveMipsData, GodmodeControllerGetDealWithActiveMipsResponses, GodmodeControllerGetFileInfoData, GodmodeControllerGetFileInfoResponses, GodmodeControllerGetInvestmentWorkflowsData, GodmodeControllerGetInvestmentWorkflowsResponses, GodmodeControllerGetInvestorPersonalDetailsDataByUserIdData, GodmodeControllerGetInvestorPersonalDetailsDataByUserIdResponses, GodmodeControllerGetInvestorsFromMipData, GodmodeControllerGetInvestorsFromMipResponses, GodmodeControllerGetMipCustomDetailsDataWithoutFormsData, GodmodeControllerGetMipCustomDetailsDataWithoutFormsResponses, GodmodeControllerGetMipDataData, GodmodeControllerGetMipDataResponses, GodmodeControllerGetMipListOfInvestmentsData, GodmodeControllerGetMipListOfInvestmentsResponses, GodmodeControllerGetMipListOfLoansData, GodmodeControllerGetMipListOfLoansResponses, GodmodeControllerGetUserDataData, GodmodeControllerGetUserDataResponses, GodmodeControllerIsAnyActiveInvestorInMipData, GodmodeControllerIsAnyActiveInvestorInMipResponses, GodmodeControllerIsAnyInvitedInvestorInMipData, GodmodeControllerIsAnyInvitedInvestorInMipResponses, GodmodeControllerPostBulkEditMipInvestmentsData, GodmodeControllerPostBulkEditMipInvestmentsResponses, GodmodeControllerPostBulkUpdateMipLoansData, GodmodeControllerPostBulkUpdateMipLoansResponses, GodmodeControllerPostReassignInvestorData, GodmodeControllerPostReassignInvestorResponses, GodmodeControllerPostRemoveInvestorData, GodmodeControllerPostRemoveInvestorResponses, GodmodeControllerPostRevokeTsaData, GodmodeControllerPostRevokeTsaResponses, GodmodeControllerPostSoftDeleteTsaData, GodmodeControllerPostSoftDeleteTsaResponses, GodmodeControllerRemoveInvestorPersonalDetailsData, GodmodeControllerRemoveInvestorPersonalDetailsResponses, GodmodeControllerReplaceFileData, GodmodeControllerReplaceFileResponses, GodmodeControllerSoftDeleteKycFileData, GodmodeControllerSoftDeleteKycFileResponses, GodmodeControllerSoftDeleteMipData, GodmodeControllerSoftDeleteMipResponses, GodmodeControllerUnArchiveDealAndMipsData, GodmodeControllerUnArchiveDealAndMipsResponses, GodmodeControllerUpdateCustomDetailTypeData, GodmodeControllerUpdateCustomDetailTypeResponses, GodmodeControllerUpdateDealMipsInvestorsDeletedData, GodmodeControllerUpdateDealMipsInvestorsDeletedResponses, GodmodeControllerUpdateInvestorPersonalDetailsData, GodmodeControllerUpdateInvestorPersonalDetailsResponses, GodmodeControllerUpdateIsLockedData, GodmodeControllerUpdateIsLockedResponses, GodmodeControllerUpdateMipKycOptionalData, GodmodeControllerUpdateMipKycOptionalResponses, GodmodeControllerUpdateShareAssociationsData, GodmodeControllerUpdateShareAssociationsResponses, GodmodeControllerUpdateUserEmailData, GodmodeControllerUpdateUserEmailResponses, GodmodeControllerUpdateUserNameData, GodmodeControllerUpdateUserNameResponses, GodmodeControllerUploadPdfFileData, GodmodeControllerUploadPdfFileResponses, HealthControllerHealthCheckData, HealthControllerHealthCheckErrors, HealthControllerHealthCheckResponses, HelpBlogControllerGetArticlesData, HelpBlogControllerGetArticlesResponses, HelpBlogControllerGetAuthorsData, HelpBlogControllerGetAuthorsResponses, HelpBlogControllerGetCategoriesData, HelpBlogControllerGetCategoriesResponses, HelpBlogControllerGetEntrypointArticlesData, HelpBlogControllerGetEntrypointArticlesResponses, HelpBlogControllerGetSlugArticleData, HelpBlogControllerGetSlugArticleResponses, HelpBlogControllerGetSlugAuthorData, HelpBlogControllerGetSlugAuthorResponses, HelpBlogControllerGetSlugCategoryData, HelpBlogControllerGetSlugCategoryResponses, HoldingEventControllerCreateBulkHoldingEventsData, HoldingEventControllerCreateBulkHoldingEventsResponses, HoldingEventControllerCreateHoldingEventData, HoldingEventControllerCreateHoldingEventResponses, HoldingEventControllerSoftDeleteHoldingEventData, HoldingEventControllerSoftDeleteHoldingEventResponses, HoldingEventControllerUpdateHoldingEventData, HoldingEventControllerUpdateHoldingEventResponses, HoldingsControllerDownloadHoldingsExcelData, HoldingsControllerDownloadHoldingsExcelResponses, HoldingsControllerDownloadVestingEventsReportData, HoldingsControllerDownloadVestingEventsReportResponses, HoldingsControllerGenerateShareRegisterPdfData, HoldingsControllerGenerateShareRegisterPdfInlineData, HoldingsControllerGenerateShareRegisterPdfInlineResponses, HoldingsControllerGenerateShareRegisterPdfResponses, HoldingsControllerGetHoldingByPersonAndSecurityData, HoldingsControllerGetHoldingByPersonAndSecurityResponses, HoldingsControllerGetHoldingEventsListByPersonAndSecurityData, HoldingsControllerGetHoldingEventsListByPersonAndSecurityResponses, HoldingsControllerGetShareRegisterPdfTaskStatusData, HoldingsControllerGetShareRegisterPdfTaskStatusResponses, HoldingsControllerPostHoldingsListForPersonData, HoldingsControllerPostHoldingsListForPersonResponses, HoldingsControllerPostRegularViewHoldingsCsvData, HoldingsControllerPostRegularViewHoldingsCsvResponses, HoldingsControllerPostWideViewHoldingsCsvData, HoldingsControllerPostWideViewHoldingsCsvResponses, HoldingsControllerStartShareRegisterPdfGenerationData, HoldingsControllerStartShareRegisterPdfGenerationResponses, InfoControllerDeploymentInfoData, InfoControllerDeploymentInfoResponses, InvestmentControllerGetAllInvestmentValuationsData, InvestmentControllerGetAllInvestmentValuationsResponses, InvestmentControllerGetInvestmentDetailsData, InvestmentControllerGetInvestmentDetailsResponses, InvestmentControllerGetInvestmentPaymentInstructionData, InvestmentControllerGetInvestmentPaymentInstructionResponses, InvestmentControllerGetInvestmentsAndSdwDocumentsData, InvestmentControllerGetInvestmentsAndSdwDocumentsResponses, InvestmentControllerGetInvestmentV2Data, InvestmentControllerGetInvestmentV2Responses, InvestmentControllerGetInvestmentValuationsData, InvestmentControllerGetInvestmentValuationsResponses, InvestmentControllerGetSecurityVestingDataData, InvestmentControllerGetSecurityVestingDataResponses, InvestmentControllerGetUserInvestmentsListData, InvestmentControllerGetUserInvestmentsListResponses, InvestmentControllerSetSelectedBankAccountData, InvestmentControllerSetSelectedBankAccountResponses, InvestorBankAccountControllerGetBankAccountDetailData, InvestorBankAccountControllerGetBankAccountDetailResponses, InvestorBankAccountControllerGetBankAccountHistoryData, InvestorBankAccountControllerGetBankAccountHistoryResponses, InvestorBankAccountControllerGetInvestorBankAccountsData, InvestorBankAccountControllerGetInvestorBankAccountsResponses, InvestorBankAccountControllerReviewData, InvestorBankAccountControllerReviewResponses, InvestorControllerDownloadInvestorsDataData, InvestorControllerDownloadInvestorsDataResponses, InvestorControllerGetInvestmentVehicleHoldingsData, InvestorControllerGetInvestmentVehicleHoldingsResponses, InvestorControllerGetInvestmentVehicleQuickLinksData, InvestorControllerGetInvestmentVehicleQuickLinksResponses, InvestorControllerGetInvestmentVehicleRelatedPeopleData, InvestorControllerGetInvestmentVehicleRelatedPeopleResponses, InvestorControllerGetInvestmentVehicleValuationsData, InvestorControllerGetInvestmentVehicleValuationsResponses, InvestorControllerGetInvestorHoldingsData, InvestorControllerGetInvestorHoldingsResponses, InvestorControllerGetInvestorHoldingTransactionsData, InvestorControllerGetInvestorHoldingTransactionsResponses, InvestorControllerGetInvestorInvestmentsAndTransactionsData, InvestorControllerGetInvestorInvestmentsAndTransactionsResponses, InvestorControllerGetInvestorInvestmentValuationsData, InvestorControllerGetInvestorInvestmentValuationsResponses, InvestorControllerGetInvestorJourneysData, InvestorControllerGetInvestorJourneysResponses, InvestorControllerGetInvestorQuickLinksData, InvestorControllerGetInvestorQuickLinksResponses, InvestorControllerGetMipDraftJoinerInvestorTemplateData, InvestorControllerGetMipDraftJoinerInvestorTemplateResponses, InvestorControllerGetMipDraftLeaverInvestorTemplateData, InvestorControllerGetMipDraftLeaverInvestorTemplateResponses, InvestorControllerGetMipInvestmentVehicleNamesForFilteringData, InvestorControllerGetMipInvestmentVehicleNamesForFilteringResponses, InvestorControllerGetMipInvestorByIdData, InvestorControllerGetMipInvestorByIdResponses, InvestorControllerGetMipInvestorDocumentWorkflowListByIdData, InvestorControllerGetMipInvestorDocumentWorkflowListByIdResponses, InvestorControllerGetMipInvestorNamesForFilteringData, InvestorControllerGetMipInvestorNamesForFilteringResponses, InvestorControllerGetMipInvestorsDataForSendModalData, InvestorControllerGetMipInvestorsDataForSendModalResponses, InvestorControllerGetMipInvestorsIdsData, InvestorControllerGetMipInvestorsIdsResponses, InvestorControllerGetMipInvestorsListData, InvestorControllerGetMipInvestorsListResponses, InvestorControllerGetMipInvestorsOrderedIdsData, InvestorControllerGetMipInvestorsOrderedIdsResponses, InvestorControllerGetMipInvestorsSecuritiesListDataData, InvestorControllerGetMipInvestorsSecuritiesListDataResponses, InvestorControllerGetMipSelectedInvestorsDataData, InvestorControllerGetMipSelectedInvestorsDataResponses, InvestorControllerGetSecurityVestingDataData, InvestorControllerGetSecurityVestingDataResponses, InvestorControllerPostBulkRevokeTsaData, InvestorControllerPostBulkRevokeTsaResponses, InvestorControllerPostMipDraftJLeaverInvestorTemplateData, InvestorControllerPostMipDraftJLeaverInvestorTemplateResponses, InvestorControllerPostMipDraftJoinerInvestorTemplateData, InvestorControllerPostMipDraftJoinerInvestorTemplateResponses, InvestorControllerPostRemoveInvestorData, InvestorControllerPostRemoveInvestorResponses, InvestorControllerPostRevokeTsaData, InvestorControllerPostRevokeTsaResponses, InvestorControllerPutInvestorCustomDetailsData, InvestorControllerPutInvestorCustomDetailsResponses, InvestorControllerRequestKycData, InvestorControllerRequestKycResponses, InvestorControllerSendInvitesData, InvestorControllerSendInvitesResponses, InvestorControllerStartDownloadInvestorsDataWorkflowData, InvestorControllerStartDownloadInvestorsDataWorkflowResponses, InvestorDraftControllerGetMipInvestorsData, InvestorDraftControllerGetMipInvestorsResponses, InvestorDraftControllerPostMipDraftInvestorDataData, InvestorDraftControllerPostMipDraftInvestorDataResponses, InvestorDraftControllerPostMipDraftInvestorTemplateData, InvestorDraftControllerPostMipDraftInvestorTemplateResponses, InvestorInvestmentWorkflowControllerAddInvestmentAllocationData, InvestorInvestmentWorkflowControllerAddInvestmentAllocationResponses, InvestorInvestmentWorkflowControllerAddInvestmentLoanData, InvestorInvestmentWorkflowControllerAddInvestmentLoanResponses, InvestorInvestmentWorkflowControllerApproveInvestmentData, InvestorInvestmentWorkflowControllerApproveInvestmentResponses, InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowData, InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowResponses, InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeData, InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeResponses, InvestorInvestmentWorkflowControllerDownloadExcelData, InvestorInvestmentWorkflowControllerDownloadExcelResponses, InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsResponses, InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationResponses, InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusResponses, InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsResponses, InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataResponses, InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryResponses, InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceResponses, InvestorInvestmentWorkflowControllerGetInvestmentsForMipData, InvestorInvestmentWorkflowControllerGetInvestmentsForMipResponses, InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsData, InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsResponses, InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsData, InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsResponses, InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusData, InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusResponses, InvestorInvestmentWorkflowControllerMakeDraftData, InvestorInvestmentWorkflowControllerMakeDraftResponses, InvestorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflowData, InvestorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflowResponses, InvestorInvestmentWorkflowControllerRemoveInvestmentAllocationData, InvestorInvestmentWorkflowControllerRemoveInvestmentAllocationResponses, InvestorInvestmentWorkflowControllerRemoveInvestmentLoanData, InvestorInvestmentWorkflowControllerRemoveInvestmentLoanResponses, InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountData, InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountResponses, InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivData, InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivResponses, InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesData, InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesResponses, InvestorInvestmentWorkflowControllerStartInvestmentData, InvestorInvestmentWorkflowControllerStartInvestmentResponses, InvestorInvestmentWorkflowControllerToggleLegalDocumentData, InvestorInvestmentWorkflowControllerToggleLegalDocumentResponses, InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationData, InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationResponses, InvestorInvestmentWorkflowControllerUpdateInvestmentLoanData, InvestorInvestmentWorkflowControllerUpdateInvestmentLoanResponses, InvestorInvestmentWorkflowControllerUpsertShareAssociationsData, InvestorInvestmentWorkflowControllerUpsertShareAssociationsResponses, InvestorMessageControllerGetMessageForInvestorData, InvestorMessageControllerGetMessageForInvestorResponses, InvestorMessageControllerGetMessagesForInvestorData, InvestorMessageControllerGetMessagesForInvestorResponses, KycControllerDeleteKycFileData, KycControllerDeleteKycFileResponses, KycControllerDownloadInvestorsFilesData, KycControllerDownloadInvestorsFilesResponses, KycControllerGetInvestorsStatisticsData, KycControllerGetInvestorsStatisticsResponses, KycControllerGetKycInvestorDataData, KycControllerGetKycInvestorDataResponses, KycControllerGetKycInvestorsDataData, KycControllerGetKycInvestorsDataResponses, KycControllerGetKycWorkflowsDataData, KycControllerGetKycWorkflowsDataResponses, KycControllerMorePivDocumentsData, KycControllerMorePivDocumentsResponses, KycControllerPutAssociateKycFileData, KycControllerPutAssociateKycFileResponses, KycControllerResendKycFileCertifierInvitationData, KycControllerResendKycFileCertifierInvitationResponses, KycControllerSetInvestorDeclarationsData, KycControllerSetInvestorDeclarationsResponses, KycControllerUpdateDeclarationsStatusData, KycControllerUpdateDeclarationsStatusResponses, KycControllerUpdateKycFileData, KycControllerUpdateKycFileResponses, KycControllerUpdateKycStatusData, KycControllerUpdateKycStatusResponses, KycControllerWithdrawStandaloneKycWorkflowData, KycControllerWithdrawStandaloneKycWorkflowResponses, KycFormTemplateControllerArchiveData, KycFormTemplateControllerArchiveResponses, KycFormTemplateControllerCreateData, KycFormTemplateControllerCreateResponses, KycFormTemplateControllerDeleteData, KycFormTemplateControllerDeleteResponses, KycFormTemplateControllerDocxDocumentData, KycFormTemplateControllerDocxDocumentResponses, KycFormTemplateControllerFieldBindingCatalogueData, KycFormTemplateControllerFieldBindingCatalogueResponses, KycFormTemplateControllerFieldBindingsData, KycFormTemplateControllerFieldBindingsResponses, KycFormTemplateControllerInstanceCountData, KycFormTemplateControllerInstanceCountResponses, KycFormTemplateControllerListData, KycFormTemplateControllerListLibraryData, KycFormTemplateControllerListLibraryResponses, KycFormTemplateControllerListResponses, KycFormTemplateControllerPreviewFieldBindingsData, KycFormTemplateControllerPreviewFieldBindingsResponses, KycFormTemplateControllerRenderDocxData, KycFormTemplateControllerRenderDocxFieldsData, KycFormTemplateControllerRenderDocxFieldsResponses, KycFormTemplateControllerRenderDocxResponses, KycFormTemplateControllerSaveDocxDocumentData, KycFormTemplateControllerSaveDocxDocumentResponses, KycFormTemplateControllerSignatureSlotsData, KycFormTemplateControllerSignatureSlotsResponses, KycFormTemplateControllerUpdateData, KycFormTemplateControllerUpdateFieldBindingsData, KycFormTemplateControllerUpdateFieldBindingsResponses, KycFormTemplateControllerUpdateResponses, KycFormTemplateControllerUpdateSignaturePlacementData, KycFormTemplateControllerUpdateSignaturePlacementResponses, KycSettingControllerGetByKycWorkflowIdData, KycSettingControllerGetByKycWorkflowIdResponses, KycSettingControllerGetMipRequirementsData, KycSettingControllerGetMipRequirementsResponses, KycSettingControllerUpdateByKycWorkflowIdData, KycSettingControllerUpdateByKycWorkflowIdResponses, KycSettingControllerUpdateMipRequirementsData, KycSettingControllerUpdateMipRequirementsResponses, LoanDefinitionControllerCreateLoanDefinitionsData, LoanDefinitionControllerCreateLoanDefinitionsResponses, LoanDefinitionControllerDeleteLoanDefinitionData, LoanDefinitionControllerDeleteLoanDefinitionResponses, LoanDefinitionControllerGetLoansDefinitionByMipIdData, LoanDefinitionControllerGetLoansDefinitionByMipIdResponses, LoanDefinitionControllerUpdateLoanDefinitionData, LoanDefinitionControllerUpdateLoanDefinitionResponses, MipClassifierControllerAttachInvestorsData, MipClassifierControllerAttachInvestorsResponses, MipClassifierControllerCreateData, MipClassifierControllerCreateResponses, MipClassifierControllerDetachInvestorsData, MipClassifierControllerDetachInvestorsResponses, MipClassifierControllerListByInvestorData, MipClassifierControllerListByInvestorResponses, MipClassifierControllerListData, MipClassifierControllerListResponses, MipClassifierControllerUpdateData, MipClassifierControllerUpdateResponses, MipControllerAddMipProgrammeEntityData, MipControllerAddMipProgrammeEntityResponses, MipControllerDeleteMipProgrammeEntityData, MipControllerDeleteMipProgrammeEntityResponses, MipControllerGetEmailWorkflowStatusData, MipControllerGetEmailWorkflowStatusResponses, MipControllerGetMipDetailsForJoinerData, MipControllerGetMipDetailsForJoinerResponses, MipControllerGetMipDetailsForLeaverData, MipControllerGetMipDetailsForLeaverResponses, MipControllerGetMipProgrammeEntitiesData, MipControllerGetMipProgrammeEntitiesResponses, MipControllerGetMipsForPersonData, MipControllerGetMipsForPersonResponses, MipControllerGetPivDetailsForInvestorsData, MipControllerGetPivDetailsForInvestorsResponses, MipControllerGetWorkflowSettingsData, MipControllerGetWorkflowSettingsResponses, MipControllerListProgrammesData, MipControllerListProgrammesResponses, MipControllerPostJoinerAdditionalAllocationsData, MipControllerPostJoinerAdditionalAllocationsResponses, MipControllerPostLeaverNegativeAllocationsData, MipControllerPostLeaverNegativeAllocationsResponses, MipControllerUpdateMipDataData, MipControllerUpdateMipDataResponses, MipControllerUpdateMipKycRequiredData, MipControllerUpdateMipKycRequiredResponses, MipControllerUpdateWorkflowSettingsData, MipControllerUpdateWorkflowSettingsResponses, MipDraftControllerCompleteData, MipDraftControllerCompleteResponses, MipDraftControllerCreateActiveProgrammeData, MipDraftControllerCreateActiveProgrammeResponses, MipDraftControllerCreateMipData, MipDraftControllerCreateMipResponses, MipDraftControllerGetDraftStepsStatusesData, MipDraftControllerGetDraftStepsStatusesResponses, MipDraftControllerSoftDeleteMipDraftData, MipDraftControllerSoftDeleteMipDraftResponses, MipDraftControllerUpdateDraftGeneralDealInputsData, MipDraftControllerUpdateDraftGeneralDealInputsResponses, OneSchemaControllerCreateOneSchemaPersonsSessionData, OneSchemaControllerCreateOneSchemaPersonsSessionResponses, OneSchemaControllerCreateOneSchemaTransactionsSessionData, OneSchemaControllerCreateOneSchemaTransactionsSessionResponses, OneSchemaControllerPrepareOneSchemaManagementLoansCacheData, OneSchemaControllerPrepareOneSchemaManagementLoansCacheResponses, OneSchemaControllerPrepareOneSchemaShareAssociationsCacheData, OneSchemaControllerPrepareOneSchemaShareAssociationsCacheResponses, OneSchemaControllerValidateOneSchemaLegalPersonsRowsData, OneSchemaControllerValidateOneSchemaLegalPersonsRowsResponses, OneSchemaControllerValidateOneSchemaManagementLoansRowsData, OneSchemaControllerValidateOneSchemaManagementLoansRowsResponses, OneSchemaControllerValidateOneSchemaNaturalPersonsRowsData, OneSchemaControllerValidateOneSchemaNaturalPersonsRowsResponses, OneSchemaControllerValidateOneSchemaShareAssociationRowsData, OneSchemaControllerValidateOneSchemaShareAssociationRowsResponses, OneSchemaControllerValidateOneSchemaTransactionRowsData, OneSchemaControllerValidateOneSchemaTransactionRowsResponses, OrganizationControllerCreateOrganizationData, OrganizationControllerCreateOrganizationResponses, OrganizationControllerDeleteOrganizationData, OrganizationControllerDeleteOrganizationResponses, OrganizationControllerGetAllOrganizationsData, OrganizationControllerGetAllOrganizationsResponses, OrganizationControllerGetOrganizationDetailsByIdData, OrganizationControllerGetOrganizationDetailsByIdResponses, OrganizationControllerImportOrganizationData, OrganizationControllerImportOrganizationResponses, OrganizationControllerLookupWorkOsOrganizationsData, OrganizationControllerLookupWorkOsOrganizationsResponses, OrganizationControllerUpdateOrganizationData, OrganizationControllerUpdateOrganizationResponses, OrganizationControllerUpdateOrganizationTypeData, OrganizationControllerUpdateOrganizationTypeResponses, OrganizationCustomFieldControllerCreateCustomFieldData, OrganizationCustomFieldControllerCreateCustomFieldResponses, OrganizationCustomFieldControllerDeleteCustomFieldData, OrganizationCustomFieldControllerDeleteCustomFieldResponses, OrganizationCustomFieldControllerGetCustomFieldsData, OrganizationCustomFieldControllerGetCustomFieldsResponses, OrganizationCustomFieldControllerUpdateCustomFieldData, OrganizationCustomFieldControllerUpdateCustomFieldResponses, OrganizationDealClassifierControllerListClassifiersData, OrganizationDealClassifierControllerListClassifiersResponses, OrganizationDealClassifierControllerSetClassifiersData, OrganizationDealClassifierControllerSetClassifiersResponses, OrganizationDealEmailTemplateControllerGetOneData, OrganizationDealEmailTemplateControllerGetOneResponses, OrganizationDealEmailTemplateControllerListData, OrganizationDealEmailTemplateControllerListResponses, OrganizationDealEmailTemplateControllerPreviewData, OrganizationDealEmailTemplateControllerPreviewResponses, OrganizationDealEmailTemplateControllerResetData, OrganizationDealEmailTemplateControllerResetResponses, OrganizationDealEmailTemplateControllerUpdateData, OrganizationDealEmailTemplateControllerUpdateResponses, OrganizationDefaultMemberControllerAddMemberData, OrganizationDefaultMemberControllerAddMemberResponses, OrganizationDefaultMemberControllerListMembersData, OrganizationDefaultMemberControllerListMembersResponses, OrganizationDefaultMemberControllerRemoveMemberData, OrganizationDefaultMemberControllerRemoveMemberResponses, OrganizationDocumentTemplateControllerBulkArchiveData, OrganizationDocumentTemplateControllerBulkArchiveResponses, OrganizationDocumentTemplateControllerBulkDeleteData, OrganizationDocumentTemplateControllerBulkDeleteResponses, OrganizationDocumentTemplateControllerCreateData, OrganizationDocumentTemplateControllerCreateResponses, OrganizationDocumentTemplateControllerGetByIdData, OrganizationDocumentTemplateControllerGetByIdResponses, OrganizationDocumentTemplateControllerListData, OrganizationDocumentTemplateControllerListResponses, OrganizationDocumentTemplateControllerRemoveData, OrganizationDocumentTemplateControllerRemoveResponses, OrganizationDocumentTemplateControllerUpdateArchivedData, OrganizationDocumentTemplateControllerUpdateArchivedResponses, OrganizationDocumentTemplateControllerUpdateData, OrganizationDocumentTemplateControllerUpdateResponses, OrganizationEmailScheduleControllerListConfigsData, OrganizationEmailScheduleControllerListConfigsResponses, OrganizationEmailScheduleControllerUpsertConfigData, OrganizationEmailScheduleControllerUpsertConfigResponses, OrganizationEmailTemplateControllerGetOneData, OrganizationEmailTemplateControllerGetOneResponses, OrganizationEmailTemplateControllerListData, OrganizationEmailTemplateControllerListResponses, OrganizationEmailTemplateControllerPreviewData, OrganizationEmailTemplateControllerPreviewResponses, OrganizationEmailTemplateControllerResetData, OrganizationEmailTemplateControllerResetResponses, OrganizationEmailTemplateControllerUpdateData, OrganizationEmailTemplateControllerUpdateResponses, OrganizationFileControllerDownloadPreSignedUrlData, OrganizationFileControllerDownloadPreSignedUrlResponses, OrganizationKycFormTemplateControllerArchiveData, OrganizationKycFormTemplateControllerArchiveResponses, OrganizationKycFormTemplateControllerCreateData, OrganizationKycFormTemplateControllerCreateResponses, OrganizationKycFormTemplateControllerListData, OrganizationKycFormTemplateControllerListResponses, OrganizationKycFormTemplateControllerRemoveData, OrganizationKycFormTemplateControllerRemoveResponses, OrganizationKycFormTemplateControllerSignatureSlotsData, OrganizationKycFormTemplateControllerSignatureSlotsResponses, OrganizationKycFormTemplateControllerUpdateData, OrganizationKycFormTemplateControllerUpdateResponses, OrganizationKycFormTemplateControllerUpdateSignaturePlacementData, OrganizationKycFormTemplateControllerUpdateSignaturePlacementResponses, OrganizationKycSettingControllerGetRequirementsData, OrganizationKycSettingControllerGetRequirementsResponses, OrganizationKycSettingControllerUpdateRequirementsData, OrganizationKycSettingControllerUpdateRequirementsResponses, OrganizationUsersControllerDeleteUserFromOrganizationsData, OrganizationUsersControllerDeleteUserFromOrganizationsResponses, OrganizationUsersControllerGetOrganizationUsersData, OrganizationUsersControllerGetOrganizationUsersResponses, OrganizationUsersControllerGetOrganizationUserWithPermissionsData, OrganizationUsersControllerGetOrganizationUserWithPermissionsResponses, OrganizationUsersControllerInviteUserToOrganizationData, OrganizationUsersControllerInviteUserToOrganizationResponses, OrganizationVestingTermControllerCreateGradedData, OrganizationVestingTermControllerCreateGradedResponses, OrganizationVestingTermControllerCreateLeaverProvisionData, OrganizationVestingTermControllerCreateLeaverProvisionResponses, OrganizationVestingTermControllerCreateStraightLineData, OrganizationVestingTermControllerCreateStraightLineResponses, OrganizationVestingTermControllerCreateVestingTermData, OrganizationVestingTermControllerCreateVestingTermResponses, OrganizationVestingTermControllerDeleteGradedData, OrganizationVestingTermControllerDeleteGradedResponses, OrganizationVestingTermControllerDeleteLeaverProvisionData, OrganizationVestingTermControllerDeleteLeaverProvisionResponses, OrganizationVestingTermControllerDeleteVestingTermData, OrganizationVestingTermControllerDeleteVestingTermResponses, OrganizationVestingTermControllerGetVestingTermsData, OrganizationVestingTermControllerGetVestingTermsResponses, OrganizationVestingTermControllerUpdateGradedData, OrganizationVestingTermControllerUpdateGradedResponses, OrganizationVestingTermControllerUpdateLeaverProvisionData, OrganizationVestingTermControllerUpdateLeaverProvisionResponses, OrganizationVestingTermControllerUpdateStraightLineData, OrganizationVestingTermControllerUpdateStraightLineResponses, OrganizationVestingTermControllerUpdateVestingTermData, OrganizationVestingTermControllerUpdateVestingTermResponses, PasswordControllerUpdatePasswordData, PasswordControllerUpdatePasswordResponses, PaymentControllerBulkUpdateData, PaymentControllerBulkUpdateResponses, PaymentControllerDownloadMipPaymentsData, PaymentControllerDownloadMipPaymentsResponses, PaymentControllerGetStatusData, PaymentControllerGetStatusResponses, PaymentControllerUpdateData, PaymentControllerUpdateResponses, PermissionControllerAddResourcePermissionsForUserData, PermissionControllerAddResourcePermissionsForUserResponses, PermissionControllerRemoveResourcePermissionForUserData, PermissionControllerRemoveResourcePermissionForUserResponses, PermissionControllerSetResourcePermissionsForUserData, PermissionControllerSetResourcePermissionsForUserResponses, PersonBankAccountControllerCreatePersonBankAccountData, PersonBankAccountControllerCreatePersonBankAccountResponses, PersonBankAccountControllerDeletePersonBankAccountData, PersonBankAccountControllerDeletePersonBankAccountResponses, PersonBankAccountControllerGetPersonBankAccountsData, PersonBankAccountControllerGetPersonBankAccountsResponses, PersonBankAccountControllerUpdatePersonBankAccountData, PersonBankAccountControllerUpdatePersonBankAccountResponses, PersonBankAccountControllerValidatePersonBankAccountData, PersonBankAccountControllerValidatePersonBankAccountResponses, PersonControllerAddRelatedPersonByEmailData, PersonControllerAddRelatedPersonByEmailResponses, PersonControllerBulkCreateLegalPersonsData, PersonControllerBulkCreateLegalPersonsResponses, PersonControllerBulkCreateNaturalPersonsData, PersonControllerBulkCreateNaturalPersonsResponses, PersonControllerCreateAddressData, PersonControllerCreateAddressResponses, PersonControllerCreateLegalEntityData, PersonControllerCreateLegalEntityResponses, PersonControllerCreateNaturalEntityData, PersonControllerCreateNaturalEntityResponses, PersonControllerCreateRelatedPeopleForPersonData, PersonControllerCreateRelatedPeopleForPersonResponses, PersonControllerDeleteAddressData, PersonControllerDeleteAddressResponses, PersonControllerDeleteEntitiesData, PersonControllerDeleteEntitiesResponses, PersonControllerDeletePersonRelatedPersonData, PersonControllerDeletePersonRelatedPersonResponses, PersonControllerGetAllEntitiesData, PersonControllerGetAllEntitiesResponses, PersonControllerGetAllLegalEntitiesData, PersonControllerGetAllLegalEntitiesResponses, PersonControllerGetAvailableRelatedPeopleForPersonData, PersonControllerGetAvailableRelatedPeopleForPersonResponses, PersonControllerGetEntityDataData, PersonControllerGetEntityDataResponses, PersonControllerGetNaturalPersonsByPivIdData, PersonControllerGetNaturalPersonsByPivIdResponses, PersonControllerGetPersonRelatedPeopleData, PersonControllerGetPersonRelatedPeopleResponses, PersonControllerGetPersonsForCapData, PersonControllerGetPersonsForCapResponses, PersonControllerGetPersonTagsForDealData, PersonControllerGetPersonTagsForDealResponses, PersonControllerIsPersonUserInvitedToPlatformData, PersonControllerIsPersonUserInvitedToPlatformResponses, PersonControllerIsThereInvestmentWorkflowData, PersonControllerIsThereInvestmentWorkflowResponses, PersonControllerLookupPersonByEmailData, PersonControllerLookupPersonByEmailResponses, PersonControllerUpdateAddressData, PersonControllerUpdateAddressResponses, PersonControllerUpdateLegalPersonDetailsData, PersonControllerUpdateLegalPersonDetailsResponses, PersonControllerUpdateNaturalPersonDetailsData, PersonControllerUpdateNaturalPersonDetailsResponses, PersonControllerUpdateNaturalPersonEmailData, PersonControllerUpdateNaturalPersonEmailResponses, PersonControllerUpdateRelatedPersonRelationData, PersonControllerUpdateRelatedPersonRelationResponses, PersonEmploymentControllerGetPersonEmploymentData, PersonEmploymentControllerGetPersonEmploymentResponses, PersonEmploymentControllerUpsertPersonEmploymentData, PersonEmploymentControllerUpsertPersonEmploymentResponses, PersonEmploymentRecordControllerCreateEmploymentRecordData, PersonEmploymentRecordControllerCreateEmploymentRecordResponses, PersonEmploymentRecordControllerListEmploymentRecordsData, PersonEmploymentRecordControllerListEmploymentRecordsResponses, PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipData, PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipResponses, PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonData, PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonResponses, PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonData, PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonResponses, PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipData, PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipResponses, PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestData, PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestResponses, PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestData, PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestResponses, PersonTaxControllerCreatePersonTaxInformationData, PersonTaxControllerCreatePersonTaxInformationResponses, PersonTaxControllerDeletePersonTaxInformationData, PersonTaxControllerDeletePersonTaxInformationResponses, PersonTaxControllerGetPersonTaxInformationData, PersonTaxControllerGetPersonTaxInformationResponses, PersonTaxControllerUpdatePersonTaxInformationData, PersonTaxControllerUpdatePersonTaxInformationResponses, PreFillableFormsControllerGetTemplatesForProjectData, PreFillableFormsControllerGetTemplatesForProjectResponses, PreFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplateData, PreFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplateResponses, PreFillableFormTemplateControllerCreatePreFillableFormTemplateData, PreFillableFormTemplateControllerCreatePreFillableFormTemplateResponses, PreFillableFormTemplateControllerDeleteCustomDetailsDefinitionsData, PreFillableFormTemplateControllerDeleteCustomDetailsDefinitionsResponses, PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesData, PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesResponses, PreFillableFormTemplateControllerGetOrganizationOptionsData, PreFillableFormTemplateControllerGetOrganizationOptionsResponses, PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsData, PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsResponses, PreFillableFormTemplateControllerGetPreFillableFormTemplateData, PreFillableFormTemplateControllerGetPreFillableFormTemplateResponses, PreFillableFormTemplateControllerSoftDeletePreFillableFormTemplateData, PreFillableFormTemplateControllerSoftDeletePreFillableFormTemplateResponses, PreFillableFormTemplateControllerUpdateCustomDetailsDefinitionsData, PreFillableFormTemplateControllerUpdateCustomDetailsDefinitionsResponses, PreFillableFormTemplateControllerUpdatePreFillableFormTemplateData, PreFillableFormTemplateControllerUpdatePreFillableFormTemplateResponses, PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileData, PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileResponses, ProfileControllerUpdatePhoneData, ProfileControllerUpdatePhoneResponses, ProgrammeDefaultsSummaryControllerApplyData, ProgrammeDefaultsSummaryControllerApplyResponses, ProgrammeDefaultsSummaryControllerGetMySummaryData, ProgrammeDefaultsSummaryControllerGetMySummaryResponses, ProgrammeDefaultsSummaryControllerGetSummaryData, ProgrammeDefaultsSummaryControllerGetSummaryForDealData, ProgrammeDefaultsSummaryControllerGetSummaryForDealResponses, ProgrammeDefaultsSummaryControllerGetSummaryResponses, ProgrammeEmailTemplateControllerGetOneData, ProgrammeEmailTemplateControllerGetOneResponses, ProgrammeEmailTemplateControllerListData, ProgrammeEmailTemplateControllerListResponses, ProgrammeEmailTemplateControllerPreviewData, ProgrammeEmailTemplateControllerPreviewResponses, ProgrammeEmailTemplateControllerResetData, ProgrammeEmailTemplateControllerResetResponses, ProgrammeEmailTemplateControllerTestSendData, ProgrammeEmailTemplateControllerTestSendResponses, ProgrammeEmailTemplateControllerUpdateData, ProgrammeEmailTemplateControllerUpdateResponses, ProgrammeSecurityAllocationsControllerCreateAllocationData, ProgrammeSecurityAllocationsControllerCreateAllocationResponses, ProgrammeSecurityAllocationsControllerDeleteAllocationData, ProgrammeSecurityAllocationsControllerDeleteAllocationResponses, ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdData, ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdResponses, ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdData, ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdResponses, ProgrammeSecurityAllocationsControllerUpdateAllocationData, ProgrammeSecurityAllocationsControllerUpdateAllocationResponses, ProgrammeSettingControllerGetByMipIdData, ProgrammeSettingControllerGetByMipIdResponses, ProgrammeSettingControllerUpdateByMipIdData, ProgrammeSettingControllerUpdateByMipIdResponses, ProgrammeUsersControllerDeleteUserFromProgrammeData, ProgrammeUsersControllerDeleteUserFromProgrammeResponses, ProgrammeUsersControllerGetProgrammeUserData, ProgrammeUsersControllerGetProgrammeUserResponses, ProgrammeUsersControllerGetProgrammeUsersData, ProgrammeUsersControllerGetProgrammeUsersResponses, ProgrammeUsersControllerInviteUserToProgrammeData, ProgrammeUsersControllerInviteUserToProgrammeResponses, ProgrammeUsersControllerUpdateUserAndUserProgrammeData, ProgrammeUsersControllerUpdateUserAndUserProgrammeResponses, PublicBulkSigningControllerBulkCompleteData, PublicBulkSigningControllerBulkCompleteResponses, PublicBulkSigningControllerBulkPrepareData, PublicBulkSigningControllerBulkPrepareResponses, PublicBulkSigningControllerBulkSignCompleteData, PublicBulkSigningControllerBulkSignCompleteResponses, PublicBulkSigningControllerBulkSignInitiateData, PublicBulkSigningControllerBulkSignInitiateResponses, PublicBulkSigningControllerBulkSignStatusData, PublicBulkSigningControllerBulkSignStatusResponses, PublicBulkSigningControllerGetProgrammeDocumentData, PublicBulkSigningControllerGetProgrammeDocumentResponses, PublicBulkSigningControllerGetProgrammeDocumentsData, PublicBulkSigningControllerGetProgrammeDocumentsResponses, PublicBulkSigningControllerGetSignatureTokenData, PublicBulkSigningControllerGetSignatureTokenResponses, PublicCertificationControllerSaveCertifierDetailsData, PublicCertificationControllerSaveCertifierDetailsResponses, PublicCertificationControllerUpdateCertificationTextData, PublicCertificationControllerUpdateCertificationTextResponses, PublicSigningControllerCompleteData, PublicSigningControllerCompleteResponses, PublicSigningControllerGetDocumentData, PublicSigningControllerGetDocumentResponses, PublicSigningControllerGetSigningInfoData, PublicSigningControllerGetSigningInfoResponses, PublicSigningControllerInviteWitnessData, PublicSigningControllerInviteWitnessResponses, PublicSigningControllerPrepareData, PublicSigningControllerPrepareResponses, PublicSigningControllerSaveWitnessDetailsData, PublicSigningControllerSaveWitnessDetailsResponses, ResendControllerEmailEventData, ResendControllerEmailEventResponses, SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsData, SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsResponses, SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsData, SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsResponses, SecurityControllerBulkCreateSecuritiesData, SecurityControllerBulkCreateSecuritiesResponses, SecurityControllerBulkDeleteTrackedSecuritiesData, SecurityControllerBulkDeleteTrackedSecuritiesResponses, SecurityControllerBulkSoftDeleteSecuritiesData, SecurityControllerBulkSoftDeleteSecuritiesResponses, SecurityControllerBulkUpdateSecuritiesData, SecurityControllerBulkUpdateSecuritiesResponses, SecurityControllerBulkUpdateTrackedSecuritiesData, SecurityControllerBulkUpdateTrackedSecuritiesResponses, SecurityControllerCreateSecurityData, SecurityControllerCreateSecurityResponses, SecurityControllerDoesPersonHaveSecuritiesData, SecurityControllerDoesPersonHaveSecuritiesResponses, SecurityControllerDownloadExcelData, SecurityControllerDownloadExcelResponses, SecurityControllerGetLoanDefinitionsForDealData, SecurityControllerGetLoanDefinitionsForDealResponses, SecurityControllerGetPersonSecuritiesData, SecurityControllerGetPersonSecuritiesResponses, SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksData, SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksResponses, SecurityControllerGetSecuritiesByDealIdData, SecurityControllerGetSecuritiesByDealIdResponses, SecurityControllerGetSecuritiesDataForMipData, SecurityControllerGetSecuritiesDataForMipResponses, SecurityControllerGetSecurityData, SecurityControllerGetSecurityNominalValueData, SecurityControllerGetSecurityNominalValueResponses, SecurityControllerGetSecurityResponses, SecurityControllerIsSecuritiesUsedInAnyMipData, SecurityControllerIsSecuritiesUsedInAnyMipResponses, SecurityControllerSoftDeleteSecurityData, SecurityControllerSoftDeleteSecurityResponses, SecurityControllerUpdateCurrencyForPersonSecuritiesData, SecurityControllerUpdateCurrencyForPersonSecuritiesResponses, SecurityControllerUpdateSecurityAuthorisedCapitalData, SecurityControllerUpdateSecurityAuthorisedCapitalResponses, SecurityControllerUpdateSecurityData, SecurityControllerUpdateSecurityParticipationThresholdData, SecurityControllerUpdateSecurityParticipationThresholdResponses, SecurityControllerUpdateSecurityResponses, SecurityEventControllerCreateSecurityEventData, SecurityEventControllerCreateSecurityEventResponses, SecurityEventControllerGetSecurityEventsData, SecurityEventControllerGetSecurityEventsResponses, SecurityEventControllerSoftDeleteSecurityEventData, SecurityEventControllerSoftDeleteSecurityEventResponses, SecurityEventControllerUpdateSecurityEventData, SecurityEventControllerUpdateSecurityEventResponses, SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsData, SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsResponses, SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsData, SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsResponses, SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionData, SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionResponses, SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsData, SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsResponses, SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionData, SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionResponses, SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsData, SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsResponses, SecurityLiquidationPreferenceControllerCreateOrUpdateData, SecurityLiquidationPreferenceControllerCreateOrUpdateResponses, SecurityLiquidationPreferenceControllerGetData, SecurityLiquidationPreferenceControllerGetResponses, SecurityLiquidationPreferenceControllerSoftDeleteData, SecurityLiquidationPreferenceControllerSoftDeleteResponses, SecurityRankControllerDeleteSecurityIncomeRanksData, SecurityRankControllerDeleteSecurityIncomeRanksResponses, SecurityRankControllerDeleteSecurityRankData, SecurityRankControllerDeleteSecurityRankResponses, SecurityRankControllerUpsertSecurityIncomeRanksData, SecurityRankControllerUpsertSecurityIncomeRanksResponses, SecurityRankControllerUpsertSecurityRankData, SecurityRankControllerUpsertSecurityRankResponses, SecurityRankDefinitionControllerCreateRankData, SecurityRankDefinitionControllerCreateRankResponses, SecurityRankDefinitionControllerGetPersonRanksData, SecurityRankDefinitionControllerGetPersonRanksResponses, SecurityRankDefinitionControllerSoftDeleteRankData, SecurityRankDefinitionControllerSoftDeleteRankResponses, SecurityRankDefinitionControllerUpdateRankData, SecurityRankDefinitionControllerUpdateRankResponses, SecurityRatchetControllerDeleteScheduleData, SecurityRatchetControllerDeleteScheduleResponses, SecurityRatchetControllerGetScheduleData, SecurityRatchetControllerGetScheduleResponses, SecurityRatchetControllerUpsertScheduleData, SecurityRatchetControllerUpsertScheduleResponses, SecurityValueOverrideControllerCreateSecurityValueOverrideData, SecurityValueOverrideControllerCreateSecurityValueOverrideResponses, SecurityValueOverrideControllerDeleteSecurityValueOverrideData, SecurityValueOverrideControllerDeleteSecurityValueOverrideResponses, SecurityValueOverrideControllerUpdateSecurityValueOverrideData, SecurityValueOverrideControllerUpdateSecurityValueOverrideResponses, SessionManagementControllerGetSessionStatusData, SessionManagementControllerGetSessionStatusResponses, SessionManagementControllerKeepSessionAliveData, SessionManagementControllerKeepSessionAliveResponses, SessionManagementControllerLogoutData, SessionManagementControllerLogoutResponses, SessionManagementControllerRedirectCallbackFromWorkOsData, SessionManagementControllerRedirectCallbackFromWorkOsResponses, SessionManagementControllerRefreshTokenData, SessionManagementControllerRefreshTokenResponses, SessionManagementControllerSendMagicAuthVerificationCodeData, SessionManagementControllerSendMagicAuthVerificationCodeResponses, SessionManagementControllerSignOutData, SessionManagementControllerSignOutResponses, SessionManagementControllerValidateMagicCodeData, SessionManagementControllerValidateMagicCodeResponses, ShareholderBankAccountControllerConfirmBankAccountData, ShareholderBankAccountControllerConfirmBankAccountResponses, ShareholderBankAccountControllerDeleteBankAccountData, ShareholderBankAccountControllerDeleteBankAccountResponses, ShareholderBankAccountControllerGetUserBankAccountData, ShareholderBankAccountControllerGetUserBankAccountResponses, ShareholderBankAccountControllerRequestBankAccountCodeData, ShareholderBankAccountControllerRequestBankAccountCodeResponses, ShareholderBankAccountControllerUpsertBankAccountData, ShareholderBankAccountControllerUpsertBankAccountResponses, ShareholderBankAccountControllerValidateBankAccountData, ShareholderBankAccountControllerValidateBankAccountResponses, ShareholderContractControllerGeneratePrefillableFormFileData, ShareholderContractControllerGeneratePrefillableFormFileResponses, ShareholderContractControllerGenerateSignableDocumentsData, ShareholderContractControllerGenerateSignableDocumentsResponses, ShareholderContractControllerGetListOfActionableDocumentsData, ShareholderContractControllerGetListOfActionableDocumentsResponses, ShareholderContractControllerReviewDocumentData, ShareholderContractControllerReviewDocumentResponses, ShareholderContractControllerStreamSignableDocumentsData, ShareholderContractControllerStreamSignableDocumentsResponses, ShareholderCustomDetailControllerGetShareholderCustomDetailDataData, ShareholderCustomDetailControllerGetShareholderCustomDetailDataResponses, ShareholderCustomDetailControllerUpdateShareholderInvestorDataData, ShareholderCustomDetailControllerUpdateShareholderInvestorDataResponses, ShareholderInvestorControllerGetInvestmentTransactionsData, ShareholderInvestorControllerGetInvestmentTransactionsResponses, ShareholderInvestorControllerGetInvestorDealDocumentsData, ShareholderInvestorControllerGetInvestorDealDocumentsResponses, ShareholderInvestorControllerGetInvestorDocumentsData, ShareholderInvestorControllerGetInvestorDocumentsResponses, ShareholderInvestorControllerGetInvestorRepresentativeData, ShareholderInvestorControllerGetInvestorRepresentativeResponses, ShareholderInvestorControllerGetShareholderInvestorDataByUserIdData, ShareholderInvestorControllerGetShareholderInvestorDataByUserIdResponses, ShareholderInvestorControllerGetShareholderInvestorDataData, ShareholderInvestorControllerGetShareholderInvestorDataResponses, ShareholderInvestorControllerUpdateShareholderInvestorCompletedStepsDataData, ShareholderInvestorControllerUpdateShareholderInvestorCompletedStepsDataResponses, ShareholderInvestorControllerUpdateShareholderInvestorDataData, ShareholderInvestorControllerUpdateShareholderInvestorDataResponses, ShareholderInvestorControllerUpdateShareholderInvestorVehicleDataData, ShareholderInvestorControllerUpdateShareholderInvestorVehicleDataResponses, ShareholderKycControllerAddFilledKycFormData, ShareholderKycControllerAddFilledKycFormResponses, ShareholderKycControllerChangeKycFileCertificationData, ShareholderKycControllerChangeKycFileCertificationResponses, ShareholderKycControllerConfirmDeclarationData, ShareholderKycControllerConfirmDeclarationResponses, ShareholderKycControllerConfirmInvestorFormData, ShareholderKycControllerConfirmInvestorFormResponses, ShareholderKycControllerConfirmKycFileData, ShareholderKycControllerConfirmKycFileResponses, ShareholderKycControllerDeleteKycFileData, ShareholderKycControllerDeleteKycFileResponses, ShareholderKycControllerDownloadPreFilledKycFormFileData, ShareholderKycControllerDownloadPreFilledKycFormFileResponses, ShareholderKycControllerGetDeclarationsData, ShareholderKycControllerGetDeclarationsResponses, ShareholderKycControllerGetInvestmentVehicleKycFilesData, ShareholderKycControllerGetInvestmentVehicleKycFilesResponses, ShareholderKycControllerGetInvestorKycFormsData, ShareholderKycControllerGetInvestorKycFormsResponses, ShareholderKycControllerGetProofOfAddressData, ShareholderKycControllerGetProofOfAddressResponses, ShareholderKycControllerGetProofOfIdentityData, ShareholderKycControllerGetProofOfIdentityResponses, ShareholderKycControllerGetStandaloneKycMetadataData, ShareholderKycControllerGetStandaloneKycMetadataResponses, ShareholderKycControllerPatchDeclarationsData, ShareholderKycControllerPatchDeclarationsResponses, ShareholderKycControllerPostInvestmentVehicleData, ShareholderKycControllerPostInvestmentVehicleResponses, ShareholderKycControllerPreFillInvestorKycFormData, ShareholderKycControllerPreFillInvestorKycFormResponses, ShareholderKycControllerPutProofOfAddressData, ShareholderKycControllerPutProofOfAddressResponses, ShareholderKycControllerPutProofOfIdentityData, ShareholderKycControllerPutProofOfIdentityResponses, ShareholderKycControllerRemoveInvestorFormData, ShareholderKycControllerRemoveInvestorFormResponses, ShareholderKycControllerResendKycFileCertifierInvitationData, ShareholderKycControllerResendKycFileCertifierInvitationResponses, ShareholderKycControllerResetInheritedData, ShareholderKycControllerResetInheritedResponses, ShareholderKycControllerSetOffMorePivDocumentsData, ShareholderKycControllerSetOffMorePivDocumentsResponses, SimpleDocumentWorkflowControllerAddFileToMipData, SimpleDocumentWorkflowControllerAddFileToMipResponses, SimpleDocumentWorkflowControllerCreateDocumentsData, SimpleDocumentWorkflowControllerCreateDocumentsResponses, SimpleDocumentWorkflowControllerGetInvestorsFilteringDataData, SimpleDocumentWorkflowControllerGetInvestorsFilteringDataResponses, SimpleDocumentWorkflowControllerRemoveDocumentFileData, SimpleDocumentWorkflowControllerRemoveDocumentFileResponses, SimpleDocumentWorkflowControllerSendMasterDocumentsData, SimpleDocumentWorkflowControllerSendMasterDocumentsResponses, TagControllerAttachClassifiersData, TagControllerAttachClassifiersResponses, TagControllerCreateData, TagControllerCreateResponses, TagControllerDetachClassifiersData, TagControllerDetachClassifiersResponses, TagControllerListData, TagControllerListResponses, TagControllerRemoveData, TagControllerRemoveResponses, TagControllerUpdateData, TagControllerUpdateResponses, TaskControllerGetData, TaskControllerGetResponses, TransactionControllerAutoReorderData, TransactionControllerAutoReorderResponses, TransactionControllerBulkDeleteTransactionsData, TransactionControllerBulkDeleteTransactionsResponses, TransactionControllerBulkRestoreData, TransactionControllerBulkRestoreResponses, TransactionControllerBulkUpdateData, TransactionControllerBulkUpdateResponses, TransactionControllerBulkUploadData, TransactionControllerBulkUploadManagementLoansData, TransactionControllerBulkUploadManagementLoansResponses, TransactionControllerBulkUploadResponses, TransactionControllerCreateInseparableRedemptionData, TransactionControllerCreateInseparableRedemptionResponses, TransactionControllerCreatePairedIssueData, TransactionControllerCreatePairedIssueResponses, TransactionControllerCreateTransactionData, TransactionControllerCreateTransactionResponses, TransactionControllerDeleteTransactionData, TransactionControllerDeleteTransactionResponses, TransactionControllerDownloadExcelData, TransactionControllerDownloadExcelResponses, TransactionControllerGetBulkUploadTaskStatusData, TransactionControllerGetBulkUploadTaskStatusResponses, TransactionControllerGetInseparableRedemptionGroupData, TransactionControllerGetInseparableRedemptionGroupResponses, TransactionControllerGetPairTransactionData, TransactionControllerGetPairTransactionResponses, TransactionControllerGetTransactionDetailsData, TransactionControllerGetTransactionDetailsResponses, TransactionControllerGetTransactionsData, TransactionControllerGetTransactionsResponses, TransactionControllerPairTransactionData, TransactionControllerPairTransactionResponses, TransactionControllerPreviewInseparableRedemptionData, TransactionControllerPreviewInseparableRedemptionResponses, TransactionControllerPreviewTransferCounterpartData, TransactionControllerPreviewTransferCounterpartResponses, TransactionControllerRestoreData, TransactionControllerRestoreResponses, TransactionControllerSplitTransactionData, TransactionControllerSplitTransactionInterestData, TransactionControllerSplitTransactionInterestResponses, TransactionControllerSplitTransactionResponses, TransactionControllerUpdateData, TransactionControllerUpdateInseparableRedemptionData, TransactionControllerUpdateInseparableRedemptionResponses, TransactionControllerUpdateOrderData, TransactionControllerUpdateOrderResponses, TransactionControllerUpdateResponses, TranslationsControllerTranslationsData, TranslationsControllerTranslationsResponses, TwoFaControllerDeleteAuthFactorData, TwoFaControllerDeleteAuthFactorResponses, TwoFaControllerSetup2FaData, TwoFaControllerSetup2FaResponses, TwoFaControllerVerifyChallenge2FaData, TwoFaControllerVerifyChallenge2FaResponses, UserControllerDeleteUserSignatureData, UserControllerDeleteUserSignatureResponses, UserControllerGetAllInvestorsData, UserControllerGetAllInvestorsResponses, UserControllerGetCurrentUserDataData, UserControllerGetCurrentUserDataResponses, UserControllerGetUserOrganizationData, UserControllerGetUserOrganizationResponses, UserControllerGetUserPersonsData, UserControllerGetUserPersonsResponses, UserControllerGetUserProfileData, UserControllerGetUserProfileResponses, UserControllerGetUserSignatureData, UserControllerGetUserSignatureResponses, UserControllerUpdatePersonalDetailsData, UserControllerUpdatePersonalDetailsResponses, UserControllerUpdateShareholderInvestorVehicleDataWithoutMipData, UserControllerUpdateShareholderInvestorVehicleDataWithoutMipResponses, UserControllerUpdateUserLegalRepresentativeWithoutMipData, UserControllerUpdateUserLegalRepresentativeWithoutMipResponses, UserControllerUpdateUserSignatureData, UserControllerUpdateUserSignatureResponses, ValidationControllerValidateTinData, ValidationControllerValidateTinResponses, ValidationControllerVerifyBankIdentifiersData, ValidationControllerVerifyBankIdentifiersResponses, ValuationControllerCreateValuationData, ValuationControllerCreateValuationResponses, ValuationControllerDeleteValuationData, ValuationControllerDeleteValuationResponses, ValuationControllerDuplicateValuationData, ValuationControllerDuplicateValuationResponses, ValuationControllerGetValuationsAndJoinWithClassifiersData, ValuationControllerGetValuationsAndJoinWithClassifiersResponses, ValuationControllerUpdateValuationWithClassifiersData, ValuationControllerUpdateValuationWithClassifiersResponses, ValuationControllerUpsertValuationData, ValuationControllerUpsertValuationResponses, ValuationInputControllerCreateValuationInputAdjustmentData, ValuationInputControllerCreateValuationInputAdjustmentResponses, ValuationInputControllerDeleteValuationInputAdjustmentData, ValuationInputControllerDeleteValuationInputAdjustmentResponses, ValuationInputControllerGetValuationInputsData, ValuationInputControllerGetValuationInputsResponses, ValuationInputControllerUpdateValuationInputAdjustmentData, ValuationInputControllerUpdateValuationInputAdjustmentResponses, ValuationInputControllerUpdateValuationInputData, ValuationInputControllerUpdateValuationInputResponses, ValuationInputControllerUpsertData, ValuationInputControllerUpsertResponses, ValuationPersonInputControllerCreateValuationPersonInputData, ValuationPersonInputControllerCreateValuationPersonInputResponses, ValuationPersonInputControllerDeleteValuationPersonInputData, ValuationPersonInputControllerDeleteValuationPersonInputResponses, ValuationPersonInputControllerGetValuationPersonInputsData, ValuationPersonInputControllerGetValuationPersonInputsResponses, ValuationPersonInputControllerUpdateValuationPersonInputData, ValuationPersonInputControllerUpdateValuationPersonInputResponses, ValuationPersonInputControllerUpsertValuationPersonInputsData, ValuationPersonInputControllerUpsertValuationPersonInputsResponses, ValuationSummaryControllerDownloadExcelData, ValuationSummaryControllerDownloadExcelResponses, ValuationSummaryControllerDownloadInterestEventsExcelData, ValuationSummaryControllerDownloadInterestEventsExcelResponses, ValuationSummaryControllerGetValuationBreakpointSummaryData, ValuationSummaryControllerGetValuationBreakpointSummaryResponses, ValuationSummaryControllerGetValuationSummaryResultData, ValuationSummaryControllerGetValuationSummaryResultResponses, ValuationSummaryControllerStartCalculateValuationData, ValuationSummaryControllerStartCalculateValuationResponses, ValuationSummaryControllerStreamCalculateValuationData, ValuationSummaryControllerStreamCalculateValuationResponses, VestingControllerApplyVestingStartDateToInvestmentWorkflowData, VestingControllerApplyVestingStartDateToInvestmentWorkflowResponses, VestingControllerApplyVestingStartDateToTransactionData, VestingControllerApplyVestingStartDateToTransactionResponses, VestingControllerApplyVestingTermToInvestmentWorkflowData, VestingControllerApplyVestingTermToInvestmentWorkflowResponses, VestingControllerApplyVestingTermToTransactionData, VestingControllerApplyVestingTermToTransactionResponses, VestingControllerBulkUpdateInvestorsVestingData, VestingControllerBulkUpdateInvestorsVestingResponses, VestingControllerCreateVestingTermData, VestingControllerCreateVestingTermGradedData, VestingControllerCreateVestingTermGradedResponses, VestingControllerCreateVestingTermLeaverProvisionData, VestingControllerCreateVestingTermLeaverProvisionResponses, VestingControllerCreateVestingTermResponses, VestingControllerCreateVestingTermStraightLineData, VestingControllerCreateVestingTermStraightLineResponses, VestingControllerDeletePerformanceVestingData, VestingControllerDeletePerformanceVestingResponses, VestingControllerDeleteVestingTermData, VestingControllerDeleteVestingTermGradedData, VestingControllerDeleteVestingTermGradedResponses, VestingControllerDeleteVestingTermLeaverProvisionData, VestingControllerDeleteVestingTermLeaverProvisionResponses, VestingControllerDeleteVestingTermResponses, VestingControllerDeleteVestingTermStraightLineData, VestingControllerDeleteVestingTermStraightLineResponses, VestingControllerGetSimplifiedVestingTermsData, VestingControllerGetSimplifiedVestingTermsResponses, VestingControllerGetVestingTermsData, VestingControllerGetVestingTermsResponses, VestingControllerRemoveVestingTermFromInvestmentWorkflowData, VestingControllerRemoveVestingTermFromInvestmentWorkflowResponses, VestingControllerRemoveVestingTermFromTransactionData, VestingControllerRemoveVestingTermFromTransactionResponses, VestingControllerSaveTransactionVestingData, VestingControllerSaveTransactionVestingResponses, VestingControllerUpdateVestingTermData, VestingControllerUpdateVestingTermGradedData, VestingControllerUpdateVestingTermGradedResponses, VestingControllerUpdateVestingTermLeaverProvisionData, VestingControllerUpdateVestingTermLeaverProvisionResponses, VestingControllerUpdateVestingTermResponses, VestingControllerUpdateVestingTermStraightLineData, VestingControllerUpdateVestingTermStraightLineResponses, VestingControllerUpsertPerformanceVestingData, VestingControllerUpsertPerformanceVestingResponses, WorkOsEventsAdminControllerListWorkOsEventsData, WorkOsEventsAdminControllerListWorkOsEventsResponses, WorkOsEventsAdminControllerReplayWorkOsEventData, WorkOsEventsAdminControllerReplayWorkOsEventResponses, WorkOsWebhookControllerWebhookData, WorkOsWebhookControllerWebhookResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Fetch current user data
 */
export const userControllerGetCurrentUserData = <ThrowOnError extends boolean = false>(options?: Options<UserControllerGetCurrentUserDataData, ThrowOnError>) => (options?.client ?? client).get<UserControllerGetCurrentUserDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/user',
    ...options
});

/**
 * Fetch the id of the organization the current user belongs to
 */
export const userControllerGetUserOrganization = <ThrowOnError extends boolean = false>(options?: Options<UserControllerGetUserOrganizationData, ThrowOnError>) => (options?.client ?? client).get<UserControllerGetUserOrganizationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/user/organization',
    ...options
});

/**
 * Fetch user profile
 */
export const userControllerGetUserProfile = <ThrowOnError extends boolean = false>(options?: Options<UserControllerGetUserProfileData, ThrowOnError>) => (options?.client ?? client).get<UserControllerGetUserProfileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/user/profile',
    ...options
});

/**
 * Fetch user persons data
 */
export const userControllerGetUserPersons = <ThrowOnError extends boolean = false>(options?: Options<UserControllerGetUserPersonsData, ThrowOnError>) => (options?.client ?? client).get<UserControllerGetUserPersonsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/user/persons',
    ...options
});

/**
 * Update user personal details
 */
export const userControllerUpdatePersonalDetails = <ThrowOnError extends boolean = false>(options: Options<UserControllerUpdatePersonalDetailsData, ThrowOnError>) => (options.client ?? client).put<UserControllerUpdatePersonalDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/user/personal-details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-delete the current user signature (idempotent)
 */
export const userControllerDeleteUserSignature = <ThrowOnError extends boolean = false>(options?: Options<UserControllerDeleteUserSignatureData, ThrowOnError>) => (options?.client ?? client).delete<UserControllerDeleteUserSignatureResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/user/signature',
    ...options
});

/**
 * Get the current user signature image (signed URL) or null
 */
export const userControllerGetUserSignature = <ThrowOnError extends boolean = false>(options?: Options<UserControllerGetUserSignatureData, ThrowOnError>) => (options?.client ?? client).get<UserControllerGetUserSignatureResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/user/signature',
    ...options
});

/**
 * Set or replace the current user signature image
 */
export const userControllerUpdateUserSignature = <ThrowOnError extends boolean = false>(options: Options<UserControllerUpdateUserSignatureData, ThrowOnError>) => (options.client ?? client).put<UserControllerUpdateUserSignatureResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/user/signature',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update user vehicle data without mipId
 */
export const userControllerUpdateShareholderInvestorVehicleDataWithoutMip = <ThrowOnError extends boolean = false>(options: Options<UserControllerUpdateShareholderInvestorVehicleDataWithoutMipData, ThrowOnError>) => (options.client ?? client).put<UserControllerUpdateShareholderInvestorVehicleDataWithoutMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/user/vehicle-data-without-mip-id',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update user legal representative without mipId
 */
export const userControllerUpdateUserLegalRepresentativeWithoutMip = <ThrowOnError extends boolean = false>(options: Options<UserControllerUpdateUserLegalRepresentativeWithoutMipData, ThrowOnError>) => (options.client ?? client).put<UserControllerUpdateUserLegalRepresentativeWithoutMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/user/legal-representative-without-mip-id',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all users
 */
export const userControllerGetAllInvestors = <ThrowOnError extends boolean = false>(options: Options<UserControllerGetAllInvestorsData, ThrowOnError>) => (options.client ?? client).get<UserControllerGetAllInvestorsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/user/all',
    ...options
});

/**
 * Get Shareholder investor data
 */
export const shareholderInvestorControllerGetShareholderInvestorData = <ThrowOnError extends boolean = false>(options: Options<ShareholderInvestorControllerGetShareholderInvestorDataData, ThrowOnError>) => (options.client ?? client).get<ShareholderInvestorControllerGetShareholderInvestorDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investor',
    ...options
});

/**
 * Update investor data during first step of investment flow
 */
export const shareholderInvestorControllerUpdateShareholderInvestorData = <ThrowOnError extends boolean = false>(options: Options<ShareholderInvestorControllerUpdateShareholderInvestorDataData, ThrowOnError>) => (options.client ?? client).put<ShareholderInvestorControllerUpdateShareholderInvestorDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Shareholder investor data by user id
 */
export const shareholderInvestorControllerGetShareholderInvestorDataByUserId = <ThrowOnError extends boolean = false>(options?: Options<ShareholderInvestorControllerGetShareholderInvestorDataByUserIdData, ThrowOnError>) => (options?.client ?? client).get<ShareholderInvestorControllerGetShareholderInvestorDataByUserIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investor/user/{userId}',
    ...options
});

/**
 * documents for all users investments, or a single MIP investment when investorId is provided
 */
export const shareholderInvestorControllerGetInvestorDocuments = <ThrowOnError extends boolean = false>(options?: Options<ShareholderInvestorControllerGetInvestorDocumentsData, ThrowOnError>) => (options?.client ?? client).get<ShareholderInvestorControllerGetInvestorDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investor/user-investment-documents',
    ...options
});

/**
 * Deal library documents shared with this investor
 *
 * DC-494. Documents from the deal document library that a deal admin has opted in to the investor portal for the caller, or for an investment vehicle the caller holds through. Scoped entirely off the authenticated user — no caller-supplied id is trusted.
 */
export const shareholderInvestorControllerGetInvestorDealDocuments = <ThrowOnError extends boolean = false>(options?: Options<ShareholderInvestorControllerGetInvestorDealDocumentsData, ThrowOnError>) => (options?.client ?? client).get<ShareholderInvestorControllerGetInvestorDealDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investor/deal-documents',
    ...options
});

/**
 * Update investor vehicle data
 */
export const shareholderInvestorControllerUpdateShareholderInvestorVehicleData = <ThrowOnError extends boolean = false>(options: Options<ShareholderInvestorControllerUpdateShareholderInvestorVehicleDataData, ThrowOnError>) => (options.client ?? client).patch<ShareholderInvestorControllerUpdateShareholderInvestorVehicleDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investor/vehicle-data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update data on which completion step are investor for given MIP
 */
export const shareholderInvestorControllerUpdateShareholderInvestorCompletedStepsData = <ThrowOnError extends boolean = false>(options: Options<ShareholderInvestorControllerUpdateShareholderInvestorCompletedStepsDataData, ThrowOnError>) => (options.client ?? client).patch<ShareholderInvestorControllerUpdateShareholderInvestorCompletedStepsDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investor/completion-step',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Shareholder investor data
 */
export const shareholderInvestorControllerGetInvestorRepresentative = <ThrowOnError extends boolean = false>(options: Options<ShareholderInvestorControllerGetInvestorRepresentativeData, ThrowOnError>) => (options.client ?? client).get<ShareholderInvestorControllerGetInvestorRepresentativeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investor/{investorId}/representative',
    ...options
});

/**
 * Get shareholder investor transactions
 */
export const shareholderInvestorControllerGetInvestmentTransactions = <ThrowOnError extends boolean = false>(options: Options<ShareholderInvestorControllerGetInvestmentTransactionsData, ThrowOnError>) => (options.client ?? client).get<ShareholderInvestorControllerGetInvestmentTransactionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investor/transactions',
    ...options
});

/**
 * Create natural person entity
 */
export const personControllerCreateNaturalEntity = <ThrowOnError extends boolean = false>(options: Options<PersonControllerCreateNaturalEntityData, ThrowOnError>) => (options.client ?? client).post<PersonControllerCreateNaturalEntityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/deal/{dealId}/person/create-natural',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create legal person entity
 */
export const personControllerCreateLegalEntity = <ThrowOnError extends boolean = false>(options: Options<PersonControllerCreateLegalEntityData, ThrowOnError>) => (options.client ?? client).post<PersonControllerCreateLegalEntityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/deal/{dealId}/person/create-legal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update legal person details
 */
export const personControllerUpdateLegalPersonDetails = <ThrowOnError extends boolean = false>(options: Options<PersonControllerUpdateLegalPersonDetailsData, ThrowOnError>) => (options.client ?? client).put<PersonControllerUpdateLegalPersonDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/legal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update natural person details
 */
export const personControllerUpdateNaturalPersonDetails = <ThrowOnError extends boolean = false>(options: Options<PersonControllerUpdateNaturalPersonDetailsData, ThrowOnError>) => (options.client ?? client).put<PersonControllerUpdateNaturalPersonDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/natural',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update natural person email
 */
export const personControllerUpdateNaturalPersonEmail = <ThrowOnError extends boolean = false>(options: Options<PersonControllerUpdateNaturalPersonEmailData, ThrowOnError>) => (options.client ?? client).put<PersonControllerUpdateNaturalPersonEmailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/natural/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Look up a person by email in the deal directory (prefill)
 */
export const personControllerLookupPersonByEmail = <ThrowOnError extends boolean = false>(options: Options<PersonControllerLookupPersonByEmailData, ThrowOnError>) => (options.client ?? client).get<PersonControllerLookupPersonByEmailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/lookup-by-email',
    ...options
});

/**
 * Get person data
 */
export const personControllerGetEntityData = <ThrowOnError extends boolean = false>(options: Options<PersonControllerGetEntityDataData, ThrowOnError>) => (options.client ?? client).get<PersonControllerGetEntityDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}',
    ...options
});

/**
 * Delete related person
 */
export const personControllerDeletePersonRelatedPerson = <ThrowOnError extends boolean = false>(options: Options<PersonControllerDeletePersonRelatedPersonData, ThrowOnError>) => (options.client ?? client).delete<PersonControllerDeletePersonRelatedPersonResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/related-people',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get related people for person
 */
export const personControllerGetPersonRelatedPeople = <ThrowOnError extends boolean = false>(options: Options<PersonControllerGetPersonRelatedPeopleData, ThrowOnError>) => (options.client ?? client).get<PersonControllerGetPersonRelatedPeopleResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/related-people',
    ...options
});

/**
 * Create related people for person
 */
export const personControllerCreateRelatedPeopleForPerson = <ThrowOnError extends boolean = false>(options: Options<PersonControllerCreateRelatedPeopleForPersonData, ThrowOnError>) => (options.client ?? client).post<PersonControllerCreateRelatedPeopleForPersonResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/related-people',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get available people to relate to person
 */
export const personControllerGetAvailableRelatedPeopleForPerson = <ThrowOnError extends boolean = false>(options: Options<PersonControllerGetAvailableRelatedPeopleForPersonData, ThrowOnError>) => (options.client ?? client).get<PersonControllerGetAvailableRelatedPeopleForPersonResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/available-related-people',
    ...options
});

/**
 * Add a related person to a legal person by email (find-or-create + link)
 */
export const personControllerAddRelatedPersonByEmail = <ThrowOnError extends boolean = false>(options: Options<PersonControllerAddRelatedPersonByEmailData, ThrowOnError>) => (options.client ?? client).post<PersonControllerAddRelatedPersonByEmailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/related-people/by-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update related person relation
 */
export const personControllerUpdateRelatedPersonRelation = <ThrowOnError extends boolean = false>(options: Options<PersonControllerUpdateRelatedPersonRelationData, ThrowOnError>) => (options.client ?? client).patch<PersonControllerUpdateRelatedPersonRelationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/related-people/{relationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all person entities
 */
export const personControllerGetAllEntities = <ThrowOnError extends boolean = false>(options: Options<PersonControllerGetAllEntitiesData, ThrowOnError>) => (options.client ?? client).get<PersonControllerGetAllEntitiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/deal/{dealId}/persons',
    ...options
});

/**
 * Get all legal person entities
 */
export const personControllerGetAllLegalEntities = <ThrowOnError extends boolean = false>(options: Options<PersonControllerGetAllLegalEntitiesData, ThrowOnError>) => (options.client ?? client).get<PersonControllerGetAllLegalEntitiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/deal/{dealId}/legal-persons',
    ...options
});

/**
 * Get persons for CAP manage page
 */
export const personControllerGetPersonsForCap = <ThrowOnError extends boolean = false>(options: Options<PersonControllerGetPersonsForCapData, ThrowOnError>) => (options.client ?? client).get<PersonControllerGetPersonsForCapResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/deal/{dealId}/persons-for-cap',
    ...options
});

/**
 * Get all deal person tags with counts
 */
export const personControllerGetPersonTagsForDeal = <ThrowOnError extends boolean = false>(options: Options<PersonControllerGetPersonTagsForDealData, ThrowOnError>) => (options.client ?? client).get<PersonControllerGetPersonTagsForDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/deal/{dealId}/person-tags',
    ...options
});

/**
 * Delete person entities
 */
export const personControllerDeleteEntities = <ThrowOnError extends boolean = false>(options: Options<PersonControllerDeleteEntitiesData, ThrowOnError>) => (options.client ?? client).post<PersonControllerDeleteEntitiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/delete-entities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * check if person have InvestmentWorkflow attached
 */
export const personControllerIsThereInvestmentWorkflow = <ThrowOnError extends boolean = false>(options: Options<PersonControllerIsThereInvestmentWorkflowData, ThrowOnError>) => (options.client ?? client).post<PersonControllerIsThereInvestmentWorkflowResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/is-there-investmentWorkflow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk create legal persons
 */
export const personControllerBulkCreateLegalPersons = <ThrowOnError extends boolean = false>(options: Options<PersonControllerBulkCreateLegalPersonsData, ThrowOnError>) => (options.client ?? client).post<PersonControllerBulkCreateLegalPersonsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/deal/{dealId}/create-legal-bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk create natural persons
 */
export const personControllerBulkCreateNaturalPersons = <ThrowOnError extends boolean = false>(options: Options<PersonControllerBulkCreateNaturalPersonsData, ThrowOnError>) => (options.client ?? client).post<PersonControllerBulkCreateNaturalPersonsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/deal/{dealId}/create-natural-bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create person address
 */
export const personControllerCreateAddress = <ThrowOnError extends boolean = false>(options: Options<PersonControllerCreateAddressData, ThrowOnError>) => (options.client ?? client).post<PersonControllerCreateAddressResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/create-address',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update person address
 */
export const personControllerUpdateAddress = <ThrowOnError extends boolean = false>(options: Options<PersonControllerUpdateAddressData, ThrowOnError>) => (options.client ?? client).put<PersonControllerUpdateAddressResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/update-address',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete person address
 */
export const personControllerDeleteAddress = <ThrowOnError extends boolean = false>(options: Options<PersonControllerDeleteAddressData, ThrowOnError>) => (options.client ?? client).delete<PersonControllerDeleteAddressResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personAddressId}/delete-address',
    ...options
});

/**
 * Get natural persons investing through a PIV
 */
export const personControllerGetNaturalPersonsByPivId = <ThrowOnError extends boolean = false>(options: Options<PersonControllerGetNaturalPersonsByPivIdData, ThrowOnError>) => (options.client ?? client).get<PersonControllerGetNaturalPersonsByPivIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{pivPersonId}/natural-persons-by-piv',
    ...options
});

/**
 * Check if person email can be updated, based on whether user is invited to the platform
 */
export const personControllerIsPersonUserInvitedToPlatform = <ThrowOnError extends boolean = false>(options: Options<PersonControllerIsPersonUserInvitedToPlatformData, ThrowOnError>) => (options.client ?? client).get<PersonControllerIsPersonUserInvitedToPlatformResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/is-user-invited',
    ...options
});

/**
 * Get person bank accounts
 */
export const personBankAccountControllerGetPersonBankAccounts = <ThrowOnError extends boolean = false>(options: Options<PersonBankAccountControllerGetPersonBankAccountsData, ThrowOnError>) => (options.client ?? client).get<PersonBankAccountControllerGetPersonBankAccountsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/bankAccount',
    ...options
});

/**
 * Add person bank account
 */
export const personBankAccountControllerCreatePersonBankAccount = <ThrowOnError extends boolean = false>(options: Options<PersonBankAccountControllerCreatePersonBankAccountData, ThrowOnError>) => (options.client ?? client).post<PersonBankAccountControllerCreatePersonBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/bankAccount',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete person bank account
 */
export const personBankAccountControllerDeletePersonBankAccount = <ThrowOnError extends boolean = false>(options: Options<PersonBankAccountControllerDeletePersonBankAccountData, ThrowOnError>) => (options.client ?? client).delete<PersonBankAccountControllerDeletePersonBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/bankAccount/{bankAccountId}',
    ...options
});

/**
 * Update person bank account
 */
export const personBankAccountControllerUpdatePersonBankAccount = <ThrowOnError extends boolean = false>(options: Options<PersonBankAccountControllerUpdatePersonBankAccountData, ThrowOnError>) => (options.client ?? client).put<PersonBankAccountControllerUpdatePersonBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/bankAccount/{bankAccountId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify a person bank account's identifiers per format rule and log the lookup
 */
export const personBankAccountControllerValidatePersonBankAccount = <ThrowOnError extends boolean = false>(options: Options<PersonBankAccountControllerValidatePersonBankAccountData, ThrowOnError>) => (options.client ?? client).post<PersonBankAccountControllerValidatePersonBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/bankAccount/{bankAccountId}/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get person tax information
 */
export const personTaxControllerGetPersonTaxInformation = <ThrowOnError extends boolean = false>(options: Options<PersonTaxControllerGetPersonTaxInformationData, ThrowOnError>) => (options.client ?? client).get<PersonTaxControllerGetPersonTaxInformationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/tax',
    ...options
});

/**
 * Add person tax information
 */
export const personTaxControllerCreatePersonTaxInformation = <ThrowOnError extends boolean = false>(options: Options<PersonTaxControllerCreatePersonTaxInformationData, ThrowOnError>) => (options.client ?? client).post<PersonTaxControllerCreatePersonTaxInformationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/tax',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete person tax information
 */
export const personTaxControllerDeletePersonTaxInformation = <ThrowOnError extends boolean = false>(options: Options<PersonTaxControllerDeletePersonTaxInformationData, ThrowOnError>) => (options.client ?? client).delete<PersonTaxControllerDeletePersonTaxInformationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/tax/{taxId}',
    ...options
});

/**
 * Update person tax information
 */
export const personTaxControllerUpdatePersonTaxInformation = <ThrowOnError extends boolean = false>(options: Options<PersonTaxControllerUpdatePersonTaxInformationData, ThrowOnError>) => (options.client ?? client).put<PersonTaxControllerUpdatePersonTaxInformationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/tax/{taxId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get investment programmes for person
 */
export const personInvestmentProgrammeControllerGetInvestmentProgrammesForPerson = <ThrowOnError extends boolean = false>(options: Options<PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonData, ThrowOnError>) => (options.client ?? client).get<PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/mip',
    ...options
});

/**
 * Get available investment programmes for person
 */
export const personInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPerson = <ThrowOnError extends boolean = false>(options: Options<PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonData, ThrowOnError>) => (options.client ?? client).get<PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/mip/available-for-linking',
    ...options
});

/**
 * Check available transactions for person for mip
 */
export const personInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMip = <ThrowOnError extends boolean = false>(options: Options<PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipData, ThrowOnError>) => (options.client ?? client).get<PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/mip/{mipId}/transactions',
    ...options
});

/**
 * Get open TSA warning for person in MIP
 */
export const personInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMip = <ThrowOnError extends boolean = false>(options: Options<PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipData, ThrowOnError>) => (options.client ?? client).get<PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/mip/{mipId}/open-tsa-warning',
    ...options
});

/**
 * Link person to MIP
 */
export const personInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequest = <ThrowOnError extends boolean = false>(options: Options<PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestData, ThrowOnError>) => (options.client ?? client).post<PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/mip/{mipId}/link',
    ...options
});

/**
 * Unlink person from MIP
 */
export const personInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequest = <ThrowOnError extends boolean = false>(options: Options<PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestData, ThrowOnError>) => (options.client ?? client).post<PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/mip/{mipId}/unlink',
    ...options
});

/**
 * List employment records for a person (as employee or employer)
 */
export const personEmploymentRecordControllerListEmploymentRecords = <ThrowOnError extends boolean = false>(options: Options<PersonEmploymentRecordControllerListEmploymentRecordsData, ThrowOnError>) => (options.client ?? client).get<PersonEmploymentRecordControllerListEmploymentRecordsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/persons/{personId}/employment-records',
    ...options
});

/**
 * Create an employment record for a person
 */
export const personEmploymentRecordControllerCreateEmploymentRecord = <ThrowOnError extends boolean = false>(options: Options<PersonEmploymentRecordControllerCreateEmploymentRecordData, ThrowOnError>) => (options.client ?? client).post<PersonEmploymentRecordControllerCreateEmploymentRecordResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/persons/{personId}/employment-records',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get employment records where the person is the employee
 */
export const personEmploymentControllerGetPersonEmployment = <ThrowOnError extends boolean = false>(options: Options<PersonEmploymentControllerGetPersonEmploymentData, ThrowOnError>) => (options.client ?? client).get<PersonEmploymentControllerGetPersonEmploymentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/employment',
    ...options
});

/**
 * Upsert an employment record by employer name
 */
export const personEmploymentControllerUpsertPersonEmployment = <ThrowOnError extends boolean = false>(options: Options<PersonEmploymentControllerUpsertPersonEmploymentData, ThrowOnError>) => (options.client ?? client).put<PersonEmploymentControllerUpsertPersonEmploymentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/person/{personId}/employment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List employer persons referenced by employment records in the deal
 */
export const employmentEmployersControllerGetEmployers = <ThrowOnError extends boolean = false>(options?: Options<EmploymentEmployersControllerGetEmployersData, ThrowOnError>) => (options?.client ?? client).get<EmploymentEmployersControllerGetEmployersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/employment/employers',
    ...options
});

/**
 * Delete an employment record
 */
export const employmentRecordControllerDeleteEmploymentRecord = <ThrowOnError extends boolean = false>(options: Options<EmploymentRecordControllerDeleteEmploymentRecordData, ThrowOnError>) => (options.client ?? client).delete<EmploymentRecordControllerDeleteEmploymentRecordResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/employment-records/{employmentRecordId}',
    ...options
});

/**
 * Get a single employment record
 */
export const employmentRecordControllerGetEmploymentRecord = <ThrowOnError extends boolean = false>(options: Options<EmploymentRecordControllerGetEmploymentRecordData, ThrowOnError>) => (options.client ?? client).get<EmploymentRecordControllerGetEmploymentRecordResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/employment-records/{employmentRecordId}',
    ...options
});

/**
 * Update an employment record
 */
export const employmentRecordControllerUpdateEmploymentRecord = <ThrowOnError extends boolean = false>(options: Options<EmploymentRecordControllerUpdateEmploymentRecordData, ThrowOnError>) => (options.client ?? client).put<EmploymentRecordControllerUpdateEmploymentRecordResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/employment-records/{employmentRecordId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Debug: all verification log rows for a bank account
 */
export const bankAccountLifecycleDebugControllerGetVerificationLogs = <ThrowOnError extends boolean = false>(options: Options<BankAccountLifecycleDebugControllerGetVerificationLogsData, ThrowOnError>) => (options.client ?? client).get<BankAccountLifecycleDebugControllerGetVerificationLogsResponses, unknown, ThrowOnError>({ url: '/bank-account-lifecycle-debug/{id}/verification-logs', ...options });

/**
 * Debug: all state transition rows for a bank account
 */
export const bankAccountLifecycleDebugControllerGetStateTransitions = <ThrowOnError extends boolean = false>(options: Options<BankAccountLifecycleDebugControllerGetStateTransitionsData, ThrowOnError>) => (options.client ?? client).get<BankAccountLifecycleDebugControllerGetStateTransitionsResponses, unknown, ThrowOnError>({ url: '/bank-account-lifecycle-debug/{id}/state-transitions', ...options });

/**
 * Verify bank identifiers against the format rule (or as IBAN when no rule is given)
 */
export const validationControllerVerifyBankIdentifiers = <ThrowOnError extends boolean = false>(options: Options<ValidationControllerVerifyBankIdentifiersData, ThrowOnError>) => (options.client ?? client).post<ValidationControllerVerifyBankIdentifiersResponses, unknown, ThrowOnError>({
    url: '/validation/bank-identifiers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate TIN
 */
export const validationControllerValidateTin = <ThrowOnError extends boolean = false>(options: Options<ValidationControllerValidateTinData, ThrowOnError>) => (options.client ?? client).post<ValidationControllerValidateTinResponses, unknown, ThrowOnError>({
    url: '/validation/tin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all vesting terms and their nested entities
 */
export const vestingControllerGetVestingTerms = <ThrowOnError extends boolean = false>(options?: Options<VestingControllerGetVestingTermsData, ThrowOnError>) => (options?.client ?? client).get<VestingControllerGetVestingTermsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term',
    ...options
});

/**
 * Create vesting term
 */
export const vestingControllerCreateVestingTerm = <ThrowOnError extends boolean = false>(options: Options<VestingControllerCreateVestingTermData, ThrowOnError>) => (options.client ?? client).post<VestingControllerCreateVestingTermResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all vesting terms (basic data)
 */
export const vestingControllerGetSimplifiedVestingTerms = <ThrowOnError extends boolean = false>(options?: Options<VestingControllerGetSimplifiedVestingTermsData, ThrowOnError>) => (options?.client ?? client).get<VestingControllerGetSimplifiedVestingTermsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/names',
    ...options
});

/**
 * Apply vesting start date to InvestmentWorkflow
 */
export const vestingControllerApplyVestingStartDateToInvestmentWorkflow = <ThrowOnError extends boolean = false>(options: Options<VestingControllerApplyVestingStartDateToInvestmentWorkflowData, ThrowOnError>) => (options.client ?? client).post<VestingControllerApplyVestingStartDateToInvestmentWorkflowResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/vesting-start-investmentWorkflow/{investmentWorkflowId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apply vesting start date to transaction
 */
export const vestingControllerApplyVestingStartDateToTransaction = <ThrowOnError extends boolean = false>(options: Options<VestingControllerApplyVestingStartDateToTransactionData, ThrowOnError>) => (options.client ?? client).post<VestingControllerApplyVestingStartDateToTransactionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/vesting-start-transaction/{transactionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apply a vesting term and start date to a transaction in one step
 */
export const vestingControllerSaveTransactionVesting = <ThrowOnError extends boolean = false>(options: Options<VestingControllerSaveTransactionVestingData, ThrowOnError>) => (options.client ?? client).put<VestingControllerSaveTransactionVestingResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/transaction/{transactionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apply vesting term to investmentWorkflow
 */
export const vestingControllerApplyVestingTermToInvestmentWorkflow = <ThrowOnError extends boolean = false>(options: Options<VestingControllerApplyVestingTermToInvestmentWorkflowData, ThrowOnError>) => (options.client ?? client).post<VestingControllerApplyVestingTermToInvestmentWorkflowResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/apply-to-investmentWorkflow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apply vesting term to transaction
 */
export const vestingControllerApplyVestingTermToTransaction = <ThrowOnError extends boolean = false>(options: Options<VestingControllerApplyVestingTermToTransactionData, ThrowOnError>) => (options.client ?? client).post<VestingControllerApplyVestingTermToTransactionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/apply-to-transaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove vesting term from investmentWorkflow
 */
export const vestingControllerRemoveVestingTermFromInvestmentWorkflow = <ThrowOnError extends boolean = false>(options: Options<VestingControllerRemoveVestingTermFromInvestmentWorkflowData, ThrowOnError>) => (options.client ?? client).delete<VestingControllerRemoveVestingTermFromInvestmentWorkflowResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/remove-from-investmentWorkflow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove vesting term from transaction
 */
export const vestingControllerRemoveVestingTermFromTransaction = <ThrowOnError extends boolean = false>(options: Options<VestingControllerRemoveVestingTermFromTransactionData, ThrowOnError>) => (options.client ?? client).delete<VestingControllerRemoveVestingTermFromTransactionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/remove-from-transaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk update vesting for investors
 */
export const vestingControllerBulkUpdateInvestorsVesting = <ThrowOnError extends boolean = false>(options: Options<VestingControllerBulkUpdateInvestorsVestingData, ThrowOnError>) => (options.client ?? client).post<VestingControllerBulkUpdateInvestorsVestingResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/investors/bulk-update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete vesting term
 */
export const vestingControllerDeleteVestingTerm = <ThrowOnError extends boolean = false>(options: Options<VestingControllerDeleteVestingTermData, ThrowOnError>) => (options.client ?? client).delete<VestingControllerDeleteVestingTermResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/{id}',
    ...options
});

/**
 * Update vesting term
 */
export const vestingControllerUpdateVestingTerm = <ThrowOnError extends boolean = false>(options: Options<VestingControllerUpdateVestingTermData, ThrowOnError>) => (options.client ?? client).patch<VestingControllerUpdateVestingTermResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create vesting term graded
 */
export const vestingControllerCreateVestingTermGraded = <ThrowOnError extends boolean = false>(options: Options<VestingControllerCreateVestingTermGradedData, ThrowOnError>) => (options.client ?? client).post<VestingControllerCreateVestingTermGradedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/graded',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete vesting term graded
 */
export const vestingControllerDeleteVestingTermGraded = <ThrowOnError extends boolean = false>(options: Options<VestingControllerDeleteVestingTermGradedData, ThrowOnError>) => (options.client ?? client).delete<VestingControllerDeleteVestingTermGradedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/graded/{id}',
    ...options
});

/**
 * Update vesting term graded
 */
export const vestingControllerUpdateVestingTermGraded = <ThrowOnError extends boolean = false>(options: Options<VestingControllerUpdateVestingTermGradedData, ThrowOnError>) => (options.client ?? client).put<VestingControllerUpdateVestingTermGradedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/graded/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create vesting term straight line
 */
export const vestingControllerCreateVestingTermStraightLine = <ThrowOnError extends boolean = false>(options: Options<VestingControllerCreateVestingTermStraightLineData, ThrowOnError>) => (options.client ?? client).post<VestingControllerCreateVestingTermStraightLineResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/straight-line',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete vesting term straight line
 */
export const vestingControllerDeleteVestingTermStraightLine = <ThrowOnError extends boolean = false>(options: Options<VestingControllerDeleteVestingTermStraightLineData, ThrowOnError>) => (options.client ?? client).delete<VestingControllerDeleteVestingTermStraightLineResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/straight-line/{id}',
    ...options
});

/**
 * Update vesting term straight line
 */
export const vestingControllerUpdateVestingTermStraightLine = <ThrowOnError extends boolean = false>(options: Options<VestingControllerUpdateVestingTermStraightLineData, ThrowOnError>) => (options.client ?? client).put<VestingControllerUpdateVestingTermStraightLineResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/straight-line/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create vesting term leaver provision
 */
export const vestingControllerCreateVestingTermLeaverProvision = <ThrowOnError extends boolean = false>(options: Options<VestingControllerCreateVestingTermLeaverProvisionData, ThrowOnError>) => (options.client ?? client).post<VestingControllerCreateVestingTermLeaverProvisionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/leaver-provision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete vesting term leaver provision
 */
export const vestingControllerDeleteVestingTermLeaverProvision = <ThrowOnError extends boolean = false>(options: Options<VestingControllerDeleteVestingTermLeaverProvisionData, ThrowOnError>) => (options.client ?? client).delete<VestingControllerDeleteVestingTermLeaverProvisionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/leaver-provision/{id}',
    ...options
});

/**
 * Update vesting term leaver provision
 */
export const vestingControllerUpdateVestingTermLeaverProvision = <ThrowOnError extends boolean = false>(options: Options<VestingControllerUpdateVestingTermLeaverProvisionData, ThrowOnError>) => (options.client ?? client).put<VestingControllerUpdateVestingTermLeaverProvisionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/leaver-provision/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update performance vesting for a vesting term
 */
export const vestingControllerUpsertPerformanceVesting = <ThrowOnError extends boolean = false>(options: Options<VestingControllerUpsertPerformanceVestingData, ThrowOnError>) => (options.client ?? client).post<VestingControllerUpsertPerformanceVestingResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/performance-vesting',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete performance vesting for a vesting term
 */
export const vestingControllerDeletePerformanceVesting = <ThrowOnError extends boolean = false>(options: Options<VestingControllerDeletePerformanceVestingData, ThrowOnError>) => (options.client ?? client).delete<VestingControllerDeletePerformanceVestingResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/vesting-term/performance-vesting/{performanceVestingTermId}',
    ...options
});

/**
 * List countries with an active bank account format rule
 */
export const bankAccountFormatRuleControllerGetSupportedCountries = <ThrowOnError extends boolean = false>(options?: Options<BankAccountFormatRuleControllerGetSupportedCountriesData, ThrowOnError>) => (options?.client ?? client).get<BankAccountFormatRuleControllerGetSupportedCountriesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/bank-account/supported-countries',
    ...options
});

/**
 * Active bank account format rules for a country, ordered for display
 */
export const bankAccountFormatRuleControllerGetFormatRules = <ThrowOnError extends boolean = false>(options: Options<BankAccountFormatRuleControllerGetFormatRulesData, ThrowOnError>) => (options.client ?? client).get<BankAccountFormatRuleControllerGetFormatRulesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/bank-account/format-rules/{countryCode}',
    ...options
});

/**
 * Create one schema session for transactions upload
 */
export const oneSchemaControllerCreateOneSchemaTransactionsSession = <ThrowOnError extends boolean = false>(options: Options<OneSchemaControllerCreateOneSchemaTransactionsSessionData, ThrowOnError>) => (options.client ?? client).post<OneSchemaControllerCreateOneSchemaTransactionsSessionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/one-schema/transactions/create-one-schema-session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webhook: Validate transactions for bulk upload
 */
export const oneSchemaControllerValidateOneSchemaTransactionRows = <ThrowOnError extends boolean = false>(options: Options<OneSchemaControllerValidateOneSchemaTransactionRowsData, ThrowOnError>) => (options.client ?? client).post<OneSchemaControllerValidateOneSchemaTransactionRowsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/one-schema/transactions/validate-transactions-for-bulk-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create one schema session for persons upload
 */
export const oneSchemaControllerCreateOneSchemaPersonsSession = <ThrowOnError extends boolean = false>(options: Options<OneSchemaControllerCreateOneSchemaPersonsSessionData, ThrowOnError>) => (options.client ?? client).post<OneSchemaControllerCreateOneSchemaPersonsSessionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/one-schema/persons/create-one-schema-session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webhook: Validate legal persons for bulk upload
 */
export const oneSchemaControllerValidateOneSchemaLegalPersonsRows = <ThrowOnError extends boolean = false>(options: Options<OneSchemaControllerValidateOneSchemaLegalPersonsRowsData, ThrowOnError>) => (options.client ?? client).post<OneSchemaControllerValidateOneSchemaLegalPersonsRowsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/one-schema/persons/validate-legal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webhook: Validate natural persons for bulk upload
 */
export const oneSchemaControllerValidateOneSchemaNaturalPersonsRows = <ThrowOnError extends boolean = false>(options: Options<OneSchemaControllerValidateOneSchemaNaturalPersonsRowsData, ThrowOnError>) => (options.client ?? client).post<OneSchemaControllerValidateOneSchemaNaturalPersonsRowsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/one-schema/persons/validate-natural',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Prepare one schema cache for management loans upload
 */
export const oneSchemaControllerPrepareOneSchemaManagementLoansCache = <ThrowOnError extends boolean = false>(options: Options<OneSchemaControllerPrepareOneSchemaManagementLoansCacheData, ThrowOnError>) => (options.client ?? client).post<OneSchemaControllerPrepareOneSchemaManagementLoansCacheResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/one-schema/management-loans/prepare-cache',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webhook: Validate management loans for bulk upload
 */
export const oneSchemaControllerValidateOneSchemaManagementLoansRows = <ThrowOnError extends boolean = false>(options: Options<OneSchemaControllerValidateOneSchemaManagementLoansRowsData, ThrowOnError>) => (options.client ?? client).post<OneSchemaControllerValidateOneSchemaManagementLoansRowsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/one-schema/management-loans/validate-management-loans-for-bulk-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Prepare one schema cache for share associations upload
 */
export const oneSchemaControllerPrepareOneSchemaShareAssociationsCache = <ThrowOnError extends boolean = false>(options: Options<OneSchemaControllerPrepareOneSchemaShareAssociationsCacheData, ThrowOnError>) => (options.client ?? client).post<OneSchemaControllerPrepareOneSchemaShareAssociationsCacheResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/one-schema/investment-allocations/prepare-cache',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webhook: Validate share associations for bulk upload
 */
export const oneSchemaControllerValidateOneSchemaShareAssociationRows = <ThrowOnError extends boolean = false>(options: Options<OneSchemaControllerValidateOneSchemaShareAssociationRowsData, ThrowOnError>) => (options.client ?? client).post<OneSchemaControllerValidateOneSchemaShareAssociationRowsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/one-schema/investment-allocations/validate-investment-allocations-for-bulk-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload file
 */
export const fileControllerCreateFile = <ThrowOnError extends boolean = false>(options?: Options<FileControllerCreateFileData, ThrowOnError>) => (options?.client ?? client).post<FileControllerCreateFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/file',
    ...options
});

/**
 * Download file
 */
export const fileControllerDownloadFile = <ThrowOnError extends boolean = false>(options: Options<FileControllerDownloadFileData, ThrowOnError>) => (options.client ?? client).get<FileControllerDownloadFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/file/{id}',
    ...options
});

/**
 * Download file url
 */
export const fileControllerDownloadPreSignedUrl = <ThrowOnError extends boolean = false>(options: Options<FileControllerDownloadPreSignedUrlData, ThrowOnError>) => (options.client ?? client).post<FileControllerDownloadPreSignedUrlResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/file/{id}/deal/{dealId}/download-pre-signed-url',
    ...options
});

/**
 * Download files in zip archive
 */
export const fileControllerBulkDownloadFiles = <ThrowOnError extends boolean = false>(options: Options<FileControllerBulkDownloadFilesData, ThrowOnError>) => (options.client ?? client).post<FileControllerBulkDownloadFilesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/file/bulk-download',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fileControllerGetFileDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<FileControllerGetFileDownloadUrlData, ThrowOnError>) => (options.client ?? client).get<FileControllerGetFileDownloadUrlResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/file/export/{s3Key}',
    ...options
});

/**
 * Upload signature image file
 */
export const fileControllerCreateSignatureFile = <ThrowOnError extends boolean = false>(options?: Options<FileControllerCreateSignatureFileData, ThrowOnError>) => (options?.client ?? client).post<FileControllerCreateSignatureFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/file/signature-file',
    ...options
});

/**
 * Revoke InvestmentWorkflow
 */
export const godmodeControllerPostReassignInvestor = <ThrowOnError extends boolean = false>(options?: Options<GodmodeControllerPostReassignInvestorData, ThrowOnError>) => (options?.client ?? client).post<GodmodeControllerPostReassignInvestorResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/reasignInvestor',
    ...options
});

/**
 * Fetch all users data
 */
export const godmodeControllerGetAllInvestors = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetAllInvestorsData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetAllInvestorsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/users/all',
    ...options
});

/**
 * Fetch active MIPs data
 */
export const godmodeControllerGetActiveMips = <ThrowOnError extends boolean = false>(options?: Options<GodmodeControllerGetActiveMipsData, ThrowOnError>) => (options?.client ?? client).post<GodmodeControllerGetActiveMipsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mips/active',
    ...options
});

/**
 * Download file
 */
export const godmodeControllerDownloadFile = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerDownloadFileData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerDownloadFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/file/{id}',
    ...options
});

/**
 * Revoke InvestmentWorkflow
 */
export const godmodeControllerPostRevokeTsa = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerPostRevokeTsaData, ThrowOnError>) => (options.client ?? client).post<GodmodeControllerPostRevokeTsaResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/revoke/{investmentWorkflowId}',
    ...options
});

/**
 * Soft delete InvestmentWorkflow
 */
export const godmodeControllerPostSoftDeleteTsa = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerPostSoftDeleteTsaData, ThrowOnError>) => (options.client ?? client).post<GodmodeControllerPostSoftDeleteTsaResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/soft-delete-investmentWorkflow/{investmentWorkflowId}',
    ...options
});

/**
 * Remove investor
 */
export const godmodeControllerPostRemoveInvestor = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerPostRemoveInvestorData, ThrowOnError>) => (options.client ?? client).post<GodmodeControllerPostRemoveInvestorResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/remove-investor/{investorId}',
    ...options
});

/**
 * Soft delete user
 */
export const godmodeControllerDeleteUserSoft = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerDeleteUserSoftData, ThrowOnError>) => (options.client ?? client).delete<GodmodeControllerDeleteUserSoftResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/user/{userId}/soft',
    ...options
});

/**
 * Replace file
 */
export const godmodeControllerReplaceFile = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerReplaceFileData, ThrowOnError>) => (options.client ?? client).post<GodmodeControllerReplaceFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/file/{fileId}/replace',
    ...options
});

/**
 * Is any investor on state COLLECT_AND_APPROVE
 */
export const godmodeControllerIsAnyActiveInvestorInMip = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerIsAnyActiveInvestorInMipData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerIsAnyActiveInvestorInMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/is-any-investor-active',
    ...options
});

/**
 * Is any investor invited to Programme
 */
export const godmodeControllerIsAnyInvitedInvestorInMip = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerIsAnyInvitedInvestorInMipData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerIsAnyInvitedInvestorInMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/is-any-investor-invited',
    ...options
});

/**
 * Get file info
 */
export const godmodeControllerGetFileInfo = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetFileInfoData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetFileInfoResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/file/{id}/info',
    ...options
});

/**
 * Fetch all investor data
 */
export const godmodeControllerGetAllInvestorData = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetAllInvestorDataData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetAllInvestorDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/investor/{userId}',
    ...options
});

/**
 * Update Investor Personal Details
 */
export const godmodeControllerUpdateInvestorPersonalDetails = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerUpdateInvestorPersonalDetailsData, ThrowOnError>) => (options.client ?? client).put<GodmodeControllerUpdateInvestorPersonalDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/investor/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch all investors data for specified mipId
 */
export const godmodeControllerGetAllInvestorsForMip = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetAllInvestorsForMipData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetAllInvestorsForMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/investors',
    ...options
});

/**
 * Fetch user by id data
 */
export const godmodeControllerGetUserData = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetUserDataData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetUserDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/user/{userId}',
    ...options
});

/**
 * Fetch all mip data
 */
export const godmodeControllerGetMipData = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetMipDataData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetMipDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}',
    ...options
});

/**
 * Fetch all investors with InvestmentWorkflow from MIP
 */
export const godmodeControllerGetInvestorsFromMip = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetInvestorsFromMipData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetInvestorsFromMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/investors-investmentWorkflow',
    ...options
});

/**
 * Fetch mip with custom details data without forms
 */
export const godmodeControllerGetMipCustomDetailsDataWithoutForms = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetMipCustomDetailsDataWithoutFormsData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetMipCustomDetailsDataWithoutFormsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/custom-details-without-form/{mipId}',
    ...options
});

/**
 * Fetch investor personal details by userId
 */
export const godmodeControllerGetInvestorPersonalDetailsDataByUserId = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetInvestorPersonalDetailsDataByUserIdData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetInvestorPersonalDetailsDataByUserIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/investor/{userId}/personal-details',
    ...options
});

/**
 * Remove investors personal details
 */
export const godmodeControllerRemoveInvestorPersonalDetails = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerRemoveInvestorPersonalDetailsData, ThrowOnError>) => (options.client ?? client).delete<GodmodeControllerRemoveInvestorPersonalDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/investor-personal-details/{userId}',
    ...options
});

/**
 * Update custom detail type
 */
export const godmodeControllerUpdateCustomDetailType = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerUpdateCustomDetailTypeData, ThrowOnError>) => (options.client ?? client).patch<GodmodeControllerUpdateCustomDetailTypeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/update-custom-detail-type/{customDetailId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get list of all not deleted projects
 */
export const godmodeControllerGetAllNotDeletedProjects = <ThrowOnError extends boolean = false>(options?: Options<GodmodeControllerGetAllNotDeletedProjectsData, ThrowOnError>) => (options?.client ?? client).get<GodmodeControllerGetAllNotDeletedProjectsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/projects',
    ...options
});

/**
 * Get list of deals
 */
export const godmodeControllerGetDealsList = <ThrowOnError extends boolean = false>(options?: Options<GodmodeControllerGetDealsListData, ThrowOnError>) => (options?.client ?? client).get<GodmodeControllerGetDealsListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/deals',
    ...options
});

/**
 * Get deal by MIP id
 */
export const godmodeControllerGetDeal = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetDealData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/deals/{mipId}',
    ...options
});

/**
 * Update deal for MIP
 */
export const godmodeControllerChangeDeal = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerChangeDealData, ThrowOnError>) => (options.client ?? client).patch<GodmodeControllerChangeDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/deals/{mipId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update user first and last name
 */
export const godmodeControllerUpdateUserName = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerUpdateUserNameData, ThrowOnError>) => (options.client ?? client).patch<GodmodeControllerUpdateUserNameResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/update-user-name/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update user email
 */
export const godmodeControllerUpdateUserEmail = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerUpdateUserEmailData, ThrowOnError>) => (options.client ?? client).patch<GodmodeControllerUpdateUserEmailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/update-user-email/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Un archive deal and programmes and sets them in draft. All OpenFGA relations and resources need to be re-added in OpenFGA to activate the permission system
 */
export const godmodeControllerUnArchiveDealAndMips = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerUnArchiveDealAndMipsData, ThrowOnError>) => (options.client ?? client).put<GodmodeControllerUnArchiveDealAndMipsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/deal/{dealId}/deal-draft-mips',
    ...options
});

/**
 * Soft delete programme and investors. Removes all OpenFGA relations and resources from FGA
 */
export const godmodeControllerSoftDeleteMip = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerSoftDeleteMipData, ThrowOnError>) => (options.client ?? client).delete<GodmodeControllerSoftDeleteMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/mip-investors',
    ...options
});

/**
 * Update isKycRequired status
 */
export const godmodeControllerUpdateMipKycOptional = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerUpdateMipKycOptionalData, ThrowOnError>) => (options.client ?? client).patch<GodmodeControllerUpdateMipKycOptionalResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/kyc-required',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update isLocked flag
 */
export const godmodeControllerUpdateIsLocked = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerUpdateIsLockedData, ThrowOnError>) => (options.client ?? client).patch<GodmodeControllerUpdateIsLockedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/locked',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get list of Investments under MIP
 */
export const godmodeControllerGetMipListOfInvestments = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetMipListOfInvestmentsData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetMipListOfInvestmentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/investments',
    ...options
});

/**
 * Upload Bulk Edit MIP Investments file
 */
export const godmodeControllerPostBulkEditMipInvestments = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerPostBulkEditMipInvestmentsData, ThrowOnError>) => (options.client ?? client).post<GodmodeControllerPostBulkEditMipInvestmentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/investments/edit/bulk',
    ...options
});

/**
 * Soft delete Deal, MIPs and investors
 */
export const godmodeControllerUpdateDealMipsInvestorsDeleted = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerUpdateDealMipsInvestorsDeletedData, ThrowOnError>) => (options.client ?? client).delete<GodmodeControllerUpdateDealMipsInvestorsDeletedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/deal/{dealId}/deal-mips-investors',
    ...options
});

/**
 * Get deal data with active MIPs inside it
 */
export const godmodeControllerGetDealWithActiveMips = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetDealWithActiveMipsData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetDealWithActiveMipsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/deal/{dealId}',
    ...options
});

/**
 * Fetch investor transaction share association
 */
export const godmodeControllerGetInvestmentWorkflows = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetInvestmentWorkflowsData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetInvestmentWorkflowsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/transaction-share-association/{investmentWorkflowId}',
    ...options
});

/**
 * Update share associations
 */
export const godmodeControllerUpdateShareAssociations = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerUpdateShareAssociationsData, ThrowOnError>) => (options.client ?? client).put<GodmodeControllerUpdateShareAssociationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/share-association',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload file
 */
export const godmodeControllerUploadPdfFile = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerUploadPdfFileData, ThrowOnError>) => (options.client ?? client).post<GodmodeControllerUploadPdfFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/file',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get list of Loans under MIP
 */
export const godmodeControllerGetMipListOfLoans = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerGetMipListOfLoansData, ThrowOnError>) => (options.client ?? client).get<GodmodeControllerGetMipListOfLoansResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/loans',
    ...options
});

/**
 * Upload Bulk Update MIP Loans file
 */
export const godmodeControllerPostBulkUpdateMipLoans = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerPostBulkUpdateMipLoansData, ThrowOnError>) => (options.client ?? client).post<GodmodeControllerPostBulkUpdateMipLoansResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/loans/edit/bulk',
    ...options
});

/**
 * Bulk create InvestmentWorkflow
 */
export const godmodeControllerBulkCreateTsaForMip = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerBulkCreateTsaForMipData, ThrowOnError>) => (options.client ?? client).post<GodmodeControllerBulkCreateTsaForMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/investments/bulk-create',
    ...options
});

/**
 * Add custom details and attach them to investors
 */
export const godmodeControllerCreateCustomDetails = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerCreateCustomDetailsData, ThrowOnError>) => (options.client ?? client).post<GodmodeControllerCreateCustomDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/mip/{mipId}/custom-details',
    ...options
});

/**
 * Soft delete kyc file
 */
export const godmodeControllerSoftDeleteKycFile = <ThrowOnError extends boolean = false>(options: Options<GodmodeControllerSoftDeleteKycFileData, ThrowOnError>) => (options.client ?? client).delete<GodmodeControllerSoftDeleteKycFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/kyc-file/{kycFileId}',
    ...options
});

/**
 * List ingested WorkOS events, newest first
 *
 * Payloads are returned verbatim and may contain PII (email, IP) - super admin only.
 */
export const workOsEventsAdminControllerListWorkOsEvents = <ThrowOnError extends boolean = false>(options?: Options<WorkOsEventsAdminControllerListWorkOsEventsData, ThrowOnError>) => (options?.client ?? client).get<WorkOsEventsAdminControllerListWorkOsEventsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/workos-events',
    ...options
});

/**
 * Requeue a WorkOS event for another pass (FAILED -> PENDING, attempts reset)
 */
export const workOsEventsAdminControllerReplayWorkOsEvent = <ThrowOnError extends boolean = false>(options: Options<WorkOsEventsAdminControllerReplayWorkOsEventData, ThrowOnError>) => (options.client ?? client).post<WorkOsEventsAdminControllerReplayWorkOsEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/workos-events/{id}/replay',
    ...options
});

/**
 * Whether the platform may change the email address of this user
 *
 * Local read of the WorkOS organization-domain projection. Pass targetEmail to also check the destination domain and a DealStack address collision. The write path re-checks authoritatively against WorkOS before it changes anything.
 */
export const emailChangeEligibilityControllerGetEmailChangeEligibility = <ThrowOnError extends boolean = false>(options: Options<EmailChangeEligibilityControllerGetEmailChangeEligibilityData, ThrowOnError>) => (options.client ?? client).get<EmailChangeEligibilityControllerGetEmailChangeEligibilityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/user/{userId}/email-change-eligibility',
    ...options
});

/**
 * Get a list of contractFile and documentWorkflowFile names to filter on
 */
export const contractControllerGetContractAndDocumentWorkflowFileNames = <ThrowOnError extends boolean = false>(options?: Options<ContractControllerGetContractAndDocumentWorkflowFileNamesData, ThrowOnError>) => (options?.client ?? client).get<ContractControllerGetContractAndDocumentWorkflowFileNamesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/contract/names-filtering',
    ...options
});

/**
 * Get contracts for requested mipId
 */
export const contractDraftControllerGetContracts = <ThrowOnError extends boolean = false>(options?: Options<ContractDraftControllerGetContractsData, ThrowOnError>) => (options?.client ?? client).get<ContractDraftControllerGetContractsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/contract-draft',
    ...options
});

/**
 * Create contract
 */
export const contractDraftControllerCreateContract = <ThrowOnError extends boolean = false>(options: Options<ContractDraftControllerCreateContractData, ThrowOnError>) => (options.client ?? client).post<ContractDraftControllerCreateContractResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/contract-draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete contract by its id
 */
export const contractDraftControllerDeleteContract = <ThrowOnError extends boolean = false>(options: Options<ContractDraftControllerDeleteContractData, ThrowOnError>) => (options.client ?? client).delete<ContractDraftControllerDeleteContractResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/contract-draft/{id}',
    ...options
});

/**
 * Update contract by its id
 */
export const contractDraftControllerUpdateContract = <ThrowOnError extends boolean = false>(options: Options<ContractDraftControllerUpdateContractData, ThrowOnError>) => (options.client ?? client).put<ContractDraftControllerUpdateContractResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/contract-draft/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get document workflow draft templates for the programme (new workflow)
 */
export const documentWorkflowDraftInvestmentControllerGetDraftTemplates = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/draft-templates',
    ...options
});

/**
 * Stream document-change signals for a programme
 */
export const documentWorkflowControllerStreamProgrammeDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerStreamProgrammeDocumentsData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowControllerStreamProgrammeDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/stream',
    ...options
});

/**
 * get investment programme documents
 */
export const documentWorkflowControllerFindInvestmentProgrammeDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerFindInvestmentProgrammeDocumentsData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowControllerFindInvestmentProgrammeDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/list',
    ...options
});

/**
 * Get signing roles for investment programme documents
 */
export const documentWorkflowControllerFindInvestmentProgrammeSigningRoles = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/signing-roles',
    ...options
});

/**
 * bulk export excel
 */
export const documentWorkflowControllerBulkExportToExcel = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkExportToExcelData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkExportToExcelResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-export-to-excel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a single investment programme document by instance ID
 */
export const documentWorkflowControllerFindInvestmentProgrammeDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerFindInvestmentProgrammeDocumentData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowControllerFindInvestmentProgrammeDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}',
    ...options
});

/**
 * Get document workflow event logs for a document instance
 */
export const documentWorkflowControllerFindDocumentWorkflowEvents = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerFindDocumentWorkflowEventsData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowControllerFindDocumentWorkflowEventsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/events',
    ...options
});

/**
 * Replace the file on a completed document workflow instance (DealStack Support only)
 */
export const documentWorkflowControllerReplaceDocumentFile = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerReplaceDocumentFileData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerReplaceDocumentFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/replace-file',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close a document the investor will not sign, recording the reason
 */
export const documentWorkflowControllerCloseDocumentWithoutSignature = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerCloseDocumentWithoutSignatureData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerCloseDocumentWithoutSignatureResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/close-without-signature',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign a user as a signer to a document workflow instance
 */
export const documentWorkflowControllerAssignUserToSigner = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerAssignUserToSignerData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerAssignUserToSignerResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unassign a user as a signer from a document workflow instance
 */
export const documentWorkflowControllerUnassignUserFromSigner = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerUnassignUserFromSignerData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerUnassignUserFromSignerResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/unassign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Whether an investor can be added to this in-flight document
 */
export const documentWorkflowControllerGetAddInvestorEligibility = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerGetAddInvestorEligibilityData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowControllerGetAddInvestorEligibilityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/add-investor-eligibility',
    ...options
});

/**
 * Add investors to a multi-sign document already out for signature
 */
export const documentWorkflowControllerAddInvestors = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerAddInvestorsData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerAddInvestorsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/add-investors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Whether a counterparty can be added to this in-flight document
 */
export const documentWorkflowControllerGetAddCounterpartyEligibility = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerGetAddCounterpartyEligibilityData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowControllerGetAddCounterpartyEligibilityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/add-counterparty-eligibility',
    ...options
});

/**
 * Add a counterparty to a document already out for signature
 */
export const documentWorkflowControllerAddCounterparty = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerAddCounterpartyData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerAddCounterpartyResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/add-counterparty',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove an outstanding, unsigned signature requirement from a document
 */
export const documentWorkflowControllerRemoveSigner = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerRemoveSignerData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerRemoveSignerResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/remove-signer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a presigned upload URL to sign a wet ink document
 */
export const documentWorkflowControllerSignWetInkDocumentUpload = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerSignWetInkDocumentUploadData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerSignWetInkDocumentUploadResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/sign-wet-ink-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign document (wet ink upload)
 */
export const documentWorkflowControllerSignWetInkDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerSignWetInkDocumentData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerSignWetInkDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/sign-wet-ink/{signingRoleType}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claim an investor signature to sign on their behalf (Power of Attorney)
 */
export const documentWorkflowControllerClaimSigner = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerClaimSignerData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerClaimSignerResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/signer/{signerId}/claim',
    ...options
});

/**
 * Get a presigned upload URL for a signable form submission
 */
export const documentWorkflowControllerSubmitFormUpload = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerSubmitFormUploadData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerSubmitFormUploadResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/submit-form-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit the filled signable form
 */
export const documentWorkflowControllerSubmitForm = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerSubmitFormData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerSubmitFormResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/submit-form',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw a signable form the investor uploaded but has not signed
 */
export const documentWorkflowControllerRemoveSubmittedForm = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerRemoveSubmittedFormData, ThrowOnError>) => (options.client ?? client).delete<DocumentWorkflowControllerRemoveSubmittedFormResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/submitted-form',
    ...options
});

/**
 * bulk download files
 */
export const documentWorkflowControllerBulkDownloadFiles = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkDownloadFilesData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkDownloadFilesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-download',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * bulk revoke simple document workflow documents
 */
export const documentWorkflowControllerBulkRevokeSimpleDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkRevokeSimpleDocumentsData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkRevokeSimpleDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk reissue documents
 */
export const documentWorkflowControllerBulkReissueDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkReissueDocumentsData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkReissueDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-reissue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get aggregated counterparty role state across selected documents
 */
export const documentWorkflowControllerBulkAssignCounterpartiesPreview = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkAssignCounterpartiesPreviewData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkAssignCounterpartiesPreviewResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-assign-counterparties-preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start an async bulk assign/unassign counterparty job — returns jobId for status polling
 */
export const documentWorkflowControllerBulkAssignCounterparty = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkAssignCounterpartyData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkAssignCounterpartyResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-assign-counterparty',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get bulk-assign-counterparty job status for polling
 */
export const documentWorkflowControllerBulkAssignCounterpartyStatus = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkAssignCounterpartyStatusData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowControllerBulkAssignCounterpartyStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-assign-counterparty-status/{jobId}',
    ...options
});

/**
 * Preview a bulk add-counterparty: eligible count and skip reasons breakdown
 */
export const documentWorkflowControllerBulkAddCounterpartyPreview = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkAddCounterpartyPreviewData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkAddCounterpartyPreviewResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-add-counterparty-preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start an async bulk add-counterparty job — returns jobId for status polling
 */
export const documentWorkflowControllerBulkAddCounterparty = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkAddCounterpartyData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkAddCounterpartyResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-add-counterparty',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get bulk-add-counterparty job status for polling
 */
export const documentWorkflowControllerBulkAddCounterpartyStatus = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkAddCounterpartyStatusData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowControllerBulkAddCounterpartyStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-add-counterparty-status/{jobId}',
    ...options
});

/**
 * Aggregate open counterparty roles across selected documents for authorised-signatory invite
 */
export const documentWorkflowControllerBulkInviteAuthorisedSignatoriesPreview = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-invite-authorised-signatories-preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invite an authorised signatory to open counterparty slots across selected documents
 */
export const documentWorkflowControllerBulkInviteAuthorisedSignatory = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkInviteAuthorisedSignatoryData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkInviteAuthorisedSignatoryResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-invite-authorised-signatory',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start an async bulk remind-signers job — returns jobId for status polling
 */
export const documentWorkflowControllerBulkRemindSigners = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkRemindSignersData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkRemindSignersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-remind-signers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get bulk-remind-signers job status for polling
 */
export const documentWorkflowControllerBulkRemindSignersStatus = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkRemindSignersStatusData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowControllerBulkRemindSignersStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-remind-signers-status/{jobId}',
    ...options
});

/**
 * Start an async bulk apply-date job — returns jobId for status polling
 */
export const documentWorkflowControllerBulkApplyDate = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkApplyDateData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkApplyDateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-apply-date',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get bulk-apply-date job status for polling
 */
export const documentWorkflowControllerBulkApplyDateStatus = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkApplyDateStatusData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowControllerBulkApplyDateStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-apply-date-status/{jobId}',
    ...options
});

/**
 * Preview claimable investor signers across selected documents, grouped by role
 */
export const documentWorkflowControllerBulkClaimOnBehalfPreview = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkClaimOnBehalfPreviewData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkClaimOnBehalfPreviewResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-claim-on-behalf-preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claim investor signer slots on behalf across selected documents
 */
export const documentWorkflowControllerBulkClaimOnBehalf = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkClaimOnBehalfData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerBulkClaimOnBehalfResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-claim-on-behalf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get bulk-claim-generation job status for polling
 */
export const documentWorkflowControllerBulkClaimGenerationStatus = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkClaimGenerationStatusData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowControllerBulkClaimGenerationStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-claim-generation-status/{jobId}',
    ...options
});

/**
 * Prepare document for eID Easy signing (PAdES hash flow)
 */
export const documentWorkflowControllerEidEasyPrepare = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerEidEasyPrepareData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerEidEasyPrepareResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/eid-easy/prepare',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete eID Easy signing and save signed document
 */
export const documentWorkflowControllerEidEasyComplete = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerEidEasyCompleteData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerEidEasyCompleteResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/eid-easy/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open an eID Easy session for the next unapplied date placement
 */
export const documentWorkflowControllerApplyDatePrepare = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerApplyDatePrepareData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerApplyDatePrepareResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/apply-date/prepare',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save the dated PDF produced by an apply-date session
 */
export const documentWorkflowControllerApplyDateComplete = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerApplyDateCompleteData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerApplyDateCompleteResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/apply-date/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk-set requiresWitness on every signer of a role within an instance.
 */
export const documentWorkflowControllerBulkSetSignerRequiresWitness = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkSetSignerRequiresWitnessData, ThrowOnError>) => (options.client ?? client).patch<DocumentWorkflowControllerBulkSetSignerRequiresWitnessResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/document-workflow-instances/{instanceId}/signers/by-role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk-set securityLevel override on every signer of a role within an instance. BASIC enables simple sign (DRAW); ADVANCED disables it; null clears the override. DealStack Support only.
 */
export const documentWorkflowControllerBulkSetSignerSecurityLevel = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerBulkSetSignerSecurityLevelData, ThrowOnError>) => (options.client ?? client).patch<DocumentWorkflowControllerBulkSetSignerSecurityLevelResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/document-workflow-instances/{instanceId}/signers/by-role/security-level',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set requiresWitness on a single signer within an instance.
 */
export const documentWorkflowControllerSetSignerRequiresWitness = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerSetSignerRequiresWitnessData, ThrowOnError>) => (options.client ?? client).patch<DocumentWorkflowControllerSetSignerRequiresWitnessResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/document-workflow-instances/{instanceId}/signers/{signerId}/requires-witness',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set securityLevel override on a single signer within an instance. BASIC enables simple sign (DRAW); ADVANCED disables it; null clears the override. DealStack Support only.
 */
export const documentWorkflowControllerSetSignerSecurityLevel = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerSetSignerSecurityLevelData, ThrowOnError>) => (options.client ?? client).patch<DocumentWorkflowControllerSetSignerSecurityLevelResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/document-workflow-instances/{instanceId}/signers/{signerId}/security-level',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invite a witness to sign via email
 */
export const documentWorkflowControllerInviteWitness = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerInviteWitnessData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerInviteWitnessResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/invite-witness',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invite a representative to sign via email
 */
export const documentWorkflowControllerInviteRepresentative = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerInviteRepresentativeData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerInviteRepresentativeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/invite-representative',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invite an authorised signatory to sign via email
 */
export const documentWorkflowControllerInviteAuthorisedSignatory = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerInviteAuthorisedSignatoryData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerInviteAuthorisedSignatoryResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/invite-authorised-signatory',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel an invited authorised signatory, resetting the slot to unassigned
 */
export const documentWorkflowControllerCancelAuthorisedSignatory = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerCancelAuthorisedSignatoryData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerCancelAuthorisedSignatoryResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/cancel-authorised-signatory',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend signing invitation email
 */
export const documentWorkflowControllerResendInvitation = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowControllerResendInvitationData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowControllerResendInvitationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/resend-invitation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Prepare multiple documents for eID Easy bulk signing
 */
export const documentWorkflowBulkSigningControllerEidEasyBulkPrepare = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowBulkSigningControllerEidEasyBulkPrepareData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowBulkSigningControllerEidEasyBulkPrepareResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/eid-easy/bulk-prepare',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete eID Easy bulk signing and save all signed documents
 */
export const documentWorkflowBulkSigningControllerEidEasyBulkComplete = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowBulkSigningControllerEidEasyBulkCompleteData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowBulkSigningControllerEidEasyBulkCompleteResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/eid-easy/bulk-complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Initiate async bulk signing job (returns jobId for polling)
 */
export const documentWorkflowBulkSigningControllerEidEasyBulkSignInitiate = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowBulkSigningControllerEidEasyBulkSignInitiateData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowBulkSigningControllerEidEasyBulkSignInitiateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/eid-easy/bulk-sign/initiate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get async bulk signing job status (for polling)
 */
export const documentWorkflowBulkSigningControllerEidEasyBulkSignStatus = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/eid-easy/bulk-sign/{jobId}/status',
    ...options
});

/**
 * Signal FTN signing complete — triggers async complete phase
 */
export const documentWorkflowBulkSigningControllerEidEasyBulkSignComplete = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowBulkSigningControllerEidEasyBulkSignCompleteData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowBulkSigningControllerEidEasyBulkSignCompleteResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/eid-easy/bulk-sign/{jobId}/signed',
    ...options
});

/**
 * MIP KYC forms + which are attached to a KYC workflow (per-investment toggle state)
 */
export const documentWorkflowKycFormControllerGetFormsForKycWorkflow = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowKycFormControllerGetFormsForKycWorkflowData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowKycFormControllerGetFormsForKycWorkflowResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/kyc-forms/kyc-workflow/{kycWorkflowId}',
    ...options
});

/**
 * Attach a KYC form to a KYC workflow (per-workflow override)
 */
export const documentWorkflowKycFormControllerAttachForm = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowKycFormControllerAttachFormData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowKycFormControllerAttachFormResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/kyc-forms/kyc-workflow/{kycWorkflowId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a KYC form from a single investment (per-investment override)
 */
export const documentWorkflowKycFormControllerRemoveForm = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowKycFormControllerRemoveFormData, ThrowOnError>) => (options.client ?? client).delete<DocumentWorkflowKycFormControllerRemoveFormResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/kyc-forms/{kycFormWorkflowStateId}',
    ...options
});

/**
 * Review a submitted KYC form
 */
export const documentWorkflowKycFormControllerReviewForm = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowKycFormControllerReviewFormData, ThrowOnError>) => (options.client ?? client).put<DocumentWorkflowKycFormControllerReviewFormResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/kyc-forms/kyc-workflow/{kycWorkflowId}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset (clear) a submitted KYC form back to unsubmitted
 */
export const documentWorkflowKycFormControllerResetForm = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowKycFormControllerResetFormData, ThrowOnError>) => (options.client ?? client).put<DocumentWorkflowKycFormControllerResetFormResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/kyc-forms/kyc-workflow/{kycWorkflowId}/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attached KYC forms + submission state for a KYC workflow
 */
export const documentWorkflowKycFormControllerGetInvestorForms = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowKycFormControllerGetInvestorFormsData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowKycFormControllerGetInvestorFormsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/kyc-forms/kyc-workflow/{kycWorkflowId}/investor-forms',
    ...options
});

/**
 * Delete KYC form templates (DocumentWorkflow-native)
 */
export const kycFormTemplateControllerDelete = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerDeleteData, ThrowOnError>) => (options.client ?? client).delete<KycFormTemplateControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List a MIP's active KYC form templates (DocumentWorkflow-native)
 */
export const kycFormTemplateControllerList = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerListData, ThrowOnError>) => (options.client ?? client).get<KycFormTemplateControllerListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates',
    ...options
});

/**
 * Create a KYC form template (DocumentWorkflow-native)
 */
export const kycFormTemplateControllerCreate = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerCreateData, ThrowOnError>) => (options.client ?? client).post<KycFormTemplateControllerCreateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Published library templates tagged for one section of Tax & Compliance
 */
export const kycFormTemplateControllerListLibrary = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerListLibraryData, ThrowOnError>) => (options.client ?? client).get<KycFormTemplateControllerListLibraryResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/library',
    ...options
});

/**
 * Update a KYC form template (DocumentWorkflow-native)
 */
export const kycFormTemplateControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerUpdateData, ThrowOnError>) => (options.client ?? client).put<KycFormTemplateControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/{templateId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The signature box an admin must place on a KYC form (always exactly one)
 */
export const kycFormTemplateControllerSignatureSlots = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerSignatureSlotsData, ThrowOnError>) => (options.client ?? client).get<KycFormTemplateControllerSignatureSlotsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/{templateId}/signature-slots',
    ...options
});

/**
 * Save the manual signature placement for a KYC form template
 */
export const kycFormTemplateControllerUpdateSignaturePlacement = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerUpdateSignaturePlacementData, ThrowOnError>) => (options.client ?? client).put<KycFormTemplateControllerUpdateSignaturePlacementResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/{templateId}/signature-placement',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the coordinate field bindings of a PDF KYC form
 */
export const kycFormTemplateControllerFieldBindings = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerFieldBindingsData, ThrowOnError>) => (options.client ?? client).get<KycFormTemplateControllerFieldBindingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/{templateId}/field-bindings',
    ...options
});

/**
 * Replace the coordinate field bindings of a PDF KYC form
 */
export const kycFormTemplateControllerUpdateFieldBindings = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerUpdateFieldBindingsData, ThrowOnError>) => (options.client ?? client).put<KycFormTemplateControllerUpdateFieldBindingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/{templateId}/field-bindings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the field-binding catalogue with resolved sample values
 */
export const kycFormTemplateControllerFieldBindingCatalogue = <ThrowOnError extends boolean = false>(options?: Options<KycFormTemplateControllerFieldBindingCatalogueData, ThrowOnError>) => (options?.client ?? client).get<KycFormTemplateControllerFieldBindingCatalogueResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/field-binding-catalogue',
    ...options
});

/**
 * Render a KYC form with one investor’s values in place
 */
export const kycFormTemplateControllerPreviewFieldBindings = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerPreviewFieldBindingsData, ThrowOnError>) => (options.client ?? client).post<KycFormTemplateControllerPreviewFieldBindingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/{templateId}/field-bindings/preview',
    ...options
});

/**
 * Get the editable document for a Word KYC form
 */
export const kycFormTemplateControllerDocxDocument = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerDocxDocumentData, ThrowOnError>) => (options.client ?? client).get<KycFormTemplateControllerDocxDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/{templateId}/docx-document',
    ...options
});

/**
 * Save an edited Word KYC form
 */
export const kycFormTemplateControllerSaveDocxDocument = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerSaveDocxDocumentData, ThrowOnError>) => (options.client ?? client).put<KycFormTemplateControllerSaveDocxDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/{templateId}/docx-document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render a Word KYC form with its field names in place
 */
export const kycFormTemplateControllerRenderDocxFields = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerRenderDocxFieldsData, ThrowOnError>) => (options.client ?? client).get<KycFormTemplateControllerRenderDocxFieldsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/{templateId}/docx-render/fields',
    ...options
});

/**
 * Render a Word KYC form — field names, or an investor’s values
 */
export const kycFormTemplateControllerRenderDocx = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerRenderDocxData, ThrowOnError>) => (options.client ?? client).post<KycFormTemplateControllerRenderDocxResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/{templateId}/docx-render',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive or unarchive a KYC form template (DocumentWorkflow-native)
 */
export const kycFormTemplateControllerArchive = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerArchiveData, ThrowOnError>) => (options.client ?? client).put<KycFormTemplateControllerArchiveResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/{templateId}/archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * How many KYC workflows hold an instance of a KYC form template
 */
export const kycFormTemplateControllerInstanceCount = <ThrowOnError extends boolean = false>(options: Options<KycFormTemplateControllerInstanceCountData, ThrowOnError>) => (options.client ?? client).get<KycFormTemplateControllerInstanceCountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-workflow/kyc-form-templates/{templateId}/instance-count',
    ...options
});

export const publicSigningControllerGetSigningInfo = <ThrowOnError extends boolean = false>(options?: Options<PublicSigningControllerGetSigningInfoData, ThrowOnError>) => (options?.client ?? client).get<PublicSigningControllerGetSigningInfoResponses, unknown, ThrowOnError>({ url: '/public-signing/info', ...options });

export const publicSigningControllerGetDocument = <ThrowOnError extends boolean = false>(options?: Options<PublicSigningControllerGetDocumentData, ThrowOnError>) => (options?.client ?? client).get<PublicSigningControllerGetDocumentResponses, unknown, ThrowOnError>({ url: '/public-signing/document', ...options });

export const publicSigningControllerSaveWitnessDetails = <ThrowOnError extends boolean = false>(options: Options<PublicSigningControllerSaveWitnessDetailsData, ThrowOnError>) => (options.client ?? client).post<PublicSigningControllerSaveWitnessDetailsResponses, unknown, ThrowOnError>({
    url: '/public-signing/witness-details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const publicSigningControllerInviteWitness = <ThrowOnError extends boolean = false>(options: Options<PublicSigningControllerInviteWitnessData, ThrowOnError>) => (options.client ?? client).post<PublicSigningControllerInviteWitnessResponses, unknown, ThrowOnError>({
    url: '/public-signing/invite-witness',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const publicSigningControllerPrepare = <ThrowOnError extends boolean = false>(options: Options<PublicSigningControllerPrepareData, ThrowOnError>) => (options.client ?? client).post<PublicSigningControllerPrepareResponses, unknown, ThrowOnError>({
    url: '/public-signing/prepare',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const publicSigningControllerComplete = <ThrowOnError extends boolean = false>(options: Options<PublicSigningControllerCompleteData, ThrowOnError>) => (options.client ?? client).post<PublicSigningControllerCompleteResponses, unknown, ThrowOnError>({
    url: '/public-signing/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const publicBulkSigningControllerGetProgrammeDocuments = <ThrowOnError extends boolean = false>(options?: Options<PublicBulkSigningControllerGetProgrammeDocumentsData, ThrowOnError>) => (options?.client ?? client).get<PublicBulkSigningControllerGetProgrammeDocumentsResponses, unknown, ThrowOnError>({ url: '/public-signing/programme/documents', ...options });

export const publicBulkSigningControllerGetProgrammeDocument = <ThrowOnError extends boolean = false>(options: Options<PublicBulkSigningControllerGetProgrammeDocumentData, ThrowOnError>) => (options.client ?? client).get<PublicBulkSigningControllerGetProgrammeDocumentResponses, unknown, ThrowOnError>({ url: '/public-signing/programme/document', ...options });

export const publicBulkSigningControllerGetSignatureToken = <ThrowOnError extends boolean = false>(options: Options<PublicBulkSigningControllerGetSignatureTokenData, ThrowOnError>) => (options.client ?? client).post<PublicBulkSigningControllerGetSignatureTokenResponses, unknown, ThrowOnError>({
    url: '/public-signing/programme/signature-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const publicBulkSigningControllerBulkPrepare = <ThrowOnError extends boolean = false>(options: Options<PublicBulkSigningControllerBulkPrepareData, ThrowOnError>) => (options.client ?? client).post<PublicBulkSigningControllerBulkPrepareResponses, unknown, ThrowOnError>({
    url: '/public-signing/programme/bulk-prepare',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const publicBulkSigningControllerBulkComplete = <ThrowOnError extends boolean = false>(options: Options<PublicBulkSigningControllerBulkCompleteData, ThrowOnError>) => (options.client ?? client).post<PublicBulkSigningControllerBulkCompleteResponses, unknown, ThrowOnError>({
    url: '/public-signing/programme/bulk-complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const publicBulkSigningControllerBulkSignInitiate = <ThrowOnError extends boolean = false>(options: Options<PublicBulkSigningControllerBulkSignInitiateData, ThrowOnError>) => (options.client ?? client).post<PublicBulkSigningControllerBulkSignInitiateResponses, unknown, ThrowOnError>({
    url: '/public-signing/programme/bulk-sign/initiate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const publicBulkSigningControllerBulkSignStatus = <ThrowOnError extends boolean = false>(options: Options<PublicBulkSigningControllerBulkSignStatusData, ThrowOnError>) => (options.client ?? client).get<PublicBulkSigningControllerBulkSignStatusResponses, unknown, ThrowOnError>({ url: '/public-signing/programme/bulk-sign/{jobId}/status', ...options });

export const publicBulkSigningControllerBulkSignComplete = <ThrowOnError extends boolean = false>(options: Options<PublicBulkSigningControllerBulkSignCompleteData, ThrowOnError>) => (options.client ?? client).post<PublicBulkSigningControllerBulkSignCompleteResponses, unknown, ThrowOnError>({ url: '/public-signing/programme/bulk-sign/{jobId}/signed', ...options });

/**
 * Save a KYC certifier's name, address and professional capacity
 */
export const publicCertificationControllerSaveCertifierDetails = <ThrowOnError extends boolean = false>(options: Options<PublicCertificationControllerSaveCertifierDetailsData, ThrowOnError>) => (options.client ?? client).post<PublicCertificationControllerSaveCertifierDetailsResponses, unknown, ThrowOnError>({
    url: '/public-signing/certifier-details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Re-stamp a KYC certification with the certifier’s amended wording
 */
export const publicCertificationControllerUpdateCertificationText = <ThrowOnError extends boolean = false>(options: Options<PublicCertificationControllerUpdateCertificationTextData, ThrowOnError>) => (options.client ?? client).put<PublicCertificationControllerUpdateCertificationTextResponses, unknown, ThrowOnError>({
    url: '/public-signing/certification-text',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all global document templates
 */
export const documentTemplatesControllerList = <ThrowOnError extends boolean = false>(options?: Options<DocumentTemplatesControllerListData, ThrowOnError>) => (options?.client ?? client).get<DocumentTemplatesControllerListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates',
    ...options
});

/**
 * Create a global document template
 */
export const documentTemplatesControllerCreate = <ThrowOnError extends boolean = false>(options: Options<DocumentTemplatesControllerCreateData, ThrowOnError>) => (options.client ?? client).post<DocumentTemplatesControllerCreateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-delete a global document template
 */
export const documentTemplatesControllerSoftDelete = <ThrowOnError extends boolean = false>(options: Options<DocumentTemplatesControllerSoftDeleteData, ThrowOnError>) => (options.client ?? client).delete<DocumentTemplatesControllerSoftDeleteResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates/{id}',
    ...options
});

/**
 * Get a global document template by id
 */
export const documentTemplatesControllerGetById = <ThrowOnError extends boolean = false>(options: Options<DocumentTemplatesControllerGetByIdData, ThrowOnError>) => (options.client ?? client).get<DocumentTemplatesControllerGetByIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates/{id}',
    ...options
});

/**
 * Update a global document template
 */
export const documentTemplatesControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<DocumentTemplatesControllerUpdateData, ThrowOnError>) => (options.client ?? client).put<DocumentTemplatesControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get which deals a global document template is available to
 */
export const documentTemplatesControllerGetAvailability = <ThrowOnError extends boolean = false>(options: Options<DocumentTemplatesControllerGetAvailabilityData, ThrowOnError>) => (options.client ?? client).get<DocumentTemplatesControllerGetAvailabilityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates/{id}/availability',
    ...options
});

/**
 * Replace which deals a global document template is available to
 */
export const documentTemplatesControllerSetAvailability = <ThrowOnError extends boolean = false>(options: Options<DocumentTemplatesControllerSetAvailabilityData, ThrowOnError>) => (options.client ?? client).put<DocumentTemplatesControllerSetAvailabilityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates/{id}/availability',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List field bindings for a global document template
 */
export const documentTemplatesControllerGetFieldBindings = <ThrowOnError extends boolean = false>(options: Options<DocumentTemplatesControllerGetFieldBindingsData, ThrowOnError>) => (options.client ?? client).get<DocumentTemplatesControllerGetFieldBindingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates/{id}/field-bindings',
    ...options
});

/**
 * Replace field bindings for a global document template
 */
export const documentTemplatesControllerUpdateFieldBindings = <ThrowOnError extends boolean = false>(options: Options<DocumentTemplatesControllerUpdateFieldBindingsData, ThrowOnError>) => (options.client ?? client).put<DocumentTemplatesControllerUpdateFieldBindingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates/{id}/field-bindings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List bindable data points with sample values
 */
export const documentTemplatesControllerGetFieldBindingCatalogue = <ThrowOnError extends boolean = false>(options?: Options<DocumentTemplatesControllerGetFieldBindingCatalogueData, ThrowOnError>) => (options?.client ?? client).get<DocumentTemplatesControllerGetFieldBindingCatalogueResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates/{id}/field-binding-catalogue',
    ...options
});

/**
 * Render a template with sample values filled in
 */
export const documentTemplatesControllerPreviewFieldBindings = <ThrowOnError extends boolean = false>(options: Options<DocumentTemplatesControllerPreviewFieldBindingsData, ThrowOnError>) => (options.client ?? client).post<DocumentTemplatesControllerPreviewFieldBindingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates/{id}/field-bindings/preview',
    ...options
});

/**
 * Get the editable document for a Word document template
 */
export const documentTemplatesControllerGetDocxFlowDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentTemplatesControllerGetDocxFlowDocumentData, ThrowOnError>) => (options.client ?? client).get<DocumentTemplatesControllerGetDocxFlowDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates/{id}/docx-document',
    ...options
});

/**
 * Save an edited Word document template
 */
export const documentTemplatesControllerSaveDocxFlowDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentTemplatesControllerSaveDocxFlowDocumentData, ThrowOnError>) => (options.client ?? client).put<DocumentTemplatesControllerSaveDocxFlowDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates/{id}/docx-document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render a Word document template against sample data
 */
export const documentTemplatesControllerRenderDocxTemplate = <ThrowOnError extends boolean = false>(options: Options<DocumentTemplatesControllerRenderDocxTemplateData, ThrowOnError>) => (options.client ?? client).post<DocumentTemplatesControllerRenderDocxTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-templates/{id}/docx-render',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List published document templates available to this deal
 */
export const dealDocumentTemplatesControllerList = <ThrowOnError extends boolean = false>(options: Options<DealDocumentTemplatesControllerListData, ThrowOnError>) => (options.client ?? client).get<DealDocumentTemplatesControllerListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-templates',
    ...options
});

/**
 * Get pdf forms assigned to project
 */
export const preFillableFormsControllerGetTemplatesForProject = <ThrowOnError extends boolean = false>(options?: Options<PreFillableFormsControllerGetTemplatesForProjectData, ThrowOnError>) => (options?.client ?? client).get<PreFillableFormsControllerGetTemplatesForProjectResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/pre-fillable-forms/templates-for-project',
    ...options
});

/**
 * Get generatable document templates
 */
export const generatableDocumentsControllerGetAllGeneratableDocumentsTemplates = <ThrowOnError extends boolean = false>(options?: Options<GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesData, ThrowOnError>) => (options?.client ?? client).get<GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/templates',
    ...options
});

/**
 * Get generatable document template details
 */
export const generatableDocumentsControllerGetGeneratableDocumentsTemplate = <ThrowOnError extends boolean = false>(options: Options<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateData, ThrowOnError>) => (options.client ?? client).get<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/template/{id}',
    ...options
});

/**
 * Update generatable document template
 */
export const generatableDocumentsControllerUpdateGeneratableDocumentTemplate = <ThrowOnError extends boolean = false>(options: Options<GeneratableDocumentsControllerUpdateGeneratableDocumentTemplateData, ThrowOnError>) => (options.client ?? client).post<GeneratableDocumentsControllerUpdateGeneratableDocumentTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/template/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get generatable document template assigned projects
 */
export const generatableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjects = <ThrowOnError extends boolean = false>(options: Options<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsData, ThrowOnError>) => (options.client ?? client).get<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/template/{id}/assigned-projects',
    ...options
});

/**
 * Get generatable document template smart fields
 */
export const generatableDocumentsControllerGetGeneratableDocumentsTemplateSmartFields = <ThrowOnError extends boolean = false>(options: Options<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsData, ThrowOnError>) => (options.client ?? client).get<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/template/{id}/smart-fields',
    ...options
});

/**
 * Update generatable document template smart fields
 */
export const generatableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFields = <ThrowOnError extends boolean = false>(options: Options<GeneratableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFieldsData, ThrowOnError>) => (options.client ?? client).put<GeneratableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFieldsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/template/smart-fields',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign project to generatable document template
 */
export const generatableDocumentsControllerAssignProjectToGeneratableDocumentTemplate = <ThrowOnError extends boolean = false>(options: Options<GeneratableDocumentsControllerAssignProjectToGeneratableDocumentTemplateData, ThrowOnError>) => (options.client ?? client).post<GeneratableDocumentsControllerAssignProjectToGeneratableDocumentTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/template/assign-project',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unassign project from generatable document template
 */
export const generatableDocumentsControllerUnassignProjectToGeneratableDocumentTemplate = <ThrowOnError extends boolean = false>(options: Options<GeneratableDocumentsControllerUnassignProjectToGeneratableDocumentTemplateData, ThrowOnError>) => (options.client ?? client).post<GeneratableDocumentsControllerUnassignProjectToGeneratableDocumentTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/template/unassign-project',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const generatableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByType = <ThrowOnError extends boolean = false>(options?: Options<GeneratableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeData, ThrowOnError>) => (options?.client ?? client).get<GeneratableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/file/{type}',
    ...options
});

/**
 * Get GeneratableDocumentsTemplate custom details definitions
 */
export const generatableDocumentsControllerGetGdwtCustomDetailsDefinitions = <ThrowOnError extends boolean = false>(options: Options<GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsData, ThrowOnError>) => (options.client ?? client).get<GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/template/{id}/custom-details-definitions',
    ...options
});

/**
 * Delete custom details definitions
 */
export const generatableDocumentsControllerDeleteCustomDetailsDefinitions = <ThrowOnError extends boolean = false>(options: Options<GeneratableDocumentsControllerDeleteCustomDetailsDefinitionsData, ThrowOnError>) => (options.client ?? client).delete<GeneratableDocumentsControllerDeleteCustomDetailsDefinitionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/custom-details-definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create custom detail definition for GeneratableDocumentsTemplate
 */
export const generatableDocumentsControllerCreateGdwtCustomDetailsDefinitions = <ThrowOnError extends boolean = false>(options: Options<GeneratableDocumentsControllerCreateGdwtCustomDetailsDefinitionsData, ThrowOnError>) => (options.client ?? client).post<GeneratableDocumentsControllerCreateGdwtCustomDetailsDefinitionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/custom-details-definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update custom details definitions for GeneratableDocumentsTemplate
 */
export const generatableDocumentsControllerUpdateGdwtCustomDetailsDefinitions = <ThrowOnError extends boolean = false>(options: Options<GeneratableDocumentsControllerUpdateGdwtCustomDetailsDefinitionsData, ThrowOnError>) => (options.client ?? client).put<GeneratableDocumentsControllerUpdateGdwtCustomDetailsDefinitionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/generatable-documents/custom-details-definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all pre-fillable form templates
 */
export const preFillableFormTemplateControllerGetAllPreFillableFormTemplates = <ThrowOnError extends boolean = false>(options?: Options<PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesData, ThrowOnError>) => (options?.client ?? client).get<PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/pre-fillable-form-template/list',
    ...options
});

/**
 * List the organisations a pre-fillable form can be assigned to
 */
export const preFillableFormTemplateControllerGetOrganizationOptions = <ThrowOnError extends boolean = false>(options?: Options<PreFillableFormTemplateControllerGetOrganizationOptionsData, ThrowOnError>) => (options?.client ?? client).get<PreFillableFormTemplateControllerGetOrganizationOptionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/pre-fillable-form-template/organizations',
    ...options
});

/**
 * Upload pre-fillable form template file
 */
export const preFillableFormTemplateControllerUploadPreFillableFormTemplateFile = <ThrowOnError extends boolean = false>(options?: Options<PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileData, ThrowOnError>) => (options?.client ?? client).post<PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/pre-fillable-form-template/upload-file',
    ...options
});

/**
 * Create pre-fillable form template
 */
export const preFillableFormTemplateControllerCreatePreFillableFormTemplate = <ThrowOnError extends boolean = false>(options: Options<PreFillableFormTemplateControllerCreatePreFillableFormTemplateData, ThrowOnError>) => (options.client ?? client).post<PreFillableFormTemplateControllerCreatePreFillableFormTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/pre-fillable-form-template/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete custom details definitions
 */
export const preFillableFormTemplateControllerDeleteCustomDetailsDefinitions = <ThrowOnError extends boolean = false>(options: Options<PreFillableFormTemplateControllerDeleteCustomDetailsDefinitionsData, ThrowOnError>) => (options.client ?? client).delete<PreFillableFormTemplateControllerDeleteCustomDetailsDefinitionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/pre-fillable-form-template/custom-details-definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create custom detail definition for pre-fillable form template
 */
export const preFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplate = <ThrowOnError extends boolean = false>(options: Options<PreFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplateData, ThrowOnError>) => (options.client ?? client).post<PreFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/pre-fillable-form-template/custom-details-definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update custom details definitions
 */
export const preFillableFormTemplateControllerUpdateCustomDetailsDefinitions = <ThrowOnError extends boolean = false>(options: Options<PreFillableFormTemplateControllerUpdateCustomDetailsDefinitionsData, ThrowOnError>) => (options.client ?? client).put<PreFillableFormTemplateControllerUpdateCustomDetailsDefinitionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/pre-fillable-form-template/custom-details-definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update pre-fillable form template
 */
export const preFillableFormTemplateControllerUpdatePreFillableFormTemplate = <ThrowOnError extends boolean = false>(options: Options<PreFillableFormTemplateControllerUpdatePreFillableFormTemplateData, ThrowOnError>) => (options.client ?? client).post<PreFillableFormTemplateControllerUpdatePreFillableFormTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/pre-fillable-form-template/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft delete pre-fillable form template with related data
 */
export const preFillableFormTemplateControllerSoftDeletePreFillableFormTemplate = <ThrowOnError extends boolean = false>(options: Options<PreFillableFormTemplateControllerSoftDeletePreFillableFormTemplateData, ThrowOnError>) => (options.client ?? client).delete<PreFillableFormTemplateControllerSoftDeletePreFillableFormTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/pre-fillable-form-template/soft-delete/{id}',
    ...options
});

/**
 * Get pre-fillable form template data by id
 */
export const preFillableFormTemplateControllerGetPreFillableFormTemplate = <ThrowOnError extends boolean = false>(options: Options<PreFillableFormTemplateControllerGetPreFillableFormTemplateData, ThrowOnError>) => (options.client ?? client).get<PreFillableFormTemplateControllerGetPreFillableFormTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/pre-fillable-form-template/{id}',
    ...options
});

/**
 * Get pre-fillable form template custom details definitions
 */
export const preFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitions = <ThrowOnError extends boolean = false>(options: Options<PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsData, ThrowOnError>) => (options.client ?? client).get<PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/godmode/pre-fillable-form-template/{id}/custom-details-definitions',
    ...options
});

/**
 * Get loans definitions for all mips in deal
 */
export const securityControllerGetLoanDefinitionsForDeal = <ThrowOnError extends boolean = false>(options?: Options<SecurityControllerGetLoanDefinitionsForDealData, ThrowOnError>) => (options?.client ?? client).get<SecurityControllerGetLoanDefinitionsForDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/loan-definitions',
    ...options
});

/**
 * Get all securities for deal
 */
export const securityControllerGetSecuritiesByDealId = <ThrowOnError extends boolean = false>(options?: Options<SecurityControllerGetSecuritiesByDealIdData, ThrowOnError>) => (options?.client ?? client).get<SecurityControllerGetSecuritiesByDealIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/deal',
    ...options
});

/**
 * Get security by id
 */
export const securityControllerGetSecurity = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerGetSecurityData, ThrowOnError>) => (options.client ?? client).get<SecurityControllerGetSecurityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}',
    ...options
});

/**
 * Get securities data for mip
 */
export const securityControllerGetSecuritiesDataForMip = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerGetSecuritiesDataForMipData, ThrowOnError>) => (options.client ?? client).get<SecurityControllerGetSecuritiesDataForMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/mip-securities/{mipId}',
    ...options
});

/**
 * Get securities for person id
 */
export const securityControllerGetPersonSecurities = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerGetPersonSecuritiesData, ThrowOnError>) => (options.client ?? client).post<SecurityControllerGetPersonSecuritiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/person-securities/{personId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Does person have any securities
 */
export const securityControllerDoesPersonHaveSecurities = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerDoesPersonHaveSecuritiesData, ThrowOnError>) => (options.client ?? client).get<SecurityControllerDoesPersonHaveSecuritiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/does-person-have-securities/{personId}',
    ...options
});

/**
 * Securities with features and ranks for person
 */
export const securityControllerGetPersonSecuritiesWithFeaturesAndRanks = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksData, ThrowOnError>) => (options.client ?? client).get<SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/security-ranks/{personId}',
    ...options
});

/**
 * Check if we have InvestmentWorkflow and how many
 */
export const securityControllerIsSecuritiesUsedInAnyMip = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerIsSecuritiesUsedInAnyMipData, ThrowOnError>) => (options.client ?? client).post<SecurityControllerIsSecuritiesUsedInAnyMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/is-securities-used-in-any-mip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create security
 */
export const securityControllerCreateSecurity = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerCreateSecurityData, ThrowOnError>) => (options.client ?? client).post<SecurityControllerCreateSecurityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update security
 */
export const securityControllerUpdateSecurity = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerUpdateSecurityData, ThrowOnError>) => (options.client ?? client).put<SecurityControllerUpdateSecurityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk create securities
 */
export const securityControllerBulkCreateSecurities = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerBulkCreateSecuritiesData, ThrowOnError>) => (options.client ?? client).post<SecurityControllerBulkCreateSecuritiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk update securities
 */
export const securityControllerBulkUpdateSecurities = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerBulkUpdateSecuritiesData, ThrowOnError>) => (options.client ?? client).put<SecurityControllerBulkUpdateSecuritiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk update tracked securities
 */
export const securityControllerBulkUpdateTrackedSecurities = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerBulkUpdateTrackedSecuritiesData, ThrowOnError>) => (options.client ?? client).put<SecurityControllerBulkUpdateTrackedSecuritiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/tracking',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk delete tracked securities
 */
export const securityControllerBulkDeleteTrackedSecurities = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerBulkDeleteTrackedSecuritiesData, ThrowOnError>) => (options.client ?? client).delete<SecurityControllerBulkDeleteTrackedSecuritiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}/tracking/{trackingSecurityIssuerId}',
    ...options
});

/**
 * Update currency for all securities issued by person
 */
export const securityControllerUpdateCurrencyForPersonSecurities = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerUpdateCurrencyForPersonSecuritiesData, ThrowOnError>) => (options.client ?? client).put<SecurityControllerUpdateCurrencyForPersonSecuritiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{personId}/currency',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete security
 */
export const securityControllerSoftDeleteSecurity = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerSoftDeleteSecurityData, ThrowOnError>) => (options.client ?? client).delete<SecurityControllerSoftDeleteSecurityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/soft-delete-one/{securityId}',
    ...options
});

/**
 * Bulk delete securities
 */
export const securityControllerBulkSoftDeleteSecurities = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerBulkSoftDeleteSecuritiesData, ThrowOnError>) => (options.client ?? client).delete<SecurityControllerBulkSoftDeleteSecuritiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/bulk-soft-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download excel file with securities
 */
export const securityControllerDownloadExcel = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerDownloadExcelData, ThrowOnError>) => (options.client ?? client).post<SecurityControllerDownloadExcelResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/download-excel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update authorised capital on security
 */
export const securityControllerUpdateSecurityAuthorisedCapital = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerUpdateSecurityAuthorisedCapitalData, ThrowOnError>) => (options.client ?? client).put<SecurityControllerUpdateSecurityAuthorisedCapitalResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}/authorised-capital',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update participation threshold on security
 */
export const securityControllerUpdateSecurityParticipationThreshold = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerUpdateSecurityParticipationThresholdData, ThrowOnError>) => (options.client ?? client).put<SecurityControllerUpdateSecurityParticipationThresholdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}/participation-threshold',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get nominal value for security
 */
export const securityControllerGetSecurityNominalValue = <ThrowOnError extends boolean = false>(options: Options<SecurityControllerGetSecurityNominalValueData, ThrowOnError>) => (options.client ?? client).get<SecurityControllerGetSecurityNominalValueResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}/nominal-value',
    ...options
});

/**
 * Delete exchange rights for security
 */
export const securityExchangeRightsControllerSoftDeleteSecurityExchangeRights = <ThrowOnError extends boolean = false>(options: Options<SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsData, ThrowOnError>) => (options.client ?? client).delete<SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}/exchange-rights',
    ...options
});

/**
 * Create or update exchange rights for security
 */
export const securityExchangeRightsControllerCreateOrUpdateSecurityExchangeRights = <ThrowOnError extends boolean = false>(options: Options<SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsData, ThrowOnError>) => (options.client ?? client).post<SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}/exchange-rights',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete interest definition for security
 */
export const securityInterestRedemptionControllerSoftDeleteSecurityInterestDefinition = <ThrowOnError extends boolean = false>(options: Options<SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionData, ThrowOnError>) => (options.client ?? client).delete<SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}/interest-definition',
    ...options
});

/**
 * Create or update interest definition for security
 */
export const securityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinition = <ThrowOnError extends boolean = false>(options: Options<SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionData, ThrowOnError>) => (options.client ?? client).post<SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}/interest-definition',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete redemption rights for security
 */
export const securityInterestRedemptionControllerSoftDeleteSecurityRedemptionRights = <ThrowOnError extends boolean = false>(options: Options<SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsData, ThrowOnError>) => (options.client ?? client).delete<SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}/redemption-rights',
    ...options
});

/**
 * Create or update redemption rights for security
 */
export const securityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRights = <ThrowOnError extends boolean = false>(options: Options<SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsData, ThrowOnError>) => (options.client ?? client).post<SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}/redemption-rights',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete catch up rights for security
 */
export const securityCatchUpRightsControllerSoftDeleteSecurityCatchUpRights = <ThrowOnError extends boolean = false>(options: Options<SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsData, ThrowOnError>) => (options.client ?? client).delete<SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}/catch-up-rights',
    ...options
});

/**
 * Create or update catch up rights for security
 */
export const securityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRights = <ThrowOnError extends boolean = false>(options: Options<SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsData, ThrowOnError>) => (options.client ?? client).post<SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security/{securityId}/catch-up-rights',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete the liquidation preference for a security
 */
export const securityLiquidationPreferenceControllerSoftDelete = <ThrowOnError extends boolean = false>(options: Options<SecurityLiquidationPreferenceControllerSoftDeleteData, ThrowOnError>) => (options.client ?? client).delete<SecurityLiquidationPreferenceControllerSoftDeleteResponses, unknown, ThrowOnError>({ url: '/securities/{securityId}/liquidation-preference', ...options });

/**
 * Get the liquidation preference for a security
 */
export const securityLiquidationPreferenceControllerGet = <ThrowOnError extends boolean = false>(options: Options<SecurityLiquidationPreferenceControllerGetData, ThrowOnError>) => (options.client ?? client).get<SecurityLiquidationPreferenceControllerGetResponses, unknown, ThrowOnError>({ url: '/securities/{securityId}/liquidation-preference', ...options });

/**
 * Create or update the liquidation preference for a security
 */
export const securityLiquidationPreferenceControllerCreateOrUpdate = <ThrowOnError extends boolean = false>(options: Options<SecurityLiquidationPreferenceControllerCreateOrUpdateData, ThrowOnError>) => (options.client ?? client).post<SecurityLiquidationPreferenceControllerCreateOrUpdateResponses, unknown, ThrowOnError>({
    url: '/securities/{securityId}/liquidation-preference',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Release workflow progress updates
 */
export const investorInvestmentWorkflowControllerGetReleaseWorkflowStatus = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusData, ThrowOnError>) => (options.client ?? client).get<InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/release-workflow-progress/{handlerId}',
    ...options
});

/**
 * Investment details — summary (header + sidebar)
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsSummary = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryData, ThrowOnError>) => (options.client ?? client).get<InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/summary',
    ...options
});

/**
 * Investment details — allocations
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsAllocations = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsData, ThrowOnError>) => (options.client ?? client).get<InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/allocations',
    ...options
});

/**
 * Investment details — add single allocation
 */
export const investorInvestmentWorkflowControllerAddInvestmentAllocation = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerAddInvestmentAllocationData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerAddInvestmentAllocationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/allocations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Investment details — legal documents
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocuments = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsData, ThrowOnError>) => (options.client ?? client).get<InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/legal-documents',
    ...options
});

/**
 * Investment details — manageable master documents
 */
export const investorInvestmentWorkflowControllerGetManageableLegalDocuments = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsData, ThrowOnError>) => (options.client ?? client).get<InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/legal-documents/manageable',
    ...options
});

/**
 * Investment details — toggle a master legal document on/off
 */
export const investorInvestmentWorkflowControllerToggleLegalDocument = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerToggleLegalDocumentData, ThrowOnError>) => (options.client ?? client).put<InvestorInvestmentWorkflowControllerToggleLegalDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/legal-documents/manageable/{templateId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Investment details — bank information
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsBankInformation = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationData, ThrowOnError>) => (options.client ?? client).get<InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/bank-information',
    ...options
});

/**
 * Investment details — other data
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsOtherData = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataData, ThrowOnError>) => (options.client ?? client).get<InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/other-data',
    ...options
});

/**
 * Investment details — tax compliance
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsTaxCompliance = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceData, ThrowOnError>) => (options.client ?? client).get<InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/tax-compliance',
    ...options
});

/**
 * Investment details — KYC status
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsKycStatus = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusData, ThrowOnError>) => (options.client ?? client).get<InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/kyc-status',
    ...options
});

/**
 * Investment details — start the investment workflow
 */
export const investorInvestmentWorkflowControllerStartInvestment = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerStartInvestmentData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerStartInvestmentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/start',
    ...options
});

/**
 * Investment details — approve the investment (Open → Definition Complete)
 */
export const investorInvestmentWorkflowControllerApproveInvestment = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerApproveInvestmentData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerApproveInvestmentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/approve',
    ...options
});

/**
 * Investment details — move the investment back to Open
 */
export const investorInvestmentWorkflowControllerMakeDraft = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerMakeDraftData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerMakeDraftResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/make-draft',
    ...options
});

/**
 * Investment details — set target start / completion dates
 */
export const investorInvestmentWorkflowControllerSetInvestmentDetailsTargetDates = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/target-dates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Investment details — set investment vehicle (PIV)
 */
export const investorInvestmentWorkflowControllerSetInvestmentDetailsPiv = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/piv',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Investment details — set selected bank account
 */
export const investorInvestmentWorkflowControllerSetInvestmentDetailsBankAccount = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/bank-account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk release InvestmentWorkflow
 */
export const investorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflow = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/bulk-release-investment-workflow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Release single InvestmentWorkflow
 */
export const investorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflow = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflowData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflowResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/release-single-investment-workflow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP investments
 */
export const investorInvestmentWorkflowControllerGetInvestmentsForMip = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerGetInvestmentsForMipData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerGetInvestmentsForMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/mip-investments/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the ids of every investment the list matches, in list order, ignoring paging
 */
export const investorInvestmentWorkflowControllerGetOrderedInvestmentIds = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/mip-investments/ordered-ids',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk update the expected transaction type on investment allocations
 */
export const investorInvestmentWorkflowControllerBulkUpdateExpectedTransactionType = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/mip-investments/bulk-update-expected-transaction-type',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download investments excel
 */
export const investorInvestmentWorkflowControllerDownloadExcel = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerDownloadExcelData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerDownloadExcelResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/mip-investments/download-excel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Investment details — remove single allocation
 */
export const investorInvestmentWorkflowControllerRemoveInvestmentAllocation = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerRemoveInvestmentAllocationData, ThrowOnError>) => (options.client ?? client).delete<InvestorInvestmentWorkflowControllerRemoveInvestmentAllocationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/allocations/{allocationId}',
    ...options
});

/**
 * Investment details — update single allocation
 */
export const investorInvestmentWorkflowControllerUpdateInvestmentAllocation = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationData, ThrowOnError>) => (options.client ?? client).patch<InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/allocations/{allocationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Investment details — add a single loan
 */
export const investorInvestmentWorkflowControllerAddInvestmentLoan = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerAddInvestmentLoanData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerAddInvestmentLoanResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/loan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Investment details — remove single loan (soft-delete)
 */
export const investorInvestmentWorkflowControllerRemoveInvestmentLoan = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerRemoveInvestmentLoanData, ThrowOnError>) => (options.client ?? client).delete<InvestorInvestmentWorkflowControllerRemoveInvestmentLoanResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/loan/{loanId}',
    ...options
});

/**
 * Investment details — update single loan
 */
export const investorInvestmentWorkflowControllerUpdateInvestmentLoan = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerUpdateInvestmentLoanData, ThrowOnError>) => (options.client ?? client).patch<InvestorInvestmentWorkflowControllerUpdateInvestmentLoanResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/loan/{loanId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk upsert share associations
 */
export const investorInvestmentWorkflowControllerUpsertShareAssociations = <ThrowOnError extends boolean = false>(options: Options<InvestorInvestmentWorkflowControllerUpsertShareAssociationsData, ThrowOnError>) => (options.client ?? client).post<InvestorInvestmentWorkflowControllerUpsertShareAssociationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor-investment-workflow/bulk-update-allocations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP investors data list
 */
export const investorControllerGetMipInvestorsList = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetMipInvestorsListData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerGetMipInvestorsListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the ids of every investor the list matches, in list order, ignoring paging
 */
export const investorControllerGetMipInvestorsOrderedIds = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetMipInvestorsOrderedIdsData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerGetMipInvestorsOrderedIdsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/ordered-ids',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP investors data for send modal
 */
export const investorControllerGetMipInvestorsDataForSendModal = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetMipInvestorsDataForSendModalData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerGetMipInvestorsDataForSendModalResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/invite/investors-data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP selected investors data
 */
export const investorControllerGetMipSelectedInvestorsData = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetMipSelectedInvestorsDataData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerGetMipSelectedInvestorsDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/selected-investors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP investors ids
 */
export const investorControllerGetMipInvestorsIds = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetMipInvestorsIdsData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerGetMipInvestorsIdsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/ids',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP investor by id
 */
export const investorControllerGetMipInvestorById = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetMipInvestorByIdData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetMipInvestorByIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/get-investor-by-id/{id}',
    ...options
});

/**
 * Get investor investments and transactions by investor id
 */
export const investorControllerGetInvestorInvestmentsAndTransactions = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetInvestorInvestmentsAndTransactionsData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetInvestorInvestmentsAndTransactionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/get-investments-transactions/{investorId}',
    ...options
});

/**
 * Get MIP investor document workflow list by investor id
 */
export const investorControllerGetMipInvestorDocumentWorkflowListById = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetMipInvestorDocumentWorkflowListByIdData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetMipInvestorDocumentWorkflowListByIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/{investorId}/document-workflow',
    ...options
});

/**
 * Send investor invites
 */
export const investorControllerSendInvites = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerSendInvitesData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerSendInvitesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP investors securities list
 */
export const investorControllerGetMipInvestorsSecuritiesListData = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetMipInvestorsSecuritiesListDataData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerGetMipInvestorsSecuritiesListDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/securities-list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP Joiner Investors template xlsx
 */
export const investorControllerGetMipDraftJoinerInvestorTemplate = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetMipDraftJoinerInvestorTemplateData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerGetMipDraftJoinerInvestorTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/joiner/template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post file with investors and securities
 */
export const investorControllerPostMipDraftJoinerInvestorTemplate = <ThrowOnError extends boolean = false>(options?: Options<InvestorControllerPostMipDraftJoinerInvestorTemplateData, ThrowOnError>) => (options?.client ?? client).post<InvestorControllerPostMipDraftJoinerInvestorTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/joiner/parse-template',
    ...options
});

/**
 * Get MIP Leaver Investors template xlsx
 */
export const investorControllerGetMipDraftLeaverInvestorTemplate = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetMipDraftLeaverInvestorTemplateData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerGetMipDraftLeaverInvestorTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/leaver/template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post file with investors, securities & loans
 */
export const investorControllerPostMipDraftJLeaverInvestorTemplate = <ThrowOnError extends boolean = false>(options?: Options<InvestorControllerPostMipDraftJLeaverInvestorTemplateData, ThrowOnError>) => (options?.client ?? client).post<InvestorControllerPostMipDraftJLeaverInvestorTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/leaver/parse-template',
    ...options
});

/**
 * Download xlsx with data for provided investors
 */
export const investorControllerDownloadInvestorsData = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerDownloadInvestorsDataData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerDownloadInvestorsDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/bulk-download',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate excel file for all provided investors and upload it to S3
 */
export const investorControllerStartDownloadInvestorsDataWorkflow = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerStartDownloadInvestorsDataWorkflowData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerStartDownloadInvestorsDataWorkflowResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/bulk-generate-file',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke InvestmentWorkflow
 */
export const investorControllerPostRevokeTsa = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerPostRevokeTsaData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerPostRevokeTsaResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/revoke/{investmentWorkflowId}',
    ...options
});

/**
 * Bulk revoke InvestmentWorkflows
 */
export const investorControllerPostBulkRevokeTsa = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerPostBulkRevokeTsaData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerPostBulkRevokeTsaResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/bulk-revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove investor
 */
export const investorControllerPostRemoveInvestor = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerPostRemoveInvestorData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerPostRemoveInvestorResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/remove-investor/{investorId}',
    ...options
});

/**
 * Update the investor's custom field values
 */
export const investorControllerPutInvestorCustomDetails = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerPutInvestorCustomDetailsData, ThrowOnError>) => (options.client ?? client).put<InvestorControllerPutInvestorCustomDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/{investorId}/custom-details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get vesting data for a specific security of an investor
 */
export const investorControllerGetSecurityVestingData = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetSecurityVestingDataData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetSecurityVestingDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/vesting/{investorId}/{securityId}',
    ...options
});

/**
 * Get list of investor valuations
 */
export const investorControllerGetInvestorInvestmentValuations = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetInvestorInvestmentValuationsData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetInvestorInvestmentValuationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/valuations/{id}',
    ...options
});

/**
 * Get an investment vehicle's aggregated holdings and loans
 */
export const investorControllerGetInvestmentVehicleValuations = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetInvestmentVehicleValuationsData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetInvestmentVehicleValuationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/investment-vehicle/{personId}/valuations',
    ...options
});

/**
 * Get the people related to an investment vehicle
 */
export const investorControllerGetInvestmentVehicleRelatedPeople = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetInvestmentVehicleRelatedPeopleData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetInvestmentVehicleRelatedPeopleResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/investment-vehicle/{personId}/related-people',
    ...options
});

/**
 * An investment vehicle's holdings, one row per security per investor held for
 */
export const investorControllerGetInvestmentVehicleHoldings = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetInvestmentVehicleHoldingsData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetInvestmentVehicleHoldingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/investment-vehicle/{personId}/holdings',
    ...options
});

/**
 * Quick link counts for an investment vehicle, across its investors
 */
export const investorControllerGetInvestmentVehicleQuickLinks = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetInvestmentVehicleQuickLinksData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetInvestmentVehicleQuickLinksResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/investment-vehicle/{personId}/quick-links',
    ...options
});

/**
 * Get active and total counts behind the investor quick links
 */
export const investorControllerGetInvestorQuickLinks = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetInvestorQuickLinksData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetInvestorQuickLinksResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/quick-links/{id}',
    ...options
});

/**
 * Get the investor open journeys, deduplicated
 */
export const investorControllerGetInvestorJourneys = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetInvestorJourneysData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetInvestorJourneysResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/journeys/{id}',
    ...options
});

/**
 * Get holdings by or for an investor, including via vehicles
 */
export const investorControllerGetInvestorHoldings = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetInvestorHoldingsData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetInvestorHoldingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/holdings/{id}',
    ...options
});

/**
 * The acquisitions and disposals behind one of an investor's holdings
 */
export const investorControllerGetInvestorHoldingTransactions = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerGetInvestorHoldingTransactionsData, ThrowOnError>) => (options.client ?? client).get<InvestorControllerGetInvestorHoldingTransactionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/holdings/{id}/transactions',
    ...options
});

/**
 * Get MIP Investor names for filtering
 */
export const investorControllerGetMipInvestorNamesForFiltering = <ThrowOnError extends boolean = false>(options?: Options<InvestorControllerGetMipInvestorNamesForFilteringData, ThrowOnError>) => (options?.client ?? client).get<InvestorControllerGetMipInvestorNamesForFilteringResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/names/filtering',
    ...options
});

/**
 * Get MIP investment vehicle names for filtering
 */
export const investorControllerGetMipInvestmentVehicleNamesForFiltering = <ThrowOnError extends boolean = false>(options?: Options<InvestorControllerGetMipInvestmentVehicleNamesForFilteringData, ThrowOnError>) => (options?.client ?? client).get<InvestorControllerGetMipInvestmentVehicleNamesForFilteringResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/investment-vehicles/names/filtering',
    ...options
});

/**
 * Request KYC for selected investors
 */
export const investorControllerRequestKyc = <ThrowOnError extends boolean = false>(options: Options<InvestorControllerRequestKycData, ThrowOnError>) => (options.client ?? client).post<InvestorControllerRequestKycResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor/request-kyc',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post file with investors and securities
 */
export const investorDraftControllerPostMipDraftInvestorTemplate = <ThrowOnError extends boolean = false>(options?: Options<InvestorDraftControllerPostMipDraftInvestorTemplateData, ThrowOnError>) => (options?.client ?? client).post<InvestorDraftControllerPostMipDraftInvestorTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor-draft/template',
    ...options
});

/**
 * Get MIP Draft Investors data from DB
 */
export const investorDraftControllerGetMipInvestors = <ThrowOnError extends boolean = false>(options?: Options<InvestorDraftControllerGetMipInvestorsData, ThrowOnError>) => (options?.client ?? client).get<InvestorDraftControllerGetMipInvestorsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor-draft',
    ...options
});

/**
 * Update MIP Draft Investors DB, removes all previous data
 */
export const investorDraftControllerPostMipDraftInvestorData = <ThrowOnError extends boolean = false>(options: Options<InvestorDraftControllerPostMipDraftInvestorDataData, ThrowOnError>) => (options.client ?? client).put<InvestorDraftControllerPostMipDraftInvestorDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor-draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP payments
 */
export const paymentControllerGetStatus = <ThrowOnError extends boolean = false>(options?: Options<PaymentControllerGetStatusData, ThrowOnError>) => (options?.client ?? client).get<PaymentControllerGetStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/payment',
    ...options
});

/**
 * Bulk update MIP Payment status
 */
export const paymentControllerBulkUpdate = <ThrowOnError extends boolean = false>(options: Options<PaymentControllerBulkUpdateData, ThrowOnError>) => (options.client ?? client).patch<PaymentControllerBulkUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/payment/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update MIP Payment status
 */
export const paymentControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<PaymentControllerUpdateData, ThrowOnError>) => (options.client ?? client).patch<PaymentControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/payment/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download xlsx with mip payments
 */
export const paymentControllerDownloadMipPayments = <ThrowOnError extends boolean = false>(options?: Options<PaymentControllerDownloadMipPaymentsData, ThrowOnError>) => (options?.client ?? client).get<PaymentControllerDownloadMipPaymentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/payment/bulk-download',
    ...options
});

/**
 * Get MIP Loans Definition
 */
export const loanDefinitionControllerGetLoansDefinitionByMipId = <ThrowOnError extends boolean = false>(options?: Options<LoanDefinitionControllerGetLoansDefinitionByMipIdData, ThrowOnError>) => (options?.client ?? client).get<LoanDefinitionControllerGetLoansDefinitionByMipIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/loan-definition',
    ...options
});

/**
 * Create MIP Loans Definition
 */
export const loanDefinitionControllerCreateLoanDefinitions = <ThrowOnError extends boolean = false>(options: Options<LoanDefinitionControllerCreateLoanDefinitionsData, ThrowOnError>) => (options.client ?? client).post<LoanDefinitionControllerCreateLoanDefinitionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/loan-definition',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete MIP Loan Definition
 */
export const loanDefinitionControllerDeleteLoanDefinition = <ThrowOnError extends boolean = false>(options?: Options<LoanDefinitionControllerDeleteLoanDefinitionData, ThrowOnError>) => (options?.client ?? client).delete<LoanDefinitionControllerDeleteLoanDefinitionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/loan-definition/{id}',
    ...options
});

/**
 * Update MIP Loan Definition
 */
export const loanDefinitionControllerUpdateLoanDefinition = <ThrowOnError extends boolean = false>(options: Options<LoanDefinitionControllerUpdateLoanDefinitionData, ThrowOnError>) => (options.client ?? client).put<LoanDefinitionControllerUpdateLoanDefinitionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/loan-definition/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive or unarchive a custom detail
 */
export const customDetailControllerToggleArchived = <ThrowOnError extends boolean = false>(options: Options<CustomDetailControllerToggleArchivedData, ThrowOnError>) => (options.client ?? client).put<CustomDetailControllerToggleArchivedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/custom-detail/{customDetailId}/archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP CustomDetails
 */
export const customDetailControllerGetAllMipCustomDetail = <ThrowOnError extends boolean = false>(options?: Options<CustomDetailControllerGetAllMipCustomDetailData, ThrowOnError>) => (options?.client ?? client).get<CustomDetailControllerGetAllMipCustomDetailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/custom-detail',
    ...options
});

/**
 * Create MIP Custom Detail
 */
export const customDetailControllerCreateSingleCustomDetail = <ThrowOnError extends boolean = false>(options: Options<CustomDetailControllerCreateSingleCustomDetailData, ThrowOnError>) => (options.client ?? client).post<CustomDetailControllerCreateSingleCustomDetailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/custom-detail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete MIP CustomDetails
 */
export const customDetailControllerDeleteSingleCustomDetail = <ThrowOnError extends boolean = false>(options?: Options<CustomDetailControllerDeleteSingleCustomDetailData, ThrowOnError>) => (options?.client ?? client).delete<CustomDetailControllerDeleteSingleCustomDetailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/custom-detail/{id}',
    ...options
});

/**
 * Update MIP CustomDetails
 */
export const customDetailControllerUpdateSingleCustomDetail = <ThrowOnError extends boolean = false>(options: Options<CustomDetailControllerUpdateSingleCustomDetailData, ThrowOnError>) => (options.client ?? client).put<CustomDetailControllerUpdateSingleCustomDetailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/custom-detail/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get per-investment custom field requirements
 */
export const customDetailControllerGetKycWorkflowCustomDetails = <ThrowOnError extends boolean = false>(options: Options<CustomDetailControllerGetKycWorkflowCustomDetailsData, ThrowOnError>) => (options.client ?? client).get<CustomDetailControllerGetKycWorkflowCustomDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/custom-detail/kycWorkflow/{kycWorkflowId}',
    ...options
});

/**
 * Toggle a custom field requirement for a single investment
 */
export const customDetailControllerUpdateKycWorkflowCustomDetail = <ThrowOnError extends boolean = false>(options: Options<CustomDetailControllerUpdateKycWorkflowCustomDetailData, ThrowOnError>) => (options.client ?? client).put<CustomDetailControllerUpdateKycWorkflowCustomDetailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/custom-detail/kycWorkflow/{kycWorkflowId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * list organizations (DealStack support only)
 */
export const organizationControllerGetAllOrganizations = <ThrowOnError extends boolean = false>(options?: Options<OrganizationControllerGetAllOrganizationsData, ThrowOnError>) => (options?.client ?? client).get<OrganizationControllerGetAllOrganizationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization',
    ...options
});

/**
 * create organization
 */
export const organizationControllerCreateOrganization = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerCreateOrganizationData, ThrowOnError>) => (options.client ?? client).post<OrganizationControllerCreateOrganizationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * look up WorkOs organizations by email domain (import flow)
 */
export const organizationControllerLookupWorkOsOrganizations = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerLookupWorkOsOrganizationsData, ThrowOnError>) => (options.client ?? client).get<OrganizationControllerLookupWorkOsOrganizationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization/workos-lookup',
    ...options
});

/**
 * delete organization
 */
export const organizationControllerDeleteOrganization = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerDeleteOrganizationData, ThrowOnError>) => (options.client ?? client).delete<OrganizationControllerDeleteOrganizationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization/{organizationId}',
    ...options
});

/**
 * get organization details by id
 */
export const organizationControllerGetOrganizationDetailsById = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerGetOrganizationDetailsByIdData, ThrowOnError>) => (options.client ?? client).get<OrganizationControllerGetOrganizationDetailsByIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization/{organizationId}',
    ...options
});

/**
 * update organization by id
 */
export const organizationControllerUpdateOrganization = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerUpdateOrganizationData, ThrowOnError>) => (options.client ?? client).patch<OrganizationControllerUpdateOrganizationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization/{organizationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * set organization type (DealStack support only)
 */
export const organizationControllerUpdateOrganizationType = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerUpdateOrganizationTypeData, ThrowOnError>) => (options.client ?? client).patch<OrganizationControllerUpdateOrganizationTypeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization/{organizationId}/type',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * import an existing WorkOs organization into the DB (for orgs created outside the app)
 */
export const organizationControllerImportOrganization = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerImportOrganizationData, ThrowOnError>) => (options.client ?? client).post<OrganizationControllerImportOrganizationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization/import/{authenticationProviderOrgId}',
    ...options
});

/**
 * Get MIP-level KYC settings
 */
export const kycSettingControllerGetMipRequirements = <ThrowOnError extends boolean = false>(options?: Options<KycSettingControllerGetMipRequirementsData, ThrowOnError>) => (options?.client ?? client).get<KycSettingControllerGetMipRequirementsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/kyc-setting/mip',
    ...options
});

/**
 * Update MIP-level KYC settings
 */
export const kycSettingControllerUpdateMipRequirements = <ThrowOnError extends boolean = false>(options: Options<KycSettingControllerUpdateMipRequirementsData, ThrowOnError>) => (options.client ?? client).put<KycSettingControllerUpdateMipRequirementsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/kyc-setting/mip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get KYC settings for a specific KYC workflow
 */
export const kycSettingControllerGetByKycWorkflowId = <ThrowOnError extends boolean = false>(options: Options<KycSettingControllerGetByKycWorkflowIdData, ThrowOnError>) => (options.client ?? client).get<KycSettingControllerGetByKycWorkflowIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/kyc-setting/kycWorkflow/{kycWorkflowId}',
    ...options
});

/**
 * Update KYC settings for a specific KYC workflow
 */
export const kycSettingControllerUpdateByKycWorkflowId = <ThrowOnError extends boolean = false>(options: Options<KycSettingControllerUpdateByKycWorkflowIdData, ThrowOnError>) => (options.client ?? client).put<KycSettingControllerUpdateByKycWorkflowIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/kyc-setting/kycWorkflow/{kycWorkflowId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get KYC workflows data for a MIP
 */
export const kycControllerGetKycWorkflowsData = <ThrowOnError extends boolean = false>(options?: Options<KycControllerGetKycWorkflowsDataData, ThrowOnError>) => (options?.client ?? client).get<KycControllerGetKycWorkflowsDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/workflows',
    ...options
});

/**
 * Get investors kyc data
 */
export const kycControllerGetKycInvestorsData = <ThrowOnError extends boolean = false>(options?: Options<KycControllerGetKycInvestorsDataData, ThrowOnError>) => (options?.client ?? client).get<KycControllerGetKycInvestorsDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/investors',
    ...options
});

/**
 * Get kyc data for a specific investor
 */
export const kycControllerGetKycInvestorData = <ThrowOnError extends boolean = false>(options: Options<KycControllerGetKycInvestorDataData, ThrowOnError>) => (options.client ?? client).get<KycControllerGetKycInvestorDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/investors/{investorId}',
    ...options
});

/**
 * Set flag for more PIV documents
 */
export const kycControllerMorePivDocuments = <ThrowOnError extends boolean = false>(options: Options<KycControllerMorePivDocumentsData, ThrowOnError>) => (options.client ?? client).patch<KycControllerMorePivDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/more-piv-documents/{investorId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get investors statistics
 */
export const kycControllerGetInvestorsStatistics = <ThrowOnError extends boolean = false>(options?: Options<KycControllerGetInvestorsStatisticsData, ThrowOnError>) => (options?.client ?? client).get<KycControllerGetInvestorsStatisticsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/statistics',
    ...options
});

/**
 * Update kyc file status
 */
export const kycControllerUpdateKycStatus = <ThrowOnError extends boolean = false>(options: Options<KycControllerUpdateKycStatusData, ThrowOnError>) => (options.client ?? client).patch<KycControllerUpdateKycStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/kyc-file/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Override kyc file and approve kyc
 */
export const kycControllerUpdateKycFile = <ThrowOnError extends boolean = false>(options: Options<KycControllerUpdateKycFileData, ThrowOnError>) => (options.client ?? client).put<KycControllerUpdateKycFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/kyc-file/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend the certifier's invitation for a KYC file
 */
export const kycControllerResendKycFileCertifierInvitation = <ThrowOnError extends boolean = false>(options: Options<KycControllerResendKycFileCertifierInvitationData, ThrowOnError>) => (options.client ?? client).post<KycControllerResendKycFileCertifierInvitationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/kyc-file/{id}/certification/resend',
    ...options
});

/**
 * Accept/reject all investor declarations
 */
export const kycControllerUpdateDeclarationsStatus = <ThrowOnError extends boolean = false>(options: Options<KycControllerUpdateDeclarationsStatusData, ThrowOnError>) => (options.client ?? client).patch<KycControllerUpdateDeclarationsStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/{investorId}/declarations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * KYC admin edits an investor's declarations on their behalf
 */
export const kycControllerSetInvestorDeclarations = <ThrowOnError extends boolean = false>(options: Options<KycControllerSetInvestorDeclarationsData, ThrowOnError>) => (options.client ?? client).put<KycControllerSetInvestorDeclarationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/{investorId}/declarations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start an async KYC bulk export for the selected (or all-matching) workflows; the zip is delivered via the Exports page
 */
export const kycControllerDownloadInvestorsFiles = <ThrowOnError extends boolean = false>(options: Options<KycControllerDownloadInvestorsFilesData, ThrowOnError>) => (options.client ?? client).post<KycControllerDownloadInvestorsFilesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/bulk-download',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Associates kyc file to an investor
 */
export const kycControllerPutAssociateKycFile = <ThrowOnError extends boolean = false>(options: Options<KycControllerPutAssociateKycFileData, ThrowOnError>) => (options.client ?? client).put<KycControllerPutAssociateKycFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/associate-kyc-file',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft deletes kyc file from an investor
 */
export const kycControllerDeleteKycFile = <ThrowOnError extends boolean = false>(options: Options<KycControllerDeleteKycFileData, ThrowOnError>) => (options.client ?? client).delete<KycControllerDeleteKycFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/kyc-file/{id}/{userId}',
    ...options
});

/**
 * Withdraw a standalone KYC workflow
 */
export const kycControllerWithdrawStandaloneKycWorkflow = <ThrowOnError extends boolean = false>(options: Options<KycControllerWithdrawStandaloneKycWorkflowData, ThrowOnError>) => (options.client ?? client).delete<KycControllerWithdrawStandaloneKycWorkflowResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc/workflows/standalone/{kycWorkflowId}',
    ...options
});

/**
 * redirect to the hosted AuthKit sign-in page, or into the app when already signed in
 */
export const authControllerStartHostedAuthKit = <ThrowOnError extends boolean = false>(options: Options<AuthControllerStartHostedAuthKitData, ThrowOnError>) => (options.client ?? client).get<AuthControllerStartHostedAuthKitResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/start',
    ...options
});

/**
 * can user change credentials - email or password
 */
export const authControllerCanChangeCredentials = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerCanChangeCredentialsData, ThrowOnError>) => (options?.client ?? client).post<AuthControllerCanChangeCredentialsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/can-change-credentials',
    ...options
});

/**
 * delete change email request
 */
export const authControllerDeleteChangeEmailRequest = <ThrowOnError extends boolean = false>(options: Options<AuthControllerDeleteChangeEmailRequestData, ThrowOnError>) => (options.client ?? client).delete<AuthControllerDeleteChangeEmailRequestResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/change-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * user changes email
 */
export const authControllerUpdateEmail = <ThrowOnError extends boolean = false>(options: Options<AuthControllerUpdateEmailData, ThrowOnError>) => (options.client ?? client).post<AuthControllerUpdateEmailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/change-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * change email request
 */
export const authControllerChangeEmailRequest = <ThrowOnError extends boolean = false>(options: Options<AuthControllerChangeEmailRequestData, ThrowOnError>) => (options.client ?? client).post<AuthControllerChangeEmailRequestResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/change-email/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * cancel a pending email change from the link sent to the old address
 */
export const authControllerCancelChangeEmailRequest = <ThrowOnError extends boolean = false>(options: Options<AuthControllerCancelChangeEmailRequestData, ThrowOnError>) => (options.client ?? client).post<AuthControllerCancelChangeEmailRequestResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/change-email/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * send a fresh invitation for an expired invitation link
 *
 * The recipient is always the address the original invitation was sent to, read from WorkOS; nothing in the request names one. Sends only when the link is expired and the invitee can still be invited, and never while a renewed invitation to that address is still pending.
 */
export const authControllerRenewInvitation = <ThrowOnError extends boolean = false>(options: Options<AuthControllerRenewInvitationData, ThrowOnError>) => (options.client ?? client).post<AuthControllerRenewInvitationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/invitation/renew',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * setup 2FA
 */
export const twoFaControllerSetup2Fa = <ThrowOnError extends boolean = false>(options?: Options<TwoFaControllerSetup2FaData, ThrowOnError>) => (options?.client ?? client).post<TwoFaControllerSetup2FaResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/2FA/setup',
    ...options
});

/**
 * Verify challenge of 2FA
 */
export const twoFaControllerVerifyChallenge2Fa = <ThrowOnError extends boolean = false>(options: Options<TwoFaControllerVerifyChallenge2FaData, ThrowOnError>) => (options.client ?? client).post<TwoFaControllerVerifyChallenge2FaResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/2FA/verify-challenge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete auth factor
 */
export const twoFaControllerDeleteAuthFactor = <ThrowOnError extends boolean = false>(options: Options<TwoFaControllerDeleteAuthFactorData, ThrowOnError>) => (options.client ?? client).delete<TwoFaControllerDeleteAuthFactorResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/2FA/delete-factor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * user changes password
 */
export const passwordControllerUpdatePassword = <ThrowOnError extends boolean = false>(options: Options<PasswordControllerUpdatePasswordData, ThrowOnError>) => (options.client ?? client).post<PasswordControllerUpdatePasswordResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * refresh access token
 */
export const sessionManagementControllerRefreshToken = <ThrowOnError extends boolean = false>(options?: Options<SessionManagementControllerRefreshTokenData, ThrowOnError>) => (options?.client ?? client).post<SessionManagementControllerRefreshTokenResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/refresh-token',
    ...options
});

/**
 * read the current session deadlines
 *
 * Lets the client warn the user before the idle window closes. Reading status never counts as activity, so polling it cannot keep a session alive.
 */
export const sessionManagementControllerGetSessionStatus = <ThrowOnError extends boolean = false>(options?: Options<SessionManagementControllerGetSessionStatusData, ThrowOnError>) => (options?.client ?? client).get<SessionManagementControllerGetSessionStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/session',
    ...options
});

/**
 * slide the idle window forward
 *
 * Backs the "stay signed in" action on the idle warning. Subject to the absolute session lifetime, which this cannot extend.
 */
export const sessionManagementControllerKeepSessionAlive = <ThrowOnError extends boolean = false>(options?: Options<SessionManagementControllerKeepSessionAliveData, ThrowOnError>) => (options?.client ?? client).post<SessionManagementControllerKeepSessionAliveResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/session/keep-alive',
    ...options
});

/**
 * user logout method
 */
export const sessionManagementControllerLogout = <ThrowOnError extends boolean = false>(options?: Options<SessionManagementControllerLogoutData, ThrowOnError>) => (options?.client ?? client).post<SessionManagementControllerLogoutResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/logout',
    ...options
});

/**
 * sign out from anywhere, including with no active session
 */
export const sessionManagementControllerSignOut = <ThrowOnError extends boolean = false>(options?: Options<SessionManagementControllerSignOutData, ThrowOnError>) => (options?.client ?? client).post<SessionManagementControllerSignOutResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/sign-out',
    ...options
});

/**
 * redirect from workos and sso providers
 */
export const sessionManagementControllerRedirectCallbackFromWorkOs = <ThrowOnError extends boolean = false>(options: Options<SessionManagementControllerRedirectCallbackFromWorkOsData, ThrowOnError>) => (options.client ?? client).get<SessionManagementControllerRedirectCallbackFromWorkOsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/redirectUri',
    ...options
});

/**
 * Send email verification
 */
export const sessionManagementControllerSendMagicAuthVerificationCode = <ThrowOnError extends boolean = false>(options: Options<SessionManagementControllerSendMagicAuthVerificationCodeData, ThrowOnError>) => (options.client ?? client).post<SessionManagementControllerSendMagicAuthVerificationCodeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/email/send/magic-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * validate user with magic code
 */
export const sessionManagementControllerValidateMagicCode = <ThrowOnError extends boolean = false>(options: Options<SessionManagementControllerValidateMagicCodeData, ThrowOnError>) => (options.client ?? client).post<SessionManagementControllerValidateMagicCodeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/email/validate/magic-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set the phone number hosted AuthKit cannot collect
 */
export const profileControllerUpdatePhone = <ThrowOnError extends boolean = false>(options: Options<ProfileControllerUpdatePhoneData, ThrowOnError>) => (options.client ?? client).post<ProfileControllerUpdatePhoneResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/auth/profile/phone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft delete deal by id
 */
export const dealControllerSoftDeleteDeal = <ThrowOnError extends boolean = false>(options?: Options<DealControllerSoftDeleteDealData, ThrowOnError>) => (options?.client ?? client).delete<DealControllerSoftDeleteDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal',
    ...options
});

/**
 * Fetch list of deals available for user
 */
export const dealControllerGetList = <ThrowOnError extends boolean = false>(options?: Options<DealControllerGetListData, ThrowOnError>) => (options?.client ?? client).get<DealControllerGetListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal',
    ...options
});

/**
 * Update deal
 */
export const dealControllerUpdateDeal = <ThrowOnError extends boolean = false>(options: Options<DealControllerUpdateDealData, ThrowOnError>) => (options.client ?? client).patch<DealControllerUpdateDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create deal
 */
export const dealControllerCreateDeal = <ThrowOnError extends boolean = false>(options: Options<DealControllerCreateDealData, ThrowOnError>) => (options.client ?? client).post<DealControllerCreateDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns the full deal with related data populated.
 */
export const dealControllerGetDeal = <ThrowOnError extends boolean = false>(options?: Options<DealControllerGetDealData, ThrowOnError>) => (options?.client ?? client).get<DealControllerGetDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/data',
    ...options
});

/**
 * Returns the deal raw database entry
 */
export const dealControllerGetDealBasicData = <ThrowOnError extends boolean = false>(options?: Options<DealControllerGetDealBasicDataData, ThrowOnError>) => (options?.client ?? client).get<DealControllerGetDealBasicDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/basic-data',
    ...options
});

/**
 * Returns the full deal with related data populated.
 */
export const dealControllerGetDealDetails = <ThrowOnError extends boolean = false>(options: Options<DealControllerGetDealDetailsData, ThrowOnError>) => (options.client ?? client).get<DealControllerGetDealDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}',
    ...options
});

/**
 * Mark a deal/fund as Restricted (or clear it). Restricted deals deny inherited DealStack Support access.
 */
export const dealControllerSetDealRestriction = <ThrowOnError extends boolean = false>(options: Options<DealControllerSetDealRestrictionData, ThrowOnError>) => (options.client ?? client).patch<DealControllerSetDealRestrictionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/restriction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch deal classifiers
 */
export const dealControllerGetDealClassifiers = <ThrowOnError extends boolean = false>(options: Options<DealControllerGetDealClassifiersData, ThrowOnError>) => (options.client ?? client).get<DealControllerGetDealClassifiersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/classifiers',
    ...options
});

/**
 * Create deal classifier
 */
export const dealControllerCreateDealClassifiers = <ThrowOnError extends boolean = false>(options: Options<DealControllerCreateDealClassifiersData, ThrowOnError>) => (options.client ?? client).post<DealControllerCreateDealClassifiersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/classifiers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update deal classifier
 */
export const dealControllerUpdateDealClassifiers = <ThrowOnError extends boolean = false>(options: Options<DealControllerUpdateDealClassifiersData, ThrowOnError>) => (options.client ?? client).put<DealControllerUpdateDealClassifiersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/classifiers/{dealClassifierId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update deal company representative
 */
export const dealControllerUpdateProjectRepresentative = <ThrowOnError extends boolean = false>(options: Options<DealControllerUpdateProjectRepresentativeData, ThrowOnError>) => (options.client ?? client).put<DealControllerUpdateProjectRepresentativeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/update-project-representative',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get deal company representative
 */
export const dealControllerUpdateCompanyRepresentative = <ThrowOnError extends boolean = false>(options: Options<DealControllerUpdateCompanyRepresentativeData, ThrowOnError>) => (options.client ?? client).get<DealControllerUpdateCompanyRepresentativeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/project-representative',
    ...options
});

/**
 * Fetch deal users
 */
export const dealUsersControllerGetDealUsers = <ThrowOnError extends boolean = false>(options: Options<DealUsersControllerGetDealUsersData, ThrowOnError>) => (options.client ?? client).get<DealUsersControllerGetDealUsersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/users',
    ...options
});

/**
 * Invite a user to a deal
 */
export const dealUsersControllerInviteUserToDeal = <ThrowOnError extends boolean = false>(options: Options<DealUsersControllerInviteUserToDealData, ThrowOnError>) => (options.client ?? client).post<DealUsersControllerInviteUserToDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync users permission with the db records
 */
export const dealUsersControllerSyncUserInDealToAllProgrammes = <ThrowOnError extends boolean = false>(options: Options<DealUsersControllerSyncUserInDealToAllProgrammesData, ThrowOnError>) => (options.client ?? client).post<DealUsersControllerSyncUserInDealToAllProgrammesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/users/{userId}/sync',
    ...options
});

/**
 * Remove user from deal
 */
export const dealUsersControllerDeleteUserFromDeal = <ThrowOnError extends boolean = false>(options: Options<DealUsersControllerDeleteUserFromDealData, ThrowOnError>) => (options.client ?? client).delete<DealUsersControllerDeleteUserFromDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/users/{userId}',
    ...options
});

/**
 * Get user information for a specific deal
 */
export const dealUsersControllerGetDealUser = <ThrowOnError extends boolean = false>(options: Options<DealUsersControllerGetDealUserData, ThrowOnError>) => (options.client ?? client).get<DealUsersControllerGetDealUserResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/users/{userId}',
    ...options
});

/**
 * Get users for specific programme
 */
export const programmeUsersControllerGetProgrammeUsers = <ThrowOnError extends boolean = false>(options: Options<ProgrammeUsersControllerGetProgrammeUsersData, ThrowOnError>) => (options.client ?? client).get<ProgrammeUsersControllerGetProgrammeUsersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{programmeId}/users',
    ...options
});

/**
 * Invite a user to a programme
 */
export const programmeUsersControllerInviteUserToProgramme = <ThrowOnError extends boolean = false>(options: Options<ProgrammeUsersControllerInviteUserToProgrammeData, ThrowOnError>) => (options.client ?? client).post<ProgrammeUsersControllerInviteUserToProgrammeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{programmeId}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete user from programme
 */
export const programmeUsersControllerDeleteUserFromProgramme = <ThrowOnError extends boolean = false>(options: Options<ProgrammeUsersControllerDeleteUserFromProgrammeData, ThrowOnError>) => (options.client ?? client).delete<ProgrammeUsersControllerDeleteUserFromProgrammeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{programmeId}/users/{userId}',
    ...options
});

/**
 * Get user data for a programme
 */
export const programmeUsersControllerGetProgrammeUser = <ThrowOnError extends boolean = false>(options: Options<ProgrammeUsersControllerGetProgrammeUserData, ThrowOnError>) => (options.client ?? client).get<ProgrammeUsersControllerGetProgrammeUserResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{programmeId}/users/{userId}',
    ...options
});

/**
 * Update user first name and last name or isContactPerson for a specific Programme
 */
export const programmeUsersControllerUpdateUserAndUserProgramme = <ThrowOnError extends boolean = false>(options: Options<ProgrammeUsersControllerUpdateUserAndUserProgrammeData, ThrowOnError>) => (options.client ?? client).put<ProgrammeUsersControllerUpdateUserAndUserProgrammeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{programmeId}/users/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download excel file with cap table data
 */
export const capTableControllerDownloadExcel = <ThrowOnError extends boolean = false>(options: Options<CapTableControllerDownloadExcelData, ThrowOnError>) => (options.client ?? client).get<CapTableControllerDownloadExcelResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/download-excel',
    ...options
});

/**
 * Gets Cap Table Data
 */
export const capTableControllerPostCapTableData = <ThrowOnError extends boolean = false>(options: Options<CapTableControllerPostCapTableDataData, ThrowOnError>) => (options.client ?? client).post<CapTableControllerPostCapTableDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets Group Structure chart Data
 */
export const capTableControllerPostGroupStructureData = <ThrowOnError extends boolean = false>(options: Options<CapTableControllerPostGroupStructureDataData, ThrowOnError>) => (options.client ?? client).post<CapTableControllerPostGroupStructureDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/group-structure-data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets all securities for group structure chart
 */
export const capTableControllerPostSecuritiesForGroupStructureData = <ThrowOnError extends boolean = false>(options: Options<CapTableControllerPostSecuritiesForGroupStructureDataData, ThrowOnError>) => (options.client ?? client).post<CapTableControllerPostSecuritiesForGroupStructureDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/group-structure-data/securities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get group structure chart positions
 */
export const capTableControllerPostGroupStructurePositions = <ThrowOnError extends boolean = false>(options?: Options<CapTableControllerPostGroupStructurePositionsData, ThrowOnError>) => (options?.client ?? client).post<CapTableControllerPostGroupStructurePositionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/group-structure-positions',
    ...options
});

/**
 * Updates group structure chart positions
 */
export const capTableControllerUpdateGroupStructurePositions = <ThrowOnError extends boolean = false>(options: Options<CapTableControllerUpdateGroupStructurePositionsData, ThrowOnError>) => (options.client ?? client).put<CapTableControllerUpdateGroupStructurePositionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/group-structure-positions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Cap Details
 */
export const capTableControllerGetCapDetails = <ThrowOnError extends boolean = false>(options: Options<CapTableControllerGetCapDetailsData, ThrowOnError>) => (options.client ?? client).get<CapTableControllerGetCapDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/deal/{dealId}/cap/details',
    ...options
});

/**
 * Get Cap Details
 */
export const capTableControllerGetCapTransactionsValidationDetails = <ThrowOnError extends boolean = false>(options: Options<CapTableControllerGetCapTransactionsValidationDetailsData, ThrowOnError>) => (options.client ?? client).get<CapTableControllerGetCapTransactionsValidationDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/deal/{dealId}/cap/validation-details',
    ...options
});

/**
 * Export deal holdings json
 */
export const capTableControllerExportDealHoldingsJson = <ThrowOnError extends boolean = false>(options: Options<CapTableControllerExportDealHoldingsJsonData, ThrowOnError>) => (options.client ?? client).get<CapTableControllerExportDealHoldingsJsonResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/deal/{dealId}/export-file',
    ...options
});

/**
 * List the editable email templates for the current Deal
 */
export const dealEmailTemplateControllerList = <ThrowOnError extends boolean = false>(options?: Options<DealEmailTemplateControllerListData, ThrowOnError>) => (options?.client ?? client).get<DealEmailTemplateControllerListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-email-template',
    ...options
});

/**
 * Get one email template (default + current override) for editing
 */
export const dealEmailTemplateControllerGetOne = <ThrowOnError extends boolean = false>(options: Options<DealEmailTemplateControllerGetOneData, ThrowOnError>) => (options.client ?? client).get<DealEmailTemplateControllerGetOneResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-email-template/{type}',
    ...options
});

/**
 * Update the subject, body, or send toggle of a Deal template
 */
export const dealEmailTemplateControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<DealEmailTemplateControllerUpdateData, ThrowOnError>) => (options.client ?? client).patch<DealEmailTemplateControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-email-template/{type}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render a live preview (send-parity) of the saved or draft template
 */
export const dealEmailTemplateControllerPreview = <ThrowOnError extends boolean = false>(options: Options<DealEmailTemplateControllerPreviewData, ThrowOnError>) => (options.client ?? client).post<DealEmailTemplateControllerPreviewResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-email-template/{type}/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send this template to the caller's own address to verify live delivery
 */
export const dealEmailTemplateControllerTestSend = <ThrowOnError extends boolean = false>(options: Options<DealEmailTemplateControllerTestSendData, ThrowOnError>) => (options.client ?? client).post<DealEmailTemplateControllerTestSendResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-email-template/{type}/test-send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset a Deal template back to the Dealstack default
 */
export const dealEmailTemplateControllerReset = <ThrowOnError extends boolean = false>(options: Options<DealEmailTemplateControllerResetData, ThrowOnError>) => (options.client ?? client).post<DealEmailTemplateControllerResetResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-email-template/{type}/reset',
    ...options
});

/**
 * List an organisation's default deal email templates
 */
export const organizationDealEmailTemplateControllerList = <ThrowOnError extends boolean = false>(options: Options<OrganizationDealEmailTemplateControllerListData, ThrowOnError>) => (options.client ?? client).get<OrganizationDealEmailTemplateControllerListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-defaults/email-template/{organizationId}',
    ...options
});

/**
 * Get one default template (Dealstack default + current override)
 */
export const organizationDealEmailTemplateControllerGetOne = <ThrowOnError extends boolean = false>(options: Options<OrganizationDealEmailTemplateControllerGetOneData, ThrowOnError>) => (options.client ?? client).get<OrganizationDealEmailTemplateControllerGetOneResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-defaults/email-template/{organizationId}/{type}',
    ...options
});

/**
 * Update the subject, body or send toggle of a default template
 */
export const organizationDealEmailTemplateControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<OrganizationDealEmailTemplateControllerUpdateData, ThrowOnError>) => (options.client ?? client).patch<OrganizationDealEmailTemplateControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-defaults/email-template/{organizationId}/{type}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render a live preview of the saved or draft default template
 */
export const organizationDealEmailTemplateControllerPreview = <ThrowOnError extends boolean = false>(options: Options<OrganizationDealEmailTemplateControllerPreviewData, ThrowOnError>) => (options.client ?? client).post<OrganizationDealEmailTemplateControllerPreviewResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-defaults/email-template/{organizationId}/{type}/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset a default template back to the Dealstack default
 */
export const organizationDealEmailTemplateControllerReset = <ThrowOnError extends boolean = false>(options: Options<OrganizationDealEmailTemplateControllerResetData, ThrowOnError>) => (options.client ?? client).post<OrganizationDealEmailTemplateControllerResetResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-defaults/email-template/{organizationId}/{type}/reset',
    ...options
});

/**
 * List the document classifiers seeded onto every new deal
 */
export const organizationDealClassifierControllerListClassifiers = <ThrowOnError extends boolean = false>(options: Options<OrganizationDealClassifierControllerListClassifiersData, ThrowOnError>) => (options.client ?? client).get<OrganizationDealClassifierControllerListClassifiersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-defaults/classifier/{organizationId}',
    ...options
});

/**
 * Replace the whole default classifier list
 */
export const organizationDealClassifierControllerSetClassifiers = <ThrowOnError extends boolean = false>(options: Options<OrganizationDealClassifierControllerSetClassifiersData, ThrowOnError>) => (options.client ?? client).put<OrganizationDealClassifierControllerSetClassifiersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-defaults/classifier/{organizationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all Funds the user has access to, optionally scoped to an organization
 */
export const fundControllerGetAllFunds = <ThrowOnError extends boolean = false>(options: Options<FundControllerGetAllFundsData, ThrowOnError>) => (options.client ?? client).get<FundControllerGetAllFundsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund',
    ...options
});

/**
 * Create a new Fund (creates both Deal and Fund)
 */
export const fundControllerCreateFund = <ThrowOnError extends boolean = false>(options: Options<FundControllerCreateFundData, ThrowOnError>) => (options.client ?? client).post<FundControllerCreateFundResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a Fund by ID
 */
export const fundControllerGetFund = <ThrowOnError extends boolean = false>(options: Options<FundControllerGetFundData, ThrowOnError>) => (options.client ?? client).get<FundControllerGetFundResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund/{fundId}',
    ...options
});

/**
 * Update a Fund and its underlying Deal
 */
export const fundControllerUpdateFund = <ThrowOnError extends boolean = false>(options: Options<FundControllerUpdateFundData, ThrowOnError>) => (options.client ?? client).patch<FundControllerUpdateFundResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund/{fundId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get linked deals for Fund by fund ID
 */
export const fundControllerGetFundLinkedDeals = <ThrowOnError extends boolean = false>(options: Options<FundControllerGetFundLinkedDealsData, ThrowOnError>) => (options.client ?? client).get<FundControllerGetFundLinkedDealsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund/{fundId}/linked-deals',
    ...options
});

/**
 * Get deals available to link to a Fund
 */
export const fundControllerGetAvailableDealsForFund = <ThrowOnError extends boolean = false>(options: Options<FundControllerGetAvailableDealsForFundData, ThrowOnError>) => (options.client ?? client).get<FundControllerGetAvailableDealsForFundResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund/{fundId}/available-deals',
    ...options
});

/**
 * Get deals available for linking for fund's person
 */
export const fundControllerGetAvailableDealsForPersonFundLink = <ThrowOnError extends boolean = false>(options: Options<FundControllerGetAvailableDealsForPersonFundLinkData, ThrowOnError>) => (options.client ?? client).get<FundControllerGetAvailableDealsForPersonFundLinkResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund/{fundId}/available-deals-for-person/{personId}',
    ...options
});

/**
 * Get the Fund associated with a Deal (if the Deal is a Fund)
 */
export const fundControllerGetFundByDeal = <ThrowOnError extends boolean = false>(options: Options<FundControllerGetFundByDealData, ThrowOnError>) => (options.client ?? client).get<FundControllerGetFundByDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund/deal/{dealId}',
    ...options
});

/**
 * Link a Fund to a Deal (Fund invests in Deal)
 */
export const fundControllerLinkFundToDeal = <ThrowOnError extends boolean = false>(options: Options<FundControllerLinkFundToDealData, ThrowOnError>) => (options.client ?? client).post<FundControllerLinkFundToDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund/deal-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unlink a Fund from a Deal
 */
export const fundControllerUnlinkFundFromDeal = <ThrowOnError extends boolean = false>(options: Options<FundControllerUnlinkFundFromDealData, ThrowOnError>) => (options.client ?? client).post<FundControllerUnlinkFundFromDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund/deal-unlink',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unlink a Person from a Fund-Deal
 */
export const fundControllerUnlinkPersonFromFund = <ThrowOnError extends boolean = false>(options: Options<FundControllerUnlinkPersonFromFundData, ThrowOnError>) => (options.client ?? client).delete<FundControllerUnlinkPersonFromFundResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund/link-person',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link a Person from a Fund to a Deal
 */
export const fundControllerLinkPersonToFund = <ThrowOnError extends boolean = false>(options: Options<FundControllerLinkPersonToFundData, ThrowOnError>) => (options.client ?? client).post<FundControllerLinkPersonToFundResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund/link-person',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Fund links for a Person
 */
export const fundControllerGetFundLinksForPerson = <ThrowOnError extends boolean = false>(options: Options<FundControllerGetFundLinksForPersonData, ThrowOnError>) => (options.client ?? client).get<FundControllerGetFundLinksForPersonResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fund/person/{personId}/fund-links',
    ...options
});

/**
 * Email workflow progress updates
 */
export const mipControllerGetEmailWorkflowStatus = <ThrowOnError extends boolean = false>(options: Options<MipControllerGetEmailWorkflowStatusData, ThrowOnError>) => (options.client ?? client).get<MipControllerGetEmailWorkflowStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/email-workflow-progress/{handlerId}',
    ...options
});

/**
 * Get Programmes by deal Id with fallback option
 */
export const mipControllerListProgrammes = <ThrowOnError extends boolean = false>(options?: Options<MipControllerListProgrammesData, ThrowOnError>) => (options?.client ?? client).get<MipControllerListProgrammesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip',
    ...options
});

/**
 * Update
 */
export const mipControllerUpdateMipData = <ThrowOnError extends boolean = false>(options: Options<MipControllerUpdateMipDataData, ThrowOnError>) => (options.client ?? client).put<MipControllerUpdateMipDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP programme entities
 */
export const mipControllerGetMipProgrammeEntities = <ThrowOnError extends boolean = false>(options?: Options<MipControllerGetMipProgrammeEntitiesData, ThrowOnError>) => (options?.client ?? client).get<MipControllerGetMipProgrammeEntitiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/entities',
    ...options
});

/**
 * Add entity to MIP programme
 */
export const mipControllerAddMipProgrammeEntity = <ThrowOnError extends boolean = false>(options: Options<MipControllerAddMipProgrammeEntityData, ThrowOnError>) => (options.client ?? client).post<MipControllerAddMipProgrammeEntityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/entities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete entity from MIP programme
 */
export const mipControllerDeleteMipProgrammeEntity = <ThrowOnError extends boolean = false>(options: Options<MipControllerDeleteMipProgrammeEntityData, ThrowOnError>) => (options.client ?? client).delete<MipControllerDeleteMipProgrammeEntityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/entities/{entityId}',
    ...options
});

/**
 * Get MIP Details
 */
export const mipControllerGetMipDetailsForJoiner = <ThrowOnError extends boolean = false>(options?: Options<MipControllerGetMipDetailsForJoinerData, ThrowOnError>) => (options?.client ?? client).get<MipControllerGetMipDetailsForJoinerResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/joiner',
    ...options
});

/**
 * Joiner/Additional allocations
 */
export const mipControllerPostJoinerAdditionalAllocations = <ThrowOnError extends boolean = false>(options: Options<MipControllerPostJoinerAdditionalAllocationsData, ThrowOnError>) => (options.client ?? client).post<MipControllerPostJoinerAdditionalAllocationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/joiner',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP Details
 */
export const mipControllerGetMipDetailsForLeaver = <ThrowOnError extends boolean = false>(options?: Options<MipControllerGetMipDetailsForLeaverData, ThrowOnError>) => (options?.client ?? client).get<MipControllerGetMipDetailsForLeaverResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/leaver',
    ...options
});

/**
 * Leaver/Negative allocations
 */
export const mipControllerPostLeaverNegativeAllocations = <ThrowOnError extends boolean = false>(options: Options<MipControllerPostLeaverNegativeAllocationsData, ThrowOnError>) => (options.client ?? client).post<MipControllerPostLeaverNegativeAllocationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/leaver',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP Workflow Settings
 */
export const mipControllerGetWorkflowSettings = <ThrowOnError extends boolean = false>(options?: Options<MipControllerGetWorkflowSettingsData, ThrowOnError>) => (options?.client ?? client).get<MipControllerGetWorkflowSettingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/workflow-settings',
    ...options
});

/**
 * Update MIP Workflow Settings
 */
export const mipControllerUpdateWorkflowSettings = <ThrowOnError extends boolean = false>(options: Options<MipControllerUpdateWorkflowSettingsData, ThrowOnError>) => (options.client ?? client).put<MipControllerUpdateWorkflowSettingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/workflow-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update isKycRequired status
 */
export const mipControllerUpdateMipKycRequired = <ThrowOnError extends boolean = false>(options: Options<MipControllerUpdateMipKycRequiredData, ThrowOnError>) => (options.client ?? client).put<MipControllerUpdateMipKycRequiredResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/kyc-required',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIPS By Person
 */
export const mipControllerGetMipsForPerson = <ThrowOnError extends boolean = false>(options: Options<MipControllerGetMipsForPersonData, ThrowOnError>) => (options.client ?? client).post<MipControllerGetMipsForPersonResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/person-mips',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get representatives for investors
 */
export const mipControllerGetPivDetailsForInvestors = <ThrowOnError extends boolean = false>(options?: Options<MipControllerGetPivDetailsForInvestorsData, ThrowOnError>) => (options?.client ?? client).get<MipControllerGetPivDetailsForInvestorsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/piv-details-for-investors',
    ...options
});

/**
 * Soft delete MIP Draft
 */
export const mipDraftControllerSoftDeleteMipDraft = <ThrowOnError extends boolean = false>(options?: Options<MipDraftControllerSoftDeleteMipDraftData, ThrowOnError>) => (options?.client ?? client).delete<MipDraftControllerSoftDeleteMipDraftResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip-draft',
    ...options
});

/**
 * Create mip draft
 */
export const mipDraftControllerCreateMip = <ThrowOnError extends boolean = false>(options?: Options<MipDraftControllerCreateMipData, ThrowOnError>) => (options?.client ?? client).post<MipDraftControllerCreateMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip-draft',
    ...options
});

/**
 * Update MIP Draft General Deal Inputs
 */
export const mipDraftControllerUpdateDraftGeneralDealInputs = <ThrowOnError extends boolean = false>(options: Options<MipDraftControllerUpdateDraftGeneralDealInputsData, ThrowOnError>) => (options.client ?? client).put<MipDraftControllerUpdateDraftGeneralDealInputsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip-draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an active programme without the wizard
 */
export const mipDraftControllerCreateActiveProgramme = <ThrowOnError extends boolean = false>(options: Options<MipDraftControllerCreateActiveProgrammeData, ThrowOnError>) => (options.client ?? client).post<MipDraftControllerCreateActiveProgrammeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip-draft/active',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete mip creation -> Draft -> active MIP project
 */
export const mipDraftControllerComplete = <ThrowOnError extends boolean = false>(options?: Options<MipDraftControllerCompleteData, ThrowOnError>) => (options?.client ?? client).get<MipDraftControllerCompleteResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip-draft/complete',
    ...options
});

/**
 * Return draft step errors/warnings
 */
export const mipDraftControllerGetDraftStepsStatuses = <ThrowOnError extends boolean = false>(options?: Options<MipDraftControllerGetDraftStepsStatusesData, ThrowOnError>) => (options?.client ?? client).get<MipDraftControllerGetDraftStepsStatusesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip-draft/steps-statuses',
    ...options
});

/**
 * Get messages for an investor
 */
export const investorMessageControllerGetMessagesForInvestor = <ThrowOnError extends boolean = false>(options: Options<InvestorMessageControllerGetMessagesForInvestorData, ThrowOnError>) => (options.client ?? client).get<InvestorMessageControllerGetMessagesForInvestorResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor/{investorId}/messages',
    ...options
});

/**
 * Get message for investor
 */
export const investorMessageControllerGetMessageForInvestor = <ThrowOnError extends boolean = false>(options: Options<InvestorMessageControllerGetMessageForInvestorData, ThrowOnError>) => (options.client ?? client).get<InvestorMessageControllerGetMessageForInvestorResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/{mipId}/investor/{investorId}/messages/{messageId}',
    ...options
});

/**
 * Get MIP Bank Account
 */
export const bankAccountControllerGetMipBankAccount = <ThrowOnError extends boolean = false>(options?: Options<BankAccountControllerGetMipBankAccountData, ThrowOnError>) => (options?.client ?? client).get<BankAccountControllerGetMipBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/bank-account',
    ...options
});

/**
 * Create MIP Bank Account
 */
export const bankAccountControllerCreateMipBankAccount = <ThrowOnError extends boolean = false>(options: Options<BankAccountControllerCreateMipBankAccountData, ThrowOnError>) => (options.client ?? client).post<BankAccountControllerCreateMipBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/bank-account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete MIP Bank Account by its id
 */
export const bankAccountControllerDeleteMipBankAccount = <ThrowOnError extends boolean = false>(options?: Options<BankAccountControllerDeleteMipBankAccountData, ThrowOnError>) => (options?.client ?? client).delete<BankAccountControllerDeleteMipBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/bank-account/{id}',
    ...options
});

/**
 * Update MIP Bank Account by its id
 */
export const bankAccountControllerUpdateMipBankAccount = <ThrowOnError extends boolean = false>(options: Options<BankAccountControllerUpdateMipBankAccountData, ThrowOnError>) => (options.client ?? client).put<BankAccountControllerUpdateMipBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/bank-account/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify the MIP bank account's identifiers per format rule and log the lookup
 */
export const bankAccountControllerValidateBankAccount = <ThrowOnError extends boolean = false>(options: Options<BankAccountControllerValidateBankAccountData, ThrowOnError>) => (options.client ?? client).post<BankAccountControllerValidateBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/bank-account/{id}/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all document workflow templates for MIP with pagination, filtering, and sorting (Master Documents)
 */
export const documentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplates = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/list',
    ...options
});

/**
 * Soft delete a document workflow template
 */
export const documentWorkflowMasterDocumentsControllerSoftDeleteMasterDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerSoftDeleteMasterDocumentData, ThrowOnError>) => (options.client ?? client).delete<DocumentWorkflowMasterDocumentsControllerSoftDeleteMasterDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}',
    ...options
});

/**
 * Get document workflow template by ID (Master Documents)
 */
export const documentWorkflowMasterDocumentsControllerGetById = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerGetByIdData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowMasterDocumentsControllerGetByIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}',
    ...options
});

/**
 * Update document workflow template properties (visibleIn, classifiers, signature type)
 */
export const documentWorkflowMasterDocumentsControllerUpdateMasterDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerUpdateMasterDocumentData, ThrowOnError>) => (options.client ?? client).put<DocumentWorkflowMasterDocumentsControllerUpdateMasterDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get signature placement slots for a template
 */
export const documentWorkflowMasterDocumentsControllerGetSignatureSlots = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/signature-slots',
    ...options
});

/**
 * Get field bindings for a template
 */
export const documentWorkflowMasterDocumentsControllerGetFieldBindings = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerGetFieldBindingsData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowMasterDocumentsControllerGetFieldBindingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/field-bindings',
    ...options
});

/**
 * Replace field bindings for a template
 */
export const documentWorkflowMasterDocumentsControllerUpdateFieldBindings = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerUpdateFieldBindingsData, ThrowOnError>) => (options.client ?? client).put<DocumentWorkflowMasterDocumentsControllerUpdateFieldBindingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/field-bindings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate a field-bound PDF preview for an investor
 */
export const documentWorkflowMasterDocumentsControllerPreviewFieldBindings = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/field-bindings/preview',
    ...options
});

/**
 * Get the editable document for a Word master document
 */
export const documentWorkflowMasterDocumentsControllerGetDocxFlowDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/docx-document',
    ...options
});

/**
 * Save an edited Word master document
 */
export const documentWorkflowMasterDocumentsControllerSaveDocxFlowDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentData, ThrowOnError>) => (options.client ?? client).put<DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/docx-document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render a converted Word template with its field names in place
 */
export const documentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsView = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/docx-render/fields',
    ...options
});

/**
 * Render a converted Word template — field names in place, or a recipient’s real values
 */
export const documentWorkflowMasterDocumentsControllerRenderDocxTemplate = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/docx-render',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the field-binding catalogue with resolved sample values
 */
export const documentWorkflowMasterDocumentsControllerGetFieldBindingCatalogue = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueData, ThrowOnError>) => (options.client ?? client).get<DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/field-binding-catalogue',
    ...options
});

/**
 * Create a document workflow template (master document)
 */
export const documentWorkflowMasterDocumentsControllerCreate = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerCreateData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowMasterDocumentsControllerCreateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive or unarchive a document workflow template
 */
export const documentWorkflowMasterDocumentsControllerUpdateArchived = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerUpdateArchivedData, ThrowOnError>) => (options.client ?? client).put<DocumentWorkflowMasterDocumentsControllerUpdateArchivedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk archive or unarchive document workflow templates
 */
export const documentWorkflowMasterDocumentsControllerBulkArchive = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerBulkArchiveData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowMasterDocumentsControllerBulkArchiveResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/bulk-archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk soft delete document workflow templates
 */
export const documentWorkflowMasterDocumentsControllerBulkDelete = <ThrowOnError extends boolean = false>(options: Options<DocumentWorkflowMasterDocumentsControllerBulkDeleteData, ThrowOnError>) => (options.client ?? client).post<DocumentWorkflowMasterDocumentsControllerBulkDeleteResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/bulk-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a filtered, sorted page of the bank accounts of a programme's investors
 */
export const investorBankAccountControllerGetInvestorBankAccounts = <ThrowOnError extends boolean = false>(options: Options<InvestorBankAccountControllerGetInvestorBankAccountsData, ThrowOnError>) => (options.client ?? client).post<InvestorBankAccountControllerGetInvestorBankAccountsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor-bank-account/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get one investor bank account with its standing review
 */
export const investorBankAccountControllerGetBankAccountDetail = <ThrowOnError extends boolean = false>(options: Options<InvestorBankAccountControllerGetBankAccountDetailData, ThrowOnError>) => (options.client ?? client).get<InvestorBankAccountControllerGetBankAccountDetailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor-bank-account/{id}',
    ...options
});

/**
 * Get a bank account's audit trail
 */
export const investorBankAccountControllerGetBankAccountHistory = <ThrowOnError extends boolean = false>(options: Options<InvestorBankAccountControllerGetBankAccountHistoryData, ThrowOnError>) => (options.client ?? client).get<InvestorBankAccountControllerGetBankAccountHistoryResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor-bank-account/{id}/history',
    ...options
});

/**
 * Approve, decline or revoke a decision on an investor bank account
 */
export const investorBankAccountControllerReview = <ThrowOnError extends boolean = false>(options: Options<InvestorBankAccountControllerReviewData, ThrowOnError>) => (options.client ?? client).post<InvestorBankAccountControllerReviewResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/investor-bank-account/{id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get audit history for entity
 */
export const auditControllerGetEntityAudits = <ThrowOnError extends boolean = false>(options: Options<AuditControllerGetEntityAuditsData, ThrowOnError>) => (options.client ?? client).get<AuditControllerGetEntityAuditsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/audit/entity/{entityId}',
    ...options
});

/**
 * Get audit history for an investment (workflow + allocations + loans)
 */
export const auditControllerGetInvestmentAudits = <ThrowOnError extends boolean = false>(options: Options<AuditControllerGetInvestmentAuditsData, ThrowOnError>) => (options.client ?? client).get<AuditControllerGetInvestmentAuditsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/audit/investment/{investmentWorkflowId}',
    ...options
});

/**
 * Get audit history for a person across all of the person's deals
 */
export const auditControllerGetPersonAudits = <ThrowOnError extends boolean = false>(options: Options<AuditControllerGetPersonAuditsData, ThrowOnError>) => (options.client ?? client).get<AuditControllerGetPersonAuditsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/audit/person/{personId}',
    ...options
});

/**
 * Get MIP-level programme settings
 */
export const programmeSettingControllerGetByMipId = <ThrowOnError extends boolean = false>(options?: Options<ProgrammeSettingControllerGetByMipIdData, ThrowOnError>) => (options?.client ?? client).get<ProgrammeSettingControllerGetByMipIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-setting/mip',
    ...options
});

/**
 * Update MIP-level programme settings
 */
export const programmeSettingControllerUpdateByMipId = <ThrowOnError extends boolean = false>(options: Options<ProgrammeSettingControllerUpdateByMipIdData, ThrowOnError>) => (options.client ?? client).put<ProgrammeSettingControllerUpdateByMipIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-setting/mip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organisation-level KYC/AML and Investor Data requirements
 */
export const organizationKycSettingControllerGetRequirements = <ThrowOnError extends boolean = false>(options: Options<OrganizationKycSettingControllerGetRequirementsData, ThrowOnError>) => (options.client ?? client).get<OrganizationKycSettingControllerGetRequirementsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/kyc-setting/{organizationId}',
    ...options
});

/**
 * Update organisation-level KYC/AML and Investor Data requirements
 */
export const organizationKycSettingControllerUpdateRequirements = <ThrowOnError extends boolean = false>(options: Options<OrganizationKycSettingControllerUpdateRequirementsData, ThrowOnError>) => (options.client ?? client).put<OrganizationKycSettingControllerUpdateRequirementsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/kyc-setting/{organizationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List organisation-level Investor Data custom fields
 */
export const organizationCustomFieldControllerGetCustomFields = <ThrowOnError extends boolean = false>(options: Options<OrganizationCustomFieldControllerGetCustomFieldsData, ThrowOnError>) => (options.client ?? client).get<OrganizationCustomFieldControllerGetCustomFieldsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/custom-field/{organizationId}',
    ...options
});

/**
 * Add an organisation-level Investor Data custom field
 */
export const organizationCustomFieldControllerCreateCustomField = <ThrowOnError extends boolean = false>(options: Options<OrganizationCustomFieldControllerCreateCustomFieldData, ThrowOnError>) => (options.client ?? client).post<OrganizationCustomFieldControllerCreateCustomFieldResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/custom-field/{organizationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove an organisation-level Investor Data custom field
 */
export const organizationCustomFieldControllerDeleteCustomField = <ThrowOnError extends boolean = false>(options: Options<OrganizationCustomFieldControllerDeleteCustomFieldData, ThrowOnError>) => (options.client ?? client).delete<OrganizationCustomFieldControllerDeleteCustomFieldResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/custom-field/{organizationId}/{customFieldId}',
    ...options
});

/**
 * Update an organisation-level Investor Data custom field
 */
export const organizationCustomFieldControllerUpdateCustomField = <ThrowOnError extends boolean = false>(options: Options<OrganizationCustomFieldControllerUpdateCustomFieldData, ThrowOnError>) => (options.client ?? client).put<OrganizationCustomFieldControllerUpdateCustomFieldResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/custom-field/{organizationId}/{customFieldId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List organisation-level vesting terms
 */
export const organizationVestingTermControllerGetVestingTerms = <ThrowOnError extends boolean = false>(options: Options<OrganizationVestingTermControllerGetVestingTermsData, ThrowOnError>) => (options.client ?? client).get<OrganizationVestingTermControllerGetVestingTermsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/vesting-term/{organizationId}',
    ...options
});

/**
 * Create an organisation-level vesting term
 */
export const organizationVestingTermControllerCreateVestingTerm = <ThrowOnError extends boolean = false>(options: Options<OrganizationVestingTermControllerCreateVestingTermData, ThrowOnError>) => (options.client ?? client).post<OrganizationVestingTermControllerCreateVestingTermResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/vesting-term/{organizationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove an organisation-level vesting term
 */
export const organizationVestingTermControllerDeleteVestingTerm = <ThrowOnError extends boolean = false>(options: Options<OrganizationVestingTermControllerDeleteVestingTermData, ThrowOnError>) => (options.client ?? client).delete<OrganizationVestingTermControllerDeleteVestingTermResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/vesting-term/{organizationId}/{vestingTermId}',
    ...options
});

/**
 * Update an organisation-level vesting term
 */
export const organizationVestingTermControllerUpdateVestingTerm = <ThrowOnError extends boolean = false>(options: Options<OrganizationVestingTermControllerUpdateVestingTermData, ThrowOnError>) => (options.client ?? client).patch<OrganizationVestingTermControllerUpdateVestingTermResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/vesting-term/{organizationId}/{vestingTermId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add the straight-line schedule to an organisation vesting term
 */
export const organizationVestingTermControllerCreateStraightLine = <ThrowOnError extends boolean = false>(options: Options<OrganizationVestingTermControllerCreateStraightLineData, ThrowOnError>) => (options.client ?? client).post<OrganizationVestingTermControllerCreateStraightLineResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/vesting-term/{organizationId}/straight-line',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update the straight-line schedule of an organisation vesting term
 */
export const organizationVestingTermControllerUpdateStraightLine = <ThrowOnError extends boolean = false>(options: Options<OrganizationVestingTermControllerUpdateStraightLineData, ThrowOnError>) => (options.client ?? client).put<OrganizationVestingTermControllerUpdateStraightLineResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/vesting-term/{organizationId}/straight-line/{straightLineId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add a graded tranche to an organisation vesting term
 */
export const organizationVestingTermControllerCreateGraded = <ThrowOnError extends boolean = false>(options: Options<OrganizationVestingTermControllerCreateGradedData, ThrowOnError>) => (options.client ?? client).post<OrganizationVestingTermControllerCreateGradedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/vesting-term/{organizationId}/graded',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a graded tranche from an organisation vesting term
 */
export const organizationVestingTermControllerDeleteGraded = <ThrowOnError extends boolean = false>(options: Options<OrganizationVestingTermControllerDeleteGradedData, ThrowOnError>) => (options.client ?? client).delete<OrganizationVestingTermControllerDeleteGradedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/vesting-term/{organizationId}/graded/{gradedId}',
    ...options
});

/**
 * Update a graded tranche of an organisation vesting term
 */
export const organizationVestingTermControllerUpdateGraded = <ThrowOnError extends boolean = false>(options: Options<OrganizationVestingTermControllerUpdateGradedData, ThrowOnError>) => (options.client ?? client).put<OrganizationVestingTermControllerUpdateGradedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/vesting-term/{organizationId}/graded/{gradedId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add a leaver provision to an organisation vesting term
 */
export const organizationVestingTermControllerCreateLeaverProvision = <ThrowOnError extends boolean = false>(options: Options<OrganizationVestingTermControllerCreateLeaverProvisionData, ThrowOnError>) => (options.client ?? client).post<OrganizationVestingTermControllerCreateLeaverProvisionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/vesting-term/{organizationId}/leaver-provision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a leaver provision from an organisation vesting term
 */
export const organizationVestingTermControllerDeleteLeaverProvision = <ThrowOnError extends boolean = false>(options: Options<OrganizationVestingTermControllerDeleteLeaverProvisionData, ThrowOnError>) => (options.client ?? client).delete<OrganizationVestingTermControllerDeleteLeaverProvisionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/vesting-term/{organizationId}/leaver-provision/{leaverProvisionId}',
    ...options
});

/**
 * Update a leaver provision of an organisation vesting term
 */
export const organizationVestingTermControllerUpdateLeaverProvision = <ThrowOnError extends boolean = false>(options: Options<OrganizationVestingTermControllerUpdateLeaverProvisionData, ThrowOnError>) => (options.client ?? client).put<OrganizationVestingTermControllerUpdateLeaverProvisionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/vesting-term/{organizationId}/leaver-provision/{leaverProvisionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List organisation-level master documents with pagination, filtering and sorting
 */
export const organizationDocumentTemplateControllerList = <ThrowOnError extends boolean = false>(options: Options<OrganizationDocumentTemplateControllerListData, ThrowOnError>) => (options.client ?? client).get<OrganizationDocumentTemplateControllerListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/master-documents/{organizationId}/list',
    ...options
});

/**
 * Remove an organisation-level master document
 */
export const organizationDocumentTemplateControllerRemove = <ThrowOnError extends boolean = false>(options: Options<OrganizationDocumentTemplateControllerRemoveData, ThrowOnError>) => (options.client ?? client).delete<OrganizationDocumentTemplateControllerRemoveResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/master-documents/{organizationId}/{templateId}',
    ...options
});

/**
 * Get an organisation-level master document
 */
export const organizationDocumentTemplateControllerGetById = <ThrowOnError extends boolean = false>(options: Options<OrganizationDocumentTemplateControllerGetByIdData, ThrowOnError>) => (options.client ?? client).get<OrganizationDocumentTemplateControllerGetByIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/master-documents/{organizationId}/{templateId}',
    ...options
});

/**
 * Update an organisation-level master document
 */
export const organizationDocumentTemplateControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<OrganizationDocumentTemplateControllerUpdateData, ThrowOnError>) => (options.client ?? client).put<OrganizationDocumentTemplateControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/master-documents/{organizationId}/{templateId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add an organisation-level master document
 */
export const organizationDocumentTemplateControllerCreate = <ThrowOnError extends boolean = false>(options: Options<OrganizationDocumentTemplateControllerCreateData, ThrowOnError>) => (options.client ?? client).post<OrganizationDocumentTemplateControllerCreateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/master-documents/{organizationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive or unarchive an organisation-level master document
 */
export const organizationDocumentTemplateControllerUpdateArchived = <ThrowOnError extends boolean = false>(options: Options<OrganizationDocumentTemplateControllerUpdateArchivedData, ThrowOnError>) => (options.client ?? client).put<OrganizationDocumentTemplateControllerUpdateArchivedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/master-documents/{organizationId}/{templateId}/archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive or unarchive organisation-level master documents in bulk
 */
export const organizationDocumentTemplateControllerBulkArchive = <ThrowOnError extends boolean = false>(options: Options<OrganizationDocumentTemplateControllerBulkArchiveData, ThrowOnError>) => (options.client ?? client).post<OrganizationDocumentTemplateControllerBulkArchiveResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/master-documents/{organizationId}/bulk-archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove organisation-level master documents in bulk
 */
export const organizationDocumentTemplateControllerBulkDelete = <ThrowOnError extends boolean = false>(options: Options<OrganizationDocumentTemplateControllerBulkDeleteData, ThrowOnError>) => (options.client ?? client).post<OrganizationDocumentTemplateControllerBulkDeleteResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/master-documents/{organizationId}/bulk-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Tax & Compliance forms from an organisation's defaults
 */
export const organizationKycFormTemplateControllerRemove = <ThrowOnError extends boolean = false>(options: Options<OrganizationKycFormTemplateControllerRemoveData, ThrowOnError>) => (options.client ?? client).delete<OrganizationKycFormTemplateControllerRemoveResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/tax-compliance/{organizationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List an organisation's default Tax & Compliance forms
 */
export const organizationKycFormTemplateControllerList = <ThrowOnError extends boolean = false>(options: Options<OrganizationKycFormTemplateControllerListData, ThrowOnError>) => (options.client ?? client).get<OrganizationKycFormTemplateControllerListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/tax-compliance/{organizationId}',
    ...options
});

/**
 * Add a Tax & Compliance form to an organisation's defaults
 */
export const organizationKycFormTemplateControllerCreate = <ThrowOnError extends boolean = false>(options: Options<OrganizationKycFormTemplateControllerCreateData, ThrowOnError>) => (options.client ?? client).post<OrganizationKycFormTemplateControllerCreateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/tax-compliance/{organizationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a Tax & Compliance form in an organisation's defaults
 */
export const organizationKycFormTemplateControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<OrganizationKycFormTemplateControllerUpdateData, ThrowOnError>) => (options.client ?? client).put<OrganizationKycFormTemplateControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/tax-compliance/{organizationId}/{templateId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive or unarchive an organisation Tax & Compliance form
 */
export const organizationKycFormTemplateControllerArchive = <ThrowOnError extends boolean = false>(options: Options<OrganizationKycFormTemplateControllerArchiveData, ThrowOnError>) => (options.client ?? client).put<OrganizationKycFormTemplateControllerArchiveResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/tax-compliance/{organizationId}/{templateId}/archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The signature box an admin must place on an organisation default (always one)
 */
export const organizationKycFormTemplateControllerSignatureSlots = <ThrowOnError extends boolean = false>(options: Options<OrganizationKycFormTemplateControllerSignatureSlotsData, ThrowOnError>) => (options.client ?? client).get<OrganizationKycFormTemplateControllerSignatureSlotsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/tax-compliance/{organizationId}/{templateId}/signature-slots',
    ...options
});

/**
 * Save the manual signature placement for an organisation default
 */
export const organizationKycFormTemplateControllerUpdateSignaturePlacement = <ThrowOnError extends boolean = false>(options: Options<OrganizationKycFormTemplateControllerUpdateSignaturePlacementData, ThrowOnError>) => (options.client ?? client).put<OrganizationKycFormTemplateControllerUpdateSignaturePlacementResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/tax-compliance/{organizationId}/{templateId}/signature-placement',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pre-signed download for one of an organisation's default files
 */
export const organizationFileControllerDownloadPreSignedUrl = <ThrowOnError extends boolean = false>(options: Options<OrganizationFileControllerDownloadPreSignedUrlData, ThrowOnError>) => (options.client ?? client).post<OrganizationFileControllerDownloadPreSignedUrlResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/file/{organizationId}/{fileId}/download-pre-signed-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List an organisation's default email templates
 */
export const organizationEmailTemplateControllerList = <ThrowOnError extends boolean = false>(options: Options<OrganizationEmailTemplateControllerListData, ThrowOnError>) => (options.client ?? client).get<OrganizationEmailTemplateControllerListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/email-template/{organizationId}',
    ...options
});

/**
 * Get one default template (Dealstack default + current override)
 */
export const organizationEmailTemplateControllerGetOne = <ThrowOnError extends boolean = false>(options: Options<OrganizationEmailTemplateControllerGetOneData, ThrowOnError>) => (options.client ?? client).get<OrganizationEmailTemplateControllerGetOneResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/email-template/{organizationId}/{type}',
    ...options
});

/**
 * Update the subject, body or send toggle of a default template
 */
export const organizationEmailTemplateControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<OrganizationEmailTemplateControllerUpdateData, ThrowOnError>) => (options.client ?? client).patch<OrganizationEmailTemplateControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/email-template/{organizationId}/{type}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render a live preview of the saved or draft default template
 */
export const organizationEmailTemplateControllerPreview = <ThrowOnError extends boolean = false>(options: Options<OrganizationEmailTemplateControllerPreviewData, ThrowOnError>) => (options.client ?? client).post<OrganizationEmailTemplateControllerPreviewResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/email-template/{organizationId}/{type}/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset a default template back to the Dealstack default
 */
export const organizationEmailTemplateControllerReset = <ThrowOnError extends boolean = false>(options: Options<OrganizationEmailTemplateControllerResetData, ThrowOnError>) => (options.client ?? client).post<OrganizationEmailTemplateControllerResetResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/email-template/{organizationId}/{type}/reset',
    ...options
});

/**
 * List organisation-level reminder cadences (one per handler type)
 */
export const organizationEmailScheduleControllerListConfigs = <ThrowOnError extends boolean = false>(options: Options<OrganizationEmailScheduleControllerListConfigsData, ThrowOnError>) => (options.client ?? client).get<OrganizationEmailScheduleControllerListConfigsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/email-schedule/{organizationId}',
    ...options
});

/**
 * Create or update an organisation-level reminder cadence
 */
export const organizationEmailScheduleControllerUpsertConfig = <ThrowOnError extends boolean = false>(options: Options<OrganizationEmailScheduleControllerUpsertConfigData, ThrowOnError>) => (options.client ?? client).put<OrganizationEmailScheduleControllerUpsertConfigResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/email-schedule/{organizationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The caller's own Programme Defaults, for the confirm step
 */
export const programmeDefaultsSummaryControllerGetMySummary = <ThrowOnError extends boolean = false>(options?: Options<ProgrammeDefaultsSummaryControllerGetMySummaryData, ThrowOnError>) => (options?.client ?? client).get<ProgrammeDefaultsSummaryControllerGetMySummaryResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/summary',
    ...options
});

/**
 * The Programme Defaults of a deal's lead Sponsor
 */
export const programmeDefaultsSummaryControllerGetSummaryForDeal = <ThrowOnError extends boolean = false>(options?: Options<ProgrammeDefaultsSummaryControllerGetSummaryForDealData, ThrowOnError>) => (options?.client ?? client).get<ProgrammeDefaultsSummaryControllerGetSummaryForDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/summary/deal',
    ...options
});

/**
 * What a Sponsor organisation has configured, for the confirm step
 */
export const programmeDefaultsSummaryControllerGetSummary = <ThrowOnError extends boolean = false>(options: Options<ProgrammeDefaultsSummaryControllerGetSummaryData, ThrowOnError>) => (options.client ?? client).get<ProgrammeDefaultsSummaryControllerGetSummaryResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/summary/{organizationId}',
    ...options
});

/**
 * Copy an organisation's Programme Defaults into a programme
 */
export const programmeDefaultsSummaryControllerApply = <ThrowOnError extends boolean = false>(options: Options<ProgrammeDefaultsSummaryControllerApplyData, ThrowOnError>) => (options.client ?? client).post<ProgrammeDefaultsSummaryControllerApplyResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-defaults/summary/{organizationId}/apply',
    ...options
});

/**
 * List classifiers for the current MIP
 */
export const mipClassifierControllerList = <ThrowOnError extends boolean = false>(options?: Options<MipClassifierControllerListData, ThrowOnError>) => (options?.client ?? client).get<MipClassifierControllerListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip-classifier',
    ...options
});

/**
 * Create a classifier scoped to the current MIP
 */
export const mipClassifierControllerCreate = <ThrowOnError extends boolean = false>(options: Options<MipClassifierControllerCreateData, ThrowOnError>) => (options.client ?? client).post<MipClassifierControllerCreateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip-classifier',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rename and/or archive a MIP-scoped classifier
 */
export const mipClassifierControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<MipClassifierControllerUpdateData, ThrowOnError>) => (options.client ?? client).patch<MipClassifierControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip-classifier/{mipClassifierId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List active cohort classifiers attached to an investor
 */
export const mipClassifierControllerListByInvestor = <ThrowOnError extends boolean = false>(options: Options<MipClassifierControllerListByInvestorData, ThrowOnError>) => (options.client ?? client).get<MipClassifierControllerListByInvestorResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip-classifier/by-investor/{investorId}',
    ...options
});

/**
 * Attach investors to a cohort classifier. Idempotent — existing active links are skipped.
 */
export const mipClassifierControllerAttachInvestors = <ThrowOnError extends boolean = false>(options: Options<MipClassifierControllerAttachInvestorsData, ThrowOnError>) => (options.client ?? client).post<MipClassifierControllerAttachInvestorsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip-classifier/{mipClassifierId}/investors/attach',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Detach investors from a cohort classifier. Investors without an active link are skipped.
 */
export const mipClassifierControllerDetachInvestors = <ThrowOnError extends boolean = false>(options: Options<MipClassifierControllerDetachInvestorsData, ThrowOnError>) => (options.client ?? client).post<MipClassifierControllerDetachInvestorsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip-classifier/{mipClassifierId}/investors/detach',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the editable email templates for the current Programme
 */
export const programmeEmailTemplateControllerList = <ThrowOnError extends boolean = false>(options?: Options<ProgrammeEmailTemplateControllerListData, ThrowOnError>) => (options?.client ?? client).get<ProgrammeEmailTemplateControllerListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-email-template',
    ...options
});

/**
 * Get one email template (default + current override) for editing
 */
export const programmeEmailTemplateControllerGetOne = <ThrowOnError extends boolean = false>(options: Options<ProgrammeEmailTemplateControllerGetOneData, ThrowOnError>) => (options.client ?? client).get<ProgrammeEmailTemplateControllerGetOneResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-email-template/{type}',
    ...options
});

/**
 * Update the subject, body, or send toggle of a Programme template
 */
export const programmeEmailTemplateControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<ProgrammeEmailTemplateControllerUpdateData, ThrowOnError>) => (options.client ?? client).patch<ProgrammeEmailTemplateControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-email-template/{type}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render a live preview (send-parity) of the saved or draft template
 */
export const programmeEmailTemplateControllerPreview = <ThrowOnError extends boolean = false>(options: Options<ProgrammeEmailTemplateControllerPreviewData, ThrowOnError>) => (options.client ?? client).post<ProgrammeEmailTemplateControllerPreviewResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-email-template/{type}/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send this template to the caller's own address to verify live delivery
 */
export const programmeEmailTemplateControllerTestSend = <ThrowOnError extends boolean = false>(options: Options<ProgrammeEmailTemplateControllerTestSendData, ThrowOnError>) => (options.client ?? client).post<ProgrammeEmailTemplateControllerTestSendResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-email-template/{type}/test-send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset a Programme template back to the Dealstack default
 */
export const programmeEmailTemplateControllerReset = <ThrowOnError extends boolean = false>(options: Options<ProgrammeEmailTemplateControllerResetData, ThrowOnError>) => (options.client ?? client).post<ProgrammeEmailTemplateControllerResetResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-email-template/{type}/reset',
    ...options
});

/**
 * List classifier tags for the current MIP
 */
export const tagControllerList = <ThrowOnError extends boolean = false>(options?: Options<TagControllerListData, ThrowOnError>) => (options?.client ?? client).get<TagControllerListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/tag',
    ...options
});

/**
 * Create a classifier tag scoped to the current MIP
 */
export const tagControllerCreate = <ThrowOnError extends boolean = false>(options: Options<TagControllerCreateData, ThrowOnError>) => (options.client ?? client).post<TagControllerCreateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/tag',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a MIP-scoped classifier tag and remove it from all its cohorts
 */
export const tagControllerRemove = <ThrowOnError extends boolean = false>(options: Options<TagControllerRemoveData, ThrowOnError>) => (options.client ?? client).delete<TagControllerRemoveResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/tag/{tagId}',
    ...options
});

/**
 * Rename and/or archive a MIP-scoped classifier tag
 */
export const tagControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<TagControllerUpdateData, ThrowOnError>) => (options.client ?? client).patch<TagControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/tag/{tagId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attach cohorts to a classifier tag. Idempotent — existing active links are skipped.
 */
export const tagControllerAttachClassifiers = <ThrowOnError extends boolean = false>(options: Options<TagControllerAttachClassifiersData, ThrowOnError>) => (options.client ?? client).post<TagControllerAttachClassifiersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/tag/{tagId}/classifiers/attach',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Detach cohorts from a classifier tag. Cohorts without an active link are skipped.
 */
export const tagControllerDetachClassifiers = <ThrowOnError extends boolean = false>(options: Options<TagControllerDetachClassifiersData, ThrowOnError>) => (options.client ?? client).post<TagControllerDetachClassifiersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/tag/{tagId}/classifiers/detach',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download translation for given language and given namespace
 */
export const translationsControllerTranslations = <ThrowOnError extends boolean = false>(options: Options<TranslationsControllerTranslationsData, ThrowOnError>) => (options.client ?? client).get<TranslationsControllerTranslationsResponses, unknown, ThrowOnError>({ url: '/translations/{language}/{namespace}', ...options });

/**
 * Get the tasks list
 */
export const taskControllerGet = <ThrowOnError extends boolean = false>(options: Options<TaskControllerGetData, ThrowOnError>) => (options.client ?? client).post<TaskControllerGetResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/task',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const configProviderControllerGetConfig = <ThrowOnError extends boolean = false>(options?: Options<ConfigProviderControllerGetConfigData, ThrowOnError>) => (options?.client ?? client).get<ConfigProviderControllerGetConfigResponses, unknown, ThrowOnError>({ url: '/config-provider', ...options });

/**
 * Get transaction data
 */
export const transactionControllerGetTransactions = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerGetTransactionsData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerGetTransactionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get transaction details
 */
export const transactionControllerGetTransactionDetails = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerGetTransactionDetailsData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerGetTransactionDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/transaction-details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download excel file with transactions
 */
export const transactionControllerDownloadExcel = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerDownloadExcelData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerDownloadExcelResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/download-excel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create transaction
 */
export const transactionControllerCreateTransaction = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerCreateTransactionData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerCreateTransactionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview the linked counterpart leg a single-title transfer would write
 */
export const transactionControllerPreviewTransferCounterpart = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerPreviewTransferCounterpartData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerPreviewTransferCounterpartResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/transfer-counterpart/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a nominee paired issue (mint BOTH title to the nominee, then transfer the beneficial rail to the buyer) atomically
 */
export const transactionControllerCreatePairedIssue = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerCreatePairedIssueData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerCreatePairedIssueResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/paired-issue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview the counterpart legs a nominee inseparable redemption would write
 */
export const transactionControllerPreviewInseparableRedemption = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerPreviewInseparableRedemptionData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerPreviewInseparableRedemptionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/inseparable-redemption/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restate an inseparable redemption from new intent, reconciling its legs
 */
export const transactionControllerUpdateInseparableRedemption = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerUpdateInseparableRedemptionData, ThrowOnError>) => (options.client ?? client).patch<TransactionControllerUpdateInseparableRedemptionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/inseparable-redemption',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Redeem one interest and retire the paired counterpart title over the same serials, atomically
 */
export const transactionControllerCreateInseparableRedemption = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerCreateInseparableRedemptionData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerCreateInseparableRedemptionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/inseparable-redemption',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read an inseparable redemption back as the operation entered
 */
export const transactionControllerGetInseparableRedemptionGroup = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerGetInseparableRedemptionGroupData, ThrowOnError>) => (options.client ?? client).get<TransactionControllerGetInseparableRedemptionGroupResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/inseparable-redemption/{redemptionGroupId}',
    ...options
});

/**
 * Split transaction
 */
export const transactionControllerSplitTransaction = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerSplitTransactionData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerSplitTransactionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/split',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Split a transaction into beneficial and legal interest legs
 */
export const transactionControllerSplitTransactionInterest = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerSplitTransactionInterestData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerSplitTransactionInterestResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/split-interest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get pair transactions
 */
export const transactionControllerGetPairTransaction = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerGetPairTransactionData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerGetPairTransactionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/get-pair',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pair transaction
 */
export const transactionControllerPairTransaction = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerPairTransactionData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerPairTransactionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/pair',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update transaction
 */
export const transactionControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerUpdateData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restore transaction
 */
export const transactionControllerRestore = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerRestoreData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerRestoreResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/restore',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Swap transaction order
 */
export const transactionControllerUpdateOrder = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerUpdateOrderData, ThrowOnError>) => (options.client ?? client).put<TransactionControllerUpdateOrderResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Auto reorder a group of transactions
 */
export const transactionControllerAutoReorder = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerAutoReorderData, ThrowOnError>) => (options.client ?? client).put<TransactionControllerAutoReorderResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/auto-reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Upload transaction
 */
export const transactionControllerBulkUpload = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerBulkUploadData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerBulkUploadResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/bulk-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk upload management loans transactions
 */
export const transactionControllerBulkUploadManagementLoans = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerBulkUploadManagementLoansData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerBulkUploadManagementLoansResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/management-loans/bulk-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Release InvestmentWorkflow status
 */
export const transactionControllerGetBulkUploadTaskStatus = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerGetBulkUploadTaskStatusData, ThrowOnError>) => (options.client ?? client).get<TransactionControllerGetBulkUploadTaskStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/bulk-upload/{sessionId}/status',
    ...options
});

/**
 * Bulk Update transaction
 */
export const transactionControllerBulkUpdate = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerBulkUpdateData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerBulkUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/bulk-update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk restore transaction
 */
export const transactionControllerBulkRestore = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerBulkRestoreData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerBulkRestoreResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/bulk-restore',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete transaction
 */
export const transactionControllerDeleteTransaction = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerDeleteTransactionData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerDeleteTransactionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Delete transaction
 */
export const transactionControllerBulkDeleteTransactions = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerBulkDeleteTransactionsData, ThrowOnError>) => (options.client ?? client).post<TransactionControllerBulkDeleteTransactionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/transaction/bulk-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * This will create and return upload pre signed urls
 */
export const documentControllerCreateUploadPreSignedUrls = <ThrowOnError extends boolean = false>(options: Options<DocumentControllerCreateUploadPreSignedUrlsData, ThrowOnError>) => (options.client ?? client).post<DocumentControllerCreateUploadPreSignedUrlsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document/upload-pre-signed-urls',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * create documents
 */
export const documentControllerCreateDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentControllerCreateDocumentsData, ThrowOnError>) => (options.client ?? client).post<DocumentControllerCreateDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removing a document from a person, by removing the documentLink to that person
 */
export const documentControllerRemoveDocumentPersonLink = <ThrowOnError extends boolean = false>(options: Options<DocumentControllerRemoveDocumentPersonLinkData, ThrowOnError>) => (options.client ?? client).delete<DocumentControllerRemoveDocumentPersonLinkResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document/{documentId}/person/{personId}',
    ...options
});

/**
 * Removing a document from a transaction, by removing the documentLink to that transaction
 */
export const documentControllerRemoveDocumentTransactionLink = <ThrowOnError extends boolean = false>(options: Options<DocumentControllerRemoveDocumentTransactionLinkData, ThrowOnError>) => (options.client ?? client).delete<DocumentControllerRemoveDocumentTransactionLinkResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document/{documentId}/transaction/{transactionId}',
    ...options
});

/**
 * Removing a document by soft deleting it
 */
export const documentControllerRemoveDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentControllerRemoveDocumentData, ThrowOnError>) => (options.client ?? client).delete<DocumentControllerRemoveDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document/{documentId}',
    ...options
});

/**
 * Get document with some related records
 */
export const documentControllerGetDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentControllerGetDocumentData, ThrowOnError>) => (options.client ?? client).get<DocumentControllerGetDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document/{documentId}',
    ...options
});

/**
 * update document and related fields, like classifiers, open for extension
 */
export const documentControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<DocumentControllerUpdateData, ThrowOnError>) => (options.client ?? client).put<DocumentControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document/{documentId}',
    ...options
});

/**
 * Get documents for a specific deal
 */
export const documentControllerGetDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentControllerGetDocumentsData, ThrowOnError>) => (options.client ?? client).get<DocumentControllerGetDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document',
    ...options
});

/**
 * Find related files based on a transaction and md5s
 */
export const documentControllerFindRelatedFilesInDeal = <ThrowOnError extends boolean = false>(options: Options<DocumentControllerFindRelatedFilesInDealData, ThrowOnError>) => (options.client ?? client).post<DocumentControllerFindRelatedFilesInDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document/find-related-files',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Find related documents
 */
export const documentControllerFindRelatedDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentControllerFindRelatedDocumentsData, ThrowOnError>) => (options.client ?? client).get<DocumentControllerFindRelatedDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document/{documentId}/related',
    ...options
});

/**
 * Create or update document links
 */
export const documentControllerUpdateRelatedDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentControllerUpdateRelatedDocumentsData, ThrowOnError>) => (options.client ?? client).post<DocumentControllerUpdateRelatedDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document/{documentId}/related',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all documents related to a deal with filtering
 */
export const documentLibraryControllerGetDocumentsWithFiltering = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerGetDocumentsWithFilteringData, ThrowOnError>) => (options.client ?? client).get<DocumentLibraryControllerGetDocumentsWithFilteringResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/documents',
    ...options
});

/**
 * Bulk add/remove document classifiers
 */
export const documentLibraryControllerBulkClassifyDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerBulkClassifyDocumentsData, ThrowOnError>) => (options.client ?? client).put<DocumentLibraryControllerBulkClassifyDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/document-classifiers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get document and related document details
 */
export const documentLibraryControllerGetDocumentDetails = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerGetDocumentDetailsData, ThrowOnError>) => (options.client ?? client).get<DocumentLibraryControllerGetDocumentDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/document/{documentId}',
    ...options
});

/**
 * update document and related fields, like classifiers, person/transaction assignment
 */
export const documentLibraryControllerUpdateDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerUpdateDocumentData, ThrowOnError>) => (options.client ?? client).put<DocumentLibraryControllerUpdateDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/document/{documentId}',
    ...options
});

/**
 * Get all deal classifiers by their groupings
 */
export const documentLibraryControllerGetDealClassifiersByGroups = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerGetDealClassifiersByGroupsData, ThrowOnError>) => (options.client ?? client).get<DocumentLibraryControllerGetDealClassifiersByGroupsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/classifier-groups',
    ...options
});

/**
 * download more than one document
 */
export const documentLibraryControllerBulkDownloadDocumentFiles = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerBulkDownloadDocumentFilesData, ThrowOnError>) => (options.client ?? client).post<DocumentLibraryControllerBulkDownloadDocumentFilesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/bulk-download',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk soft-delete library-uploaded documents. Workflow-generated documents are skipped server-side as defense in depth.
 */
export const documentLibraryControllerBulkDeleteDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerBulkDeleteDocumentsData, ThrowOnError>) => (options.client ?? client).post<DocumentLibraryControllerBulkDeleteDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/bulk-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all persons within a deal (natural or legal)
 */
export const documentLibraryControllerGetPersonsInDeal = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerGetPersonsInDealData, ThrowOnError>) => (options.client ?? client).get<DocumentLibraryControllerGetPersonsInDealResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/persons-in-deal',
    ...options
});

/**
 * Remove persons from a document
 */
export const documentLibraryControllerRemovePersonsFromDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerRemovePersonsFromDocumentData, ThrowOnError>) => (options.client ?? client).post<DocumentLibraryControllerRemovePersonsFromDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/remove-persons-from-document/{documentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add persons to a document
 */
export const documentLibraryControllerAddPersonsToDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerAddPersonsToDocumentData, ThrowOnError>) => (options.client ?? client).post<DocumentLibraryControllerAddPersonsToDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/add-persons-to-document/{documentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Show or hide a document in the investor portal for specific linked persons
 *
 * Flips investor-portal visibility per person link without removing the link itself. Requires deal admin; Dealstack Support passes via the guard-level support bypass.
 */
export const documentLibraryControllerSetPersonDocumentVisibility = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerSetPersonDocumentVisibilityData, ThrowOnError>) => (options.client ?? client).patch<DocumentLibraryControllerSetPersonDocumentVisibilityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/document/{documentId}/person-visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add multiple persons to multiple documents
 */
export const documentLibraryControllerAddPersonsToDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerAddPersonsToDocumentsData, ThrowOnError>) => (options.client ?? client).post<DocumentLibraryControllerAddPersonsToDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/add-persons-to-documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove multiple persons from multiple documents
 */
export const documentLibraryControllerRemovePersonsFromDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentLibraryControllerRemovePersonsFromDocumentsData, ThrowOnError>) => (options.client ?? client).post<DocumentLibraryControllerRemovePersonsFromDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/document-library/remove-persons-from-documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload a document for extraction, bound to the deal
 */
export const documentParsingControllerUploadExtractionDocument = <ThrowOnError extends boolean = false>(options?: Options<DocumentParsingControllerUploadExtractionDocumentData, ThrowOnError>) => (options?.client ?? client).post<DocumentParsingControllerUploadExtractionDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/upload',
    ...options
});

/**
 * Start document extraction for one or more documents
 */
export const documentParsingControllerStartExtraction = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerStartExtractionData, ThrowOnError>) => (options.client ?? client).post<DocumentParsingControllerStartExtractionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/start-extraction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the status of a document extraction task
 */
export const documentParsingControllerGetExtractionStatus = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerGetExtractionStatusData, ThrowOnError>) => (options.client ?? client).get<DocumentParsingControllerGetExtractionStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/extraction/{taskId}/status',
    ...options
});

/**
 * Get the results of a completed document extraction task
 */
export const documentParsingControllerGetExtractionResult = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerGetExtractionResultData, ThrowOnError>) => (options.client ?? client).get<DocumentParsingControllerGetExtractionResultResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/extraction/{taskId}/result',
    ...options
});

/**
 * List document extraction batches for a deal and person
 */
export const documentParsingControllerListBatches = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerListBatchesData, ThrowOnError>) => (options.client ?? client).get<DocumentParsingControllerListBatchesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/batches',
    ...options
});

/**
 * List all document extraction batches for a deal
 */
export const documentParsingControllerListDealBatches = <ThrowOnError extends boolean = false>(options?: Options<DocumentParsingControllerListDealBatchesData, ThrowOnError>) => (options?.client ?? client).get<DocumentParsingControllerListDealBatchesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/deal-batches',
    ...options
});

/**
 * Update the title of a document extraction batch
 */
export const documentParsingControllerUpdateBatchTitle = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerUpdateBatchTitleData, ThrowOnError>) => (options.client ?? client).patch<DocumentParsingControllerUpdateBatchTitleResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/extraction/batch/{batchId}/title',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get extracted transactions for a document from the external extraction service
 */
export const documentParsingControllerGetDocumentTransactions = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerGetDocumentTransactionsData, ThrowOnError>) => (options.client ?? client).get<DocumentParsingControllerGetDocumentTransactionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/document/{documentId}/transactions',
    ...options
});

/**
 * Get all transactions for a completed batch
 */
export const documentParsingControllerGetBatchTransactions = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerGetBatchTransactionsData, ThrowOnError>) => (options.client ?? client).get<DocumentParsingControllerGetBatchTransactionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/batch/{batchId}/transactions',
    ...options
});

/**
 * Get aggregated overview stats for a batch analysis
 */
export const documentParsingControllerGetBatchOverview = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerGetBatchOverviewData, ThrowOnError>) => (options.client ?? client).get<DocumentParsingControllerGetBatchOverviewResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/batch/{batchId}/overview',
    ...options
});

/**
 * Get paginated list of documents in a batch with enriched data
 */
export const documentParsingControllerGetBatchDocuments = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerGetBatchDocumentsData, ThrowOnError>) => (options.client ?? client).get<DocumentParsingControllerGetBatchDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/batch/{batchId}/documents',
    ...options
});

/**
 * Persist per-extracted-transaction user overrides (e.g. the date the user typed in the missing-fields modal). The endpoint name is historical — the actual merge into the cap table still goes through /cap/transaction/bulk-upload.
 */
export const documentParsingControllerSaveBatchExtractionOverrides = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerSaveBatchExtractionOverridesData, ThrowOnError>) => (options.client ?? client).post<DocumentParsingControllerSaveBatchExtractionOverridesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/batch/{batchId}/merge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get securities found in batch with match statuses
 */
export const documentParsingControllerGetBatchSecurities = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerGetBatchSecuritiesData, ThrowOnError>) => (options.client ?? client).get<DocumentParsingControllerGetBatchSecuritiesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/batch/{batchId}/securities',
    ...options
});

/**
 * Get people found in batch with match statuses
 */
export const documentParsingControllerGetBatchPeople = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerGetBatchPeopleData, ThrowOnError>) => (options.client ?? client).get<DocumentParsingControllerGetBatchPeopleResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/batch/{batchId}/people',
    ...options
});

/**
 * Link an extracted person to an existing deal Person
 */
export const documentParsingControllerMatchBatchPerson = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerMatchBatchPersonData, ThrowOnError>) => (options.client ?? client).post<DocumentParsingControllerMatchBatchPersonResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/batch/{batchId}/people/match',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link an extracted security to an existing deal Security
 */
export const documentParsingControllerMatchBatchSecurity = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerMatchBatchSecurityData, ThrowOnError>) => (options.client ?? client).post<DocumentParsingControllerMatchBatchSecurityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/batch/{batchId}/securities/match',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Re-run extraction pipeline for a batch using a user-supplied system prompt.
 */
export const documentParsingControllerReextractBatch = <ThrowOnError extends boolean = false>(options: Options<DocumentParsingControllerReextractBatchData, ThrowOnError>) => (options.client ?? client).post<DocumentParsingControllerReextractBatchResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/document-parsing/batch/{batchId}/reextract',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all classifiers
 */
export const classifierControllerGetAllClassifiers = <ThrowOnError extends boolean = false>(options?: Options<ClassifierControllerGetAllClassifiersData, ThrowOnError>) => (options?.client ?? client).get<ClassifierControllerGetAllClassifiersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/classifier',
    ...options
});

/**
 * Get all deal classifiers
 */
export const classifierControllerGetDealClassifiers = <ThrowOnError extends boolean = false>(options: Options<ClassifierControllerGetDealClassifiersData, ThrowOnError>) => (options.client ?? client).get<ClassifierControllerGetDealClassifiersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/classifier/deal-classifier',
    ...options
});

/**
 * create a deal classifiers
 */
export const classifierControllerPostDealClassifiers = <ThrowOnError extends boolean = false>(options?: Options<ClassifierControllerPostDealClassifiersData, ThrowOnError>) => (options?.client ?? client).post<ClassifierControllerPostDealClassifiersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/classifier/deal-classifier',
    ...options
});

/**
 * Get the consolidated event feed for a deal
 */
export const dealEventLogControllerGetDealEvents = <ThrowOnError extends boolean = false>(options?: Options<DealEventLogControllerGetDealEventsData, ThrowOnError>) => (options?.client ?? client).get<DealEventLogControllerGetDealEventsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-event-log/events',
    ...options
});

/**
 * Count the events of a deal per day, under the same filters as the feed
 */
export const dealEventLogControllerGetDealEventDailyCounts = <ThrowOnError extends boolean = false>(options?: Options<DealEventLogControllerGetDealEventDailyCountsData, ThrowOnError>) => (options?.client ?? client).get<DealEventLogControllerGetDealEventDailyCountsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-event-log/events/daily-counts',
    ...options
});

/**
 * Export the filtered feed of a deal as CSV, newest first, capped at 10000 rows
 */
export const dealEventLogControllerExportDealEvents = <ThrowOnError extends boolean = false>(options?: Options<DealEventLogControllerExportDealEventsData, ThrowOnError>) => (options?.client ?? client).get<DealEventLogControllerExportDealEventsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-event-log/events/export',
    ...options
});

/**
 * List the distinct recipients of a deal's emails, for the filter
 */
export const dealEventLogControllerGetDealEventRecipients = <ThrowOnError extends boolean = false>(options?: Options<DealEventLogControllerGetDealEventRecipientsData, ThrowOnError>) => (options?.client ?? client).get<DealEventLogControllerGetDealEventRecipientsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-event-log/events/recipients',
    ...options
});

/**
 * Read one of the deal's messages, for the feed's drill-down
 */
export const dealEventLogControllerGetDealEventMessage = <ThrowOnError extends boolean = false>(options: Options<DealEventLogControllerGetDealEventMessageData, ThrowOnError>) => (options.client ?? client).get<DealEventLogControllerGetDealEventMessageResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-event-log/events/messages/{messageId}',
    ...options
});

/**
 * List the senders of a deal's messages, for the filter
 */
export const dealEventLogControllerGetDealEventSenders = <ThrowOnError extends boolean = false>(options?: Options<DealEventLogControllerGetDealEventSendersData, ThrowOnError>) => (options?.client ?? client).get<DealEventLogControllerGetDealEventSendersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-event-log/events/senders',
    ...options
});

/**
 * List the users a deal's team and access events are about, for the filter
 */
export const dealEventLogControllerGetDealEventSubjects = <ThrowOnError extends boolean = false>(options?: Options<DealEventLogControllerGetDealEventSubjectsData, ThrowOnError>) => (options?.client ?? client).get<DealEventLogControllerGetDealEventSubjectsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-event-log/events/subjects',
    ...options
});

/**
 * Count deal events since the user last opened the event log
 */
export const dealEventLogControllerGetUnread = <ThrowOnError extends boolean = false>(options?: Options<DealEventLogControllerGetUnreadData, ThrowOnError>) => (options?.client ?? client).get<DealEventLogControllerGetUnreadResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-event-log/unread',
    ...options
});

/**
 * Mark the deal event log as viewed by the user
 */
export const dealEventLogControllerMarkViewed = <ThrowOnError extends boolean = false>(options?: Options<DealEventLogControllerMarkViewedData, ThrowOnError>) => (options?.client ?? client).post<DealEventLogControllerMarkViewedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal-event-log/viewed',
    ...options
});

/**
 * Get security events data
 */
export const securityEventControllerGetSecurityEvents = <ThrowOnError extends boolean = false>(options: Options<SecurityEventControllerGetSecurityEventsData, ThrowOnError>) => (options.client ?? client).post<SecurityEventControllerGetSecurityEventsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/security-event/events-list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create security event
 */
export const securityEventControllerCreateSecurityEvent = <ThrowOnError extends boolean = false>(options: Options<SecurityEventControllerCreateSecurityEventData, ThrowOnError>) => (options.client ?? client).post<SecurityEventControllerCreateSecurityEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/security-event/create-security-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update security event
 */
export const securityEventControllerUpdateSecurityEvent = <ThrowOnError extends boolean = false>(options: Options<SecurityEventControllerUpdateSecurityEventData, ThrowOnError>) => (options.client ?? client).post<SecurityEventControllerUpdateSecurityEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/security-event/update-security-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft delete security event
 */
export const securityEventControllerSoftDeleteSecurityEvent = <ThrowOnError extends boolean = false>(options: Options<SecurityEventControllerSoftDeleteSecurityEventData, ThrowOnError>) => (options.client ?? client).post<SecurityEventControllerSoftDeleteSecurityEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/security-event/soft-delete-security-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all valuations with classifiers
 */
export const valuationControllerGetValuationsAndJoinWithClassifiers = <ThrowOnError extends boolean = false>(options: Options<ValuationControllerGetValuationsAndJoinWithClassifiersData, ThrowOnError>) => (options.client ?? client).get<ValuationControllerGetValuationsAndJoinWithClassifiersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation',
    ...options
});

/**
 * Create valuation
 */
export const valuationControllerCreateValuation = <ThrowOnError extends boolean = false>(options: Options<ValuationControllerCreateValuationData, ThrowOnError>) => (options.client ?? client).post<ValuationControllerCreateValuationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete valuation
 */
export const valuationControllerDeleteValuation = <ThrowOnError extends boolean = false>(options: Options<ValuationControllerDeleteValuationData, ThrowOnError>) => (options.client ?? client).delete<ValuationControllerDeleteValuationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}',
    ...options
});

/**
 * Update valuation with classifiers
 */
export const valuationControllerUpdateValuationWithClassifiers = <ThrowOnError extends boolean = false>(options: Options<ValuationControllerUpdateValuationWithClassifiersData, ThrowOnError>) => (options.client ?? client).patch<ValuationControllerUpdateValuationWithClassifiersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upsert valuation by client-supplied id. Creates if missing, updates if present. Used by the autosave so the valuation id is stable from the form mount.
 */
export const valuationControllerUpsertValuation = <ThrowOnError extends boolean = false>(options: Options<ValuationControllerUpsertValuationData, ThrowOnError>) => (options.client ?? client).put<ValuationControllerUpsertValuationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplicate valuation
 */
export const valuationControllerDuplicateValuation = <ThrowOnError extends boolean = false>(options: Options<ValuationControllerDuplicateValuationData, ThrowOnError>) => (options.client ?? client).post<ValuationControllerDuplicateValuationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/duplicate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all valuation inputs for a given valuation
 */
export const valuationInputControllerGetValuationInputs = <ThrowOnError extends boolean = false>(options: Options<ValuationInputControllerGetValuationInputsData, ThrowOnError>) => (options.client ?? client).get<ValuationInputControllerGetValuationInputsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/input',
    ...options
});

/**
 * Upsert valuation inputs and adjustments. Adjustments with id are updated; without id are created.
 */
export const valuationInputControllerUpsert = <ThrowOnError extends boolean = false>(options: Options<ValuationInputControllerUpsertData, ThrowOnError>) => (options.client ?? client).put<ValuationInputControllerUpsertResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/input',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update valuation input
 */
export const valuationInputControllerUpdateValuationInput = <ThrowOnError extends boolean = false>(options: Options<ValuationInputControllerUpdateValuationInputData, ThrowOnError>) => (options.client ?? client).patch<ValuationInputControllerUpdateValuationInputResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/input/{valuationInputId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create valuation input adjustment
 */
export const valuationInputControllerCreateValuationInputAdjustment = <ThrowOnError extends boolean = false>(options: Options<ValuationInputControllerCreateValuationInputAdjustmentData, ThrowOnError>) => (options.client ?? client).post<ValuationInputControllerCreateValuationInputAdjustmentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/input/{valuationInputId}/adjustment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete valuation input adjustment
 */
export const valuationInputControllerDeleteValuationInputAdjustment = <ThrowOnError extends boolean = false>(options: Options<ValuationInputControllerDeleteValuationInputAdjustmentData, ThrowOnError>) => (options.client ?? client).delete<ValuationInputControllerDeleteValuationInputAdjustmentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/input/{valuationInputId}/adjustment/{valuationInputAdjustmentId}',
    ...options
});

/**
 * Update valuation input adjustment
 */
export const valuationInputControllerUpdateValuationInputAdjustment = <ThrowOnError extends boolean = false>(options: Options<ValuationInputControllerUpdateValuationInputAdjustmentData, ThrowOnError>) => (options.client ?? client).patch<ValuationInputControllerUpdateValuationInputAdjustmentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/input/{valuationInputId}/adjustment/{valuationInputAdjustmentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get latest exchange rate
 */
export const foreignExchangeControllerGetLatestExchangeRate = <ThrowOnError extends boolean = false>(options: Options<ForeignExchangeControllerGetLatestExchangeRateData, ThrowOnError>) => (options.client ?? client).get<ForeignExchangeControllerGetLatestExchangeRateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/fx',
    ...options
});

/**
 * Get historical and custom exchange rate
 */
export const foreignExchangeControllerGetHistoricalAndCustomExchangeRate = <ThrowOnError extends boolean = false>(options: Options<ForeignExchangeControllerGetHistoricalAndCustomExchangeRateData, ThrowOnError>) => (options.client ?? client).get<ForeignExchangeControllerGetHistoricalAndCustomExchangeRateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/fx',
    ...options
});

/**
 * Put custom foreign exchange rate
 */
export const foreignExchangeControllerPutCustomExchangeRate = <ThrowOnError extends boolean = false>(options: Options<ForeignExchangeControllerPutCustomExchangeRateData, ThrowOnError>) => (options.client ?? client).put<ForeignExchangeControllerPutCustomExchangeRateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/fx',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get currencies used in a valuation
 */
export const foreignExchangeControllerGetCurrenciesUsedInValuation = <ThrowOnError extends boolean = false>(options: Options<ForeignExchangeControllerGetCurrenciesUsedInValuationData, ThrowOnError>) => (options.client ?? client).get<ForeignExchangeControllerGetCurrenciesUsedInValuationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/currency',
    ...options
});

/**
 * Get valuation person inputs
 */
export const valuationPersonInputControllerGetValuationPersonInputs = <ThrowOnError extends boolean = false>(options: Options<ValuationPersonInputControllerGetValuationPersonInputsData, ThrowOnError>) => (options.client ?? client).get<ValuationPersonInputControllerGetValuationPersonInputsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/input',
    ...options
});

/**
 * Create valuation person input
 */
export const valuationPersonInputControllerCreateValuationPersonInput = <ThrowOnError extends boolean = false>(options: Options<ValuationPersonInputControllerCreateValuationPersonInputData, ThrowOnError>) => (options.client ?? client).post<ValuationPersonInputControllerCreateValuationPersonInputResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/input',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upsert valuation person inputs. Items with id are updated; items without id are created.
 */
export const valuationPersonInputControllerUpsertValuationPersonInputs = <ThrowOnError extends boolean = false>(options: Options<ValuationPersonInputControllerUpsertValuationPersonInputsData, ThrowOnError>) => (options.client ?? client).put<ValuationPersonInputControllerUpsertValuationPersonInputsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/input',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete valuation person input
 */
export const valuationPersonInputControllerDeleteValuationPersonInput = <ThrowOnError extends boolean = false>(options: Options<ValuationPersonInputControllerDeleteValuationPersonInputData, ThrowOnError>) => (options.client ?? client).delete<ValuationPersonInputControllerDeleteValuationPersonInputResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/input/{inputId}',
    ...options
});

/**
 * Update valuation person input
 */
export const valuationPersonInputControllerUpdateValuationPersonInput = <ThrowOnError extends boolean = false>(options: Options<ValuationPersonInputControllerUpdateValuationPersonInputData, ThrowOnError>) => (options.client ?? client).patch<ValuationPersonInputControllerUpdateValuationPersonInputResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/input/{inputId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start a valuation compute (Temporal workflow) and return its workflowId; open calculate-valuation/stream with that id to receive live progress + the result reference
 */
export const valuationSummaryControllerStartCalculateValuation = <ThrowOnError extends boolean = false>(options: Options<ValuationSummaryControllerStartCalculateValuationData, ThrowOnError>) => (options.client ?? client).post<ValuationSummaryControllerStartCalculateValuationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/calculate-valuation/start',
    ...options
});

/**
 * Stream a running valuation compute as SSE (progress relayed from Redis); the terminal `result` event carries the compute result reference ({ resultId }), `error` a failure
 */
export const valuationSummaryControllerStreamCalculateValuation = <ThrowOnError extends boolean = false>(options: Options<ValuationSummaryControllerStreamCalculateValuationData, ThrowOnError>) => (options.client ?? client).get<ValuationSummaryControllerStreamCalculateValuationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/calculate-valuation/stream',
    ...options
});

/**
 * Get a calculated valuation summary by its compute result reference
 */
export const valuationSummaryControllerGetValuationSummaryResult = <ThrowOnError extends boolean = false>(options: Options<ValuationSummaryControllerGetValuationSummaryResultData, ThrowOnError>) => (options.client ?? client).get<ValuationSummaryControllerGetValuationSummaryResultResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/calculate-valuation/result/{resultId}',
    ...options
});

/**
 * Get valuation breakpoint summary
 */
export const valuationSummaryControllerGetValuationBreakpointSummary = <ThrowOnError extends boolean = false>(options: Options<ValuationSummaryControllerGetValuationBreakpointSummaryData, ThrowOnError>) => (options.client ?? client).get<ValuationSummaryControllerGetValuationBreakpointSummaryResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/breakpoint',
    ...options
});

/**
 * Download the per-tranche interest ledger as xlsx
 */
export const valuationSummaryControllerDownloadInterestEventsExcel = <ThrowOnError extends boolean = false>(options: Options<ValuationSummaryControllerDownloadInterestEventsExcelData, ThrowOnError>) => (options.client ?? client).get<ValuationSummaryControllerDownloadInterestEventsExcelResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/interest-events-excel',
    ...options
});

/**
 * Download valuation summary excel
 */
export const valuationSummaryControllerDownloadExcel = <ThrowOnError extends boolean = false>(options: Options<ValuationSummaryControllerDownloadExcelData, ThrowOnError>) => (options.client ?? client).get<ValuationSummaryControllerDownloadExcelResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/summary-excel',
    ...options
});

/**
 * Create security value override
 */
export const securityValueOverrideControllerCreateSecurityValueOverride = <ThrowOnError extends boolean = false>(options: Options<SecurityValueOverrideControllerCreateSecurityValueOverrideData, ThrowOnError>) => (options.client ?? client).post<SecurityValueOverrideControllerCreateSecurityValueOverrideResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/securityValueOverride',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete security value override
 */
export const securityValueOverrideControllerDeleteSecurityValueOverride = <ThrowOnError extends boolean = false>(options: Options<SecurityValueOverrideControllerDeleteSecurityValueOverrideData, ThrowOnError>) => (options.client ?? client).delete<SecurityValueOverrideControllerDeleteSecurityValueOverrideResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/securityValueOverride/{securityValueOverrideId}',
    ...options
});

/**
 * Update security value override
 */
export const securityValueOverrideControllerUpdateSecurityValueOverride = <ThrowOnError extends boolean = false>(options: Options<SecurityValueOverrideControllerUpdateSecurityValueOverrideData, ThrowOnError>) => (options.client ?? client).patch<SecurityValueOverrideControllerUpdateSecurityValueOverrideResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/valuation/{valuationId}/securityValueOverride/{securityValueOverrideId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate PDF share register for an issuer, upload to S3, and return presigned download URL
 */
export const holdingsControllerGenerateShareRegisterPdf = <ThrowOnError extends boolean = false>(options: Options<HoldingsControllerGenerateShareRegisterPdfData, ThrowOnError>) => (options.client ?? client).get<HoldingsControllerGenerateShareRegisterPdfResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/share-register-pdf/{issuerId}',
    ...options
});

/**
 * Render the share-register PDF and stream the bytes inline (application/pdf). Does NOT persist to S3 or create a File row — intended for perf testing.
 */
export const holdingsControllerGenerateShareRegisterPdfInline = <ThrowOnError extends boolean = false>(options: Options<HoldingsControllerGenerateShareRegisterPdfInlineData, ThrowOnError>) => (options.client ?? client).get<HoldingsControllerGenerateShareRegisterPdfInlineResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/share-register-pdf/{issuerId}/inline',
    ...options
});

/**
 * Start async share-register PDF generation; returns a task id to poll via the status endpoint
 */
export const holdingsControllerStartShareRegisterPdfGeneration = <ThrowOnError extends boolean = false>(options: Options<HoldingsControllerStartShareRegisterPdfGenerationData, ThrowOnError>) => (options.client ?? client).post<HoldingsControllerStartShareRegisterPdfGenerationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/share-register-pdf/{issuerId}/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get share-register PDF generation task status; returns downloadUrl when status is DONE
 */
export const holdingsControllerGetShareRegisterPdfTaskStatus = <ThrowOnError extends boolean = false>(options: Options<HoldingsControllerGetShareRegisterPdfTaskStatusData, ThrowOnError>) => (options.client ?? client).get<HoldingsControllerGetShareRegisterPdfTaskStatusResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/share-register-pdf/task/{taskId}/status',
    ...options
});

/**
 * Get Holdings List for Person
 */
export const holdingsControllerPostHoldingsListForPerson = <ThrowOnError extends boolean = false>(options: Options<HoldingsControllerPostHoldingsListForPersonData, ThrowOnError>) => (options.client ?? client).post<HoldingsControllerPostHoldingsListForPersonResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/holdings-list-for-person',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Holding Details
 */
export const holdingsControllerGetHoldingByPersonAndSecurity = <ThrowOnError extends boolean = false>(options: Options<HoldingsControllerGetHoldingByPersonAndSecurityData, ThrowOnError>) => (options.client ?? client).get<HoldingsControllerGetHoldingByPersonAndSecurityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/holdings/person/{personId}/security/{securityId}',
    ...options
});

/**
 * Get Holding Events List
 */
export const holdingsControllerGetHoldingEventsListByPersonAndSecurity = <ThrowOnError extends boolean = false>(options: Options<HoldingsControllerGetHoldingEventsListByPersonAndSecurityData, ThrowOnError>) => (options.client ?? client).get<HoldingsControllerGetHoldingEventsListByPersonAndSecurityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/holdings/person/{personId}/security/{securityId}/events',
    ...options
});

/**
 * Get Wide View Holdings CSV
 */
export const holdingsControllerPostWideViewHoldingsCsv = <ThrowOnError extends boolean = false>(options: Options<HoldingsControllerPostWideViewHoldingsCsvData, ThrowOnError>) => (options.client ?? client).post<HoldingsControllerPostWideViewHoldingsCsvResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/wide-view-csv',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Regular View Holdings CSV
 */
export const holdingsControllerPostRegularViewHoldingsCsv = <ThrowOnError extends boolean = false>(options: Options<HoldingsControllerPostRegularViewHoldingsCsvData, ThrowOnError>) => (options.client ?? client).post<HoldingsControllerPostRegularViewHoldingsCsvResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/regular-view-csv',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download excel file with holdings table data
 */
export const holdingsControllerDownloadHoldingsExcel = <ThrowOnError extends boolean = false>(options: Options<HoldingsControllerDownloadHoldingsExcelData, ThrowOnError>) => (options.client ?? client).get<HoldingsControllerDownloadHoldingsExcelResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/holdings-excel',
    ...options
});

/**
 * Download xlsx with vesting events report
 */
export const holdingsControllerDownloadVestingEventsReport = <ThrowOnError extends boolean = false>(options: Options<HoldingsControllerDownloadVestingEventsReportData, ThrowOnError>) => (options.client ?? client).get<HoldingsControllerDownloadVestingEventsReportResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/vesting-events-report',
    ...options
});

/**
 * Create holding event
 */
export const holdingEventControllerCreateHoldingEvent = <ThrowOnError extends boolean = false>(options: Options<HoldingEventControllerCreateHoldingEventData, ThrowOnError>) => (options.client ?? client).post<HoldingEventControllerCreateHoldingEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/holdings-event/create-holdings-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create multiple holding events
 */
export const holdingEventControllerCreateBulkHoldingEvents = <ThrowOnError extends boolean = false>(options: Options<HoldingEventControllerCreateBulkHoldingEventsData, ThrowOnError>) => (options.client ?? client).post<HoldingEventControllerCreateBulkHoldingEventsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/holdings-event/create-bulk-holdings-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update holding event
 */
export const holdingEventControllerUpdateHoldingEvent = <ThrowOnError extends boolean = false>(options: Options<HoldingEventControllerUpdateHoldingEventData, ThrowOnError>) => (options.client ?? client).post<HoldingEventControllerUpdateHoldingEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/holdings-event/update-holdings-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft delete holding event
 */
export const holdingEventControllerSoftDeleteHoldingEvent = <ThrowOnError extends boolean = false>(options: Options<HoldingEventControllerSoftDeleteHoldingEventData, ThrowOnError>) => (options.client ?? client).post<HoldingEventControllerSoftDeleteHoldingEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/cap/holdings-event/soft-delete-holdings-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * pre-initialize the e2e user pool before tests run
 */
export const e2eControllerWarmupPool = <ThrowOnError extends boolean = false>(options: Options<E2eControllerWarmupPoolData, ThrowOnError>) => (options.client ?? client).post<E2eControllerWarmupPoolResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/warmup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * create test user
 */
export const e2eControllerCreateUser = <ThrowOnError extends boolean = false>(options: Options<E2eControllerCreateUserData, ThrowOnError>) => (options.client ?? client).post<E2eControllerCreateUserResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * authenticate a user against workos and return cookies
 */
export const e2eControllerAuthenticateUser = <ThrowOnError extends boolean = false>(options: Options<E2eControllerAuthenticateUserData, ThrowOnError>) => (options.client ?? client).post<E2eControllerAuthenticateUserResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/authenticate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get the captured WorkOS change-email verification code
 */
export const e2eControllerGetChangeEmailVerificationCode = <ThrowOnError extends boolean = false>(options: Options<E2eControllerGetChangeEmailVerificationCodeData, ThrowOnError>) => (options.client ?? client).post<E2eControllerGetChangeEmailVerificationCodeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/change-email-verification-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * read the newest WorkOS email verification code for an address from WorkOS events
 */
export const e2eControllerGetWorkOsEmailVerificationCode = <ThrowOnError extends boolean = false>(options: Options<E2eControllerGetWorkOsEmailVerificationCodeData, ThrowOnError>) => (options.client ?? client).post<E2eControllerGetWorkOsEmailVerificationCodeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/workos-email-verification-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * read the newest WorkOS magic auth code for an address from WorkOS events
 */
export const e2eControllerGetWorkOsMagicAuthCode = <ThrowOnError extends boolean = false>(options: Options<E2eControllerGetWorkOsMagicAuthCodeData, ThrowOnError>) => (options.client ?? client).post<E2eControllerGetWorkOsMagicAuthCodeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/workos-magic-auth-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * read the newest WorkOS password reset link for an address from WorkOS events
 */
export const e2eControllerGetWorkOsPasswordResetLink = <ThrowOnError extends boolean = false>(options: Options<E2eControllerGetWorkOsPasswordResetLinkData, ThrowOnError>) => (options.client ?? client).post<E2eControllerGetWorkOsPasswordResetLinkResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/workos-password-reset-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * ensure and report this environment’s SSO fixture organisations and canonical user
 */
export const e2eControllerGetSsoFixture = <ThrowOnError extends boolean = false>(options?: Options<E2eControllerGetSsoFixtureData, ThrowOnError>) => (options?.client ?? client).get<E2eControllerGetSsoFixtureResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/sso-fixture',
    ...options
});

/**
 * reset a MUTABLE SSO fixture organisation (B or C) to a known state
 */
export const e2eControllerResetSsoOrganization = <ThrowOnError extends boolean = false>(options: Options<E2eControllerResetSsoOrganizationData, ThrowOnError>) => (options.client ?? client).post<E2eControllerResetSsoOrganizationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/sso-organization/{label}/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * report the emails the app recorded sending to an address, newest last
 */
export const e2eControllerGetSentEmails = <ThrowOnError extends boolean = false>(options: Options<E2eControllerGetSentEmailsData, ThrowOnError>) => (options.client ?? client).get<E2eControllerGetSentEmailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/emails',
    ...options
});

/**
 * report the WorkOS identity behind an address and the organisations it belongs to
 */
export const e2eControllerGetWorkOsUser = <ThrowOnError extends boolean = false>(options: Options<E2eControllerGetWorkOsUserData, ThrowOnError>) => (options.client ?? client).get<E2eControllerGetWorkOsUserResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/workos-user',
    ...options
});

/**
 * create a WorkOS identity for an address without touching the local database
 */
export const e2eControllerCreateWorkOsUser = <ThrowOnError extends boolean = false>(options: Options<E2eControllerCreateWorkOsUserData, ThrowOnError>) => (options.client ?? client).post<E2eControllerCreateWorkOsUserResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/workos-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * move a WorkOS identity onto another address, as a customer’s IdP would
 */
export const e2eControllerChangeWorkOsUserEmail = <ThrowOnError extends boolean = false>(options: Options<E2eControllerChangeWorkOsUserEmailData, ThrowOnError>) => (options.client ?? client).post<E2eControllerChangeWorkOsUserEmailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/workos-user/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * accept a WorkOS invitation outside sign-in, so no DealStack user gets linked
 */
export const e2eControllerAcceptWorkOsInvitation = <ThrowOnError extends boolean = false>(options: Options<E2eControllerAcceptWorkOsInvitationData, ThrowOnError>) => (options.client ?? client).post<E2eControllerAcceptWorkOsInvitationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/workos-invitation/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * run one WorkOS event ingest+sweep pass synchronously
 */
export const e2eControllerPollWorkOsEvents = <ThrowOnError extends boolean = false>(options?: Options<E2eControllerPollWorkOsEventsData, ThrowOnError>) => (options?.client ?? client).post<E2eControllerPollWorkOsEventsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/workos-events/poll',
    ...options
});

/**
 * Disable KYC requirement for a MIP
 */
export const e2eControllerDisableMipKyc = <ThrowOnError extends boolean = false>(options: Options<E2eControllerDisableMipKycData, ThrowOnError>) => (options.client ?? client).patch<E2eControllerDisableMipKycResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/e2e/mip/{mipId}/disable-kyc',
    ...options
});

/**
 * collect Content-Security-Policy violation reports
 */
export const cspReportControllerCollectReport = <ThrowOnError extends boolean = false>(options: Options<CspReportControllerCollectReportData, ThrowOnError>) => (options.client ?? client).post<CspReportControllerCollectReportResponses, unknown, ThrowOnError>({
    url: '/csp-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const eidEasyWebhookControllerDocumentSigned = <ThrowOnError extends boolean = false>(options: Options<EidEasyWebhookControllerDocumentSignedData, ThrowOnError>) => (options.client ?? client).post<EidEasyWebhookControllerDocumentSignedResponses, unknown, ThrowOnError>({ url: '/eid-easy/webhook/document-signed', ...options });

export const eidEasyWebhookControllerCustomSignatureImage = <ThrowOnError extends boolean = false>(options: Options<EidEasyWebhookControllerCustomSignatureImageData, ThrowOnError>) => (options.client ?? client).post<EidEasyWebhookControllerCustomSignatureImageResponses, unknown, ThrowOnError>({
    url: '/eid-easy/webhook/custom-signature-image',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * WorkOS webhook - drains the events queue, payload unused
 */
export const workOsWebhookControllerWebhook = <ThrowOnError extends boolean = false>(options: Options<WorkOsWebhookControllerWebhookData, ThrowOnError>) => (options.client ?? client).post<WorkOsWebhookControllerWebhookResponses, unknown, ThrowOnError>({ url: '/workos/webhook', ...options });

export const eidEasyMockControllerSignPage = <ThrowOnError extends boolean = false>(options: Options<EidEasyMockControllerSignPageData, ThrowOnError>) => (options.client ?? client).get<EidEasyMockControllerSignPageResponses, unknown, ThrowOnError>({ url: '/eid-easy/mock/sign-page', ...options });

export const eidEasyMockControllerVerifyOtp = <ThrowOnError extends boolean = false>(options: Options<EidEasyMockControllerVerifyOtpData, ThrowOnError>) => (options.client ?? client).post<EidEasyMockControllerVerifyOtpResponses, unknown, ThrowOnError>({
    url: '/eid-easy/mock/verify-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const eidEasyMockControllerComplete = <ThrowOnError extends boolean = false>(options: Options<EidEasyMockControllerCompleteData, ThrowOnError>) => (options.client ?? client).post<EidEasyMockControllerCompleteResponses, unknown, ThrowOnError>({
    url: '/eid-easy/mock/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const healthControllerHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthControllerHealthCheckData, ThrowOnError>) => (options?.client ?? client).get<HealthControllerHealthCheckResponses, HealthControllerHealthCheckErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/health',
    ...options
});

/**
 * List the people seeded onto every new deal or programme
 */
export const organizationDefaultMemberControllerListMembers = <ThrowOnError extends boolean = false>(options: Options<OrganizationDefaultMemberControllerListMembersData, ThrowOnError>) => (options.client ?? client).get<OrganizationDefaultMemberControllerListMembersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization-defaults/members/{organizationId}/{resourceType}',
    ...options
});

/**
 * Add a default member. Sends no invitation.
 */
export const organizationDefaultMemberControllerAddMember = <ThrowOnError extends boolean = false>(options: Options<OrganizationDefaultMemberControllerAddMemberData, ThrowOnError>) => (options.client ?? client).post<OrganizationDefaultMemberControllerAddMemberResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization-defaults/members/{organizationId}/{resourceType}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a default member
 */
export const organizationDefaultMemberControllerRemoveMember = <ThrowOnError extends boolean = false>(options: Options<OrganizationDefaultMemberControllerRemoveMemberData, ThrowOnError>) => (options.client ?? client).delete<OrganizationDefaultMemberControllerRemoveMemberResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization-defaults/members/{organizationId}/{resourceType}/{userId}',
    ...options
});

/**
 * get user organization
 */
export const organizationUsersControllerGetOrganizationUsers = <ThrowOnError extends boolean = false>(options: Options<OrganizationUsersControllerGetOrganizationUsersData, ThrowOnError>) => (options.client ?? client).get<OrganizationUsersControllerGetOrganizationUsersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization/{organizationId}/users',
    ...options
});

/**
 * Invite a user to an organization
 */
export const organizationUsersControllerInviteUserToOrganization = <ThrowOnError extends boolean = false>(options: Options<OrganizationUsersControllerInviteUserToOrganizationData, ThrowOnError>) => (options.client ?? client).post<OrganizationUsersControllerInviteUserToOrganizationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization/{organizationId}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes a user from the organization by revoking their roles on it. The account is deactivated only when that leaves the user no access anywhere else
 */
export const organizationUsersControllerDeleteUserFromOrganizations = <ThrowOnError extends boolean = false>(options: Options<OrganizationUsersControllerDeleteUserFromOrganizationsData, ThrowOnError>) => (options.client ?? client).delete<OrganizationUsersControllerDeleteUserFromOrganizationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization/{organizationId}/users/{userId}',
    ...options
});

/**
 * Get user information for a specific organization
 */
export const organizationUsersControllerGetOrganizationUserWithPermissions = <ThrowOnError extends boolean = false>(options: Options<OrganizationUsersControllerGetOrganizationUserWithPermissionsData, ThrowOnError>) => (options.client ?? client).get<OrganizationUsersControllerGetOrganizationUserWithPermissionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/organization/{organizationId}/users/{userId}',
    ...options
});

/**
 * Gets info about the current deployment
 */
export const infoControllerDeploymentInfo = <ThrowOnError extends boolean = false>(options?: Options<InfoControllerDeploymentInfoData, ThrowOnError>) => (options?.client ?? client).get<InfoControllerDeploymentInfoResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/info',
    ...options
});

/**
 * Delete KYCFile
 */
export const shareholderKycControllerDeleteKycFile = <ThrowOnError extends boolean = false>(options?: Options<ShareholderKycControllerDeleteKycFileData, ThrowOnError>) => (options?.client ?? client).delete<ShareholderKycControllerDeleteKycFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/{id}',
    ...options
});

/**
 * Get shareholder proof of identity data
 */
export const shareholderKycControllerGetProofOfIdentity = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerGetProofOfIdentityData, ThrowOnError>) => (options.client ?? client).get<ShareholderKycControllerGetProofOfIdentityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/proof-of-identity',
    ...options
});

/**
 * Post new shareholder proof of identity file
 */
export const shareholderKycControllerPutProofOfIdentity = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerPutProofOfIdentityData, ThrowOnError>) => (options.client ?? client).put<ShareholderKycControllerPutProofOfIdentityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/proof-of-identity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get shareholder proof of address data
 */
export const shareholderKycControllerGetProofOfAddress = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerGetProofOfAddressData, ThrowOnError>) => (options.client ?? client).get<ShareholderKycControllerGetProofOfAddressResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/proof-of-address',
    ...options
});

/**
 * Post new shareholder proof of address file
 */
export const shareholderKycControllerPutProofOfAddress = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerPutProofOfAddressData, ThrowOnError>) => (options.client ?? client).put<ShareholderKycControllerPutProofOfAddressResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/proof-of-address',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get shareholder investment vehicle data kyc files
 */
export const shareholderKycControllerGetInvestmentVehicleKycFiles = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerGetInvestmentVehicleKycFilesData, ThrowOnError>) => (options.client ?? client).get<ShareholderKycControllerGetInvestmentVehicleKycFilesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/investment-vehicle',
    ...options
});

/**
 * Post new shareholder proof of identity file
 */
export const shareholderKycControllerPostInvestmentVehicle = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerPostInvestmentVehicleData, ThrowOnError>) => (options.client ?? client).post<ShareholderKycControllerPostInvestmentVehicleResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/investment-vehicle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get investor KYC forms for a workflow from DocumentWorkflow (flag-gated)
 */
export const shareholderKycControllerGetInvestorKycForms = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerGetInvestorKycFormsData, ThrowOnError>) => (options.client ?? client).get<ShareholderKycControllerGetInvestorKycFormsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/kyc-forms-documentworkflow',
    ...options
});

/**
 * Pre-fill a KYC form with the investor data before they complete it
 */
export const shareholderKycControllerPreFillInvestorKycForm = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerPreFillInvestorKycFormData, ThrowOnError>) => (options.client ?? client).post<ShareholderKycControllerPreFillInvestorKycFormResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/kyc-form/{templateId}/prefill',
    ...options
});

/**
 * Add a new shareholder filled kyc form to kyc forms
 */
export const shareholderKycControllerAddFilledKycForm = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerAddFilledKycFormData, ThrowOnError>) => (options.client ?? client).post<ShareholderKycControllerAddFilledKycFormResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/kyc-form',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove an uploaded KYC form
 */
export const shareholderKycControllerRemoveInvestorForm = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerRemoveInvestorFormData, ThrowOnError>) => (options.client ?? client).delete<ShareholderKycControllerRemoveInvestorFormResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/kyc-form/{templateId}',
    ...options
});

/**
 * Confirm inherited KYC form unchanged
 */
export const shareholderKycControllerConfirmInvestorForm = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerConfirmInvestorFormData, ThrowOnError>) => (options.client ?? client).patch<ShareholderKycControllerConfirmInvestorFormResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/kyc-form/{templateId}/confirm',
    ...options
});

/**
 * Get shareholder declarations data
 */
export const shareholderKycControllerGetDeclarations = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerGetDeclarationsData, ThrowOnError>) => (options.client ?? client).get<ShareholderKycControllerGetDeclarationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/declarations',
    ...options
});

/**
 * Update shareholder declarations data
 */
export const shareholderKycControllerPatchDeclarations = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerPatchDeclarationsData, ThrowOnError>) => (options.client ?? client).patch<ShareholderKycControllerPatchDeclarationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/declarations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm inherited KYC file unchanged
 */
export const shareholderKycControllerConfirmKycFile = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerConfirmKycFileData, ThrowOnError>) => (options.client ?? client).patch<ShareholderKycControllerConfirmKycFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/kyc-file/{id}/confirm',
    ...options
});

/**
 * Change how an uploaded KYC file is certified, or nominate a different certifier
 */
export const shareholderKycControllerChangeKycFileCertification = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerChangeKycFileCertificationData, ThrowOnError>) => (options.client ?? client).put<ShareholderKycControllerChangeKycFileCertificationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/kyc-file/{id}/certification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend the certifier's invitation for a KYC file
 */
export const shareholderKycControllerResendKycFileCertifierInvitation = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerResendKycFileCertifierInvitationData, ThrowOnError>) => (options.client ?? client).post<ShareholderKycControllerResendKycFileCertifierInvitationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/kyc-file/{id}/certification/resend',
    ...options
});

/**
 * Confirm inherited declaration unchanged
 */
export const shareholderKycControllerConfirmDeclaration = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerConfirmDeclarationData, ThrowOnError>) => (options.client ?? client).patch<ShareholderKycControllerConfirmDeclarationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/declaration/{id}/confirm',
    ...options
});

/**
 * Set flag for more PIV documents
 */
export const shareholderKycControllerSetOffMorePivDocuments = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerSetOffMorePivDocumentsData, ThrowOnError>) => (options.client ?? client).patch<ShareholderKycControllerSetOffMorePivDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/set-off-more-piv-documents',
    ...options
});

/**
 * Restore soft-deleted inherited KYC items back to pending confirmation
 */
export const shareholderKycControllerResetInherited = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerResetInheritedData, ThrowOnError>) => (options.client ?? client).patch<ShareholderKycControllerResetInheritedResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/reset-inherited',
    ...options
});

/**
 * Get standalone KYC workflow metadata for investor
 */
export const shareholderKycControllerGetStandaloneKycMetadata = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerGetStandaloneKycMetadataData, ThrowOnError>) => (options.client ?? client).get<ShareholderKycControllerGetStandaloneKycMetadataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/standalone/{kycWorkflowId}',
    ...options
});

/**
 * Download pre-filled kyc form file
 */
export const shareholderKycControllerDownloadPreFilledKycFormFile = <ThrowOnError extends boolean = false>(options: Options<ShareholderKycControllerDownloadPreFilledKycFormFileData, ThrowOnError>) => (options.client ?? client).get<ShareholderKycControllerDownloadPreFilledKycFormFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/kyc/pre-filled-form-file/{kycFormCustomDetailId}',
    ...options
});

/**
 * Get user persons bank accounts
 */
export const shareholderBankAccountControllerGetUserBankAccount = <ThrowOnError extends boolean = false>(options: Options<ShareholderBankAccountControllerGetUserBankAccountData, ThrowOnError>) => (options.client ?? client).get<ShareholderBankAccountControllerGetUserBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/bank-account',
    ...options
});

/**
 * Create or update bank account data
 */
export const shareholderBankAccountControllerUpsertBankAccount = <ThrowOnError extends boolean = false>(options: Options<ShareholderBankAccountControllerUpsertBankAccountData, ThrowOnError>) => (options.client ?? client).post<ShareholderBankAccountControllerUpsertBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/bank-account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete one of the user's own bank accounts
 */
export const shareholderBankAccountControllerDeleteBankAccount = <ThrowOnError extends boolean = false>(options: Options<ShareholderBankAccountControllerDeleteBankAccountData, ThrowOnError>) => (options.client ?? client).delete<ShareholderBankAccountControllerDeleteBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/bank-account/{id}',
    ...options
});

/**
 * Email a confirmation code for an own bank account
 */
export const shareholderBankAccountControllerRequestBankAccountCode = <ThrowOnError extends boolean = false>(options: Options<ShareholderBankAccountControllerRequestBankAccountCodeData, ThrowOnError>) => (options.client ?? client).post<ShareholderBankAccountControllerRequestBankAccountCodeResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/bank-account/{id}/request-code',
    ...options
});

/**
 * Confirm an own bank account with the emailed code
 */
export const shareholderBankAccountControllerConfirmBankAccount = <ThrowOnError extends boolean = false>(options: Options<ShareholderBankAccountControllerConfirmBankAccountData, ThrowOnError>) => (options.client ?? client).post<ShareholderBankAccountControllerConfirmBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/bank-account/{id}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify an own bank account's identifiers per format rule and log the lookup
 */
export const shareholderBankAccountControllerValidateBankAccount = <ThrowOnError extends boolean = false>(options: Options<ShareholderBankAccountControllerValidateBankAccountData, ThrowOnError>) => (options.client ?? client).post<ShareholderBankAccountControllerValidateBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/bank-account/{id}/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get mip custom details
 */
export const shareholderCustomDetailControllerGetShareholderCustomDetailData = <ThrowOnError extends boolean = false>(options?: Options<ShareholderCustomDetailControllerGetShareholderCustomDetailDataData, ThrowOnError>) => (options?.client ?? client).get<ShareholderCustomDetailControllerGetShareholderCustomDetailDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/custom-detail',
    ...options
});

/**
 * Update investor bank account data
 */
export const shareholderCustomDetailControllerUpdateShareholderInvestorData = <ThrowOnError extends boolean = false>(options: Options<ShareholderCustomDetailControllerUpdateShareholderInvestorDataData, ThrowOnError>) => (options.client ?? client).put<ShareholderCustomDetailControllerUpdateShareholderInvestorDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/custom-detail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get list of actionable contracts for investor
 */
export const shareholderContractControllerGetListOfActionableDocuments = <ThrowOnError extends boolean = false>(options: Options<ShareholderContractControllerGetListOfActionableDocumentsData, ThrowOnError>) => (options.client ?? client).get<ShareholderContractControllerGetListOfActionableDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/contract/transaction/investor/{investorId}/signable-documents',
    ...options
});

/**
 * Stream signable-documents change signals for an investor
 */
export const shareholderContractControllerStreamSignableDocuments = <ThrowOnError extends boolean = false>(options: Options<ShareholderContractControllerStreamSignableDocumentsData, ThrowOnError>) => (options.client ?? client).get<ShareholderContractControllerStreamSignableDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/contract/transaction/investor/{investorId}/programme/{mipId}/signable-documents/stream',
    ...options
});

/**
 * Marks a document workflow instance as reviewed
 */
export const shareholderContractControllerReviewDocument = <ThrowOnError extends boolean = false>(options: Options<ShareholderContractControllerReviewDocumentData, ThrowOnError>) => (options.client ?? client).post<ShareholderContractControllerReviewDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/contract/review-document-workflow/{documentWorkflowInstanceId}',
    ...options
});

/**
 * Generate signable documents for investor
 */
export const shareholderContractControllerGenerateSignableDocuments = <ThrowOnError extends boolean = false>(options: Options<ShareholderContractControllerGenerateSignableDocumentsData, ThrowOnError>) => (options.client ?? client).post<ShareholderContractControllerGenerateSignableDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/contract/transaction/investor/{investorId}/generate-signable-documents',
    ...options
});

/**
 * Download prefillable form file
 */
export const shareholderContractControllerGeneratePrefillableFormFile = <ThrowOnError extends boolean = false>(options: Options<ShareholderContractControllerGeneratePrefillableFormFileData, ThrowOnError>) => (options.client ?? client).get<ShareholderContractControllerGeneratePrefillableFormFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/contract/download-prefillable-form-file/{fileId}/{instanceSignatureId}',
    ...options
});

/**
 * Get detailed user investment by mip id
 */
export const investmentControllerGetInvestmentDetails = <ThrowOnError extends boolean = false>(options: Options<InvestmentControllerGetInvestmentDetailsData, ThrowOnError>) => (options.client ?? client).get<InvestmentControllerGetInvestmentDetailsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investment/by-mip-id/{mipId}',
    ...options
});

/**
 * Get user investments with SDW documents
 */
export const investmentControllerGetInvestmentsAndSdwDocuments = <ThrowOnError extends boolean = false>(options?: Options<InvestmentControllerGetInvestmentsAndSdwDocumentsData, ThrowOnError>) => (options?.client ?? client).get<InvestmentControllerGetInvestmentsAndSdwDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investment/with-sdw-documents',
    ...options
});

/**
 * Get specific investor investment with sdw documents
 */
export const investmentControllerGetInvestmentV2 = <ThrowOnError extends boolean = false>(options: Options<InvestmentControllerGetInvestmentV2Data, ThrowOnError>) => (options.client ?? client).get<InvestmentControllerGetInvestmentV2Responses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investment/with-sdw-documents/{investorId}',
    ...options
});

/**
 * Get list of investor valuations
 */
export const investmentControllerGetAllInvestmentValuations = <ThrowOnError extends boolean = false>(options?: Options<InvestmentControllerGetAllInvestmentValuationsData, ThrowOnError>) => (options?.client ?? client).get<InvestmentControllerGetAllInvestmentValuationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investment/valuations',
    ...options
});

/**
 * Get vesting data for a specific security of an investor
 */
export const investmentControllerGetSecurityVestingData = <ThrowOnError extends boolean = false>(options: Options<InvestmentControllerGetSecurityVestingDataData, ThrowOnError>) => (options.client ?? client).get<InvestmentControllerGetSecurityVestingDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investment/vesting/{investorId}/{securityId}',
    ...options
});

/**
 * Get specific investor valuations
 */
export const investmentControllerGetInvestmentValuations = <ThrowOnError extends boolean = false>(options: Options<InvestmentControllerGetInvestmentValuationsData, ThrowOnError>) => (options.client ?? client).get<InvestmentControllerGetInvestmentValuationsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investment/valuations/{investorId}',
    ...options
});

/**
 * Get payment instruction file
 */
export const investmentControllerGetInvestmentPaymentInstruction = <ThrowOnError extends boolean = false>(options?: Options<InvestmentControllerGetInvestmentPaymentInstructionData, ThrowOnError>) => (options?.client ?? client).get<InvestmentControllerGetInvestmentPaymentInstructionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investment/payment-instruction-template',
    ...options
});

/**
 * Get simple list of user investments
 */
export const investmentControllerGetUserInvestmentsList = <ThrowOnError extends boolean = false>(options?: Options<InvestmentControllerGetUserInvestmentsListData, ThrowOnError>) => (options?.client ?? client).get<InvestmentControllerGetUserInvestmentsListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investment/user-investments',
    ...options
});

/**
 * Link the bank account entered by the investor to their investment
 */
export const investmentControllerSetSelectedBankAccount = <ThrowOnError extends boolean = false>(options: Options<InvestmentControllerSetSelectedBankAccountData, ThrowOnError>) => (options.client ?? client).patch<InvestmentControllerSetSelectedBankAccountResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/shareholder/investment/{investmentWorkflowId}/selected-bank-account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add user OpenFGA relations to OpenFGA
 */
export const permissionControllerAddResourcePermissionsForUser = <ThrowOnError extends boolean = false>(options: Options<PermissionControllerAddResourcePermissionsForUserData, ThrowOnError>) => (options.client ?? client).post<PermissionControllerAddResourcePermissionsForUserResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/permissions/{resourceType}/{resourceId}/permissions/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove user OpenFGA relations to OpenFGA
 */
export const permissionControllerRemoveResourcePermissionForUser = <ThrowOnError extends boolean = false>(options: Options<PermissionControllerRemoveResourcePermissionForUserData, ThrowOnError>) => (options.client ?? client).post<PermissionControllerRemoveResourcePermissionForUserResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/permissions/{resourceType}/{resourceId}/permissions/delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove all user explicit permissions and sets the new permission roles
 */
export const permissionControllerSetResourcePermissionsForUser = <ThrowOnError extends boolean = false>(options: Options<PermissionControllerSetResourcePermissionsForUserData, ThrowOnError>) => (options.client ?? client).post<PermissionControllerSetResourcePermissionsForUserResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/permissions/{resourceType}/{resourceId}/permissions/set',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get MIP security allocations by security id
 */
export const programmeSecurityAllocationsControllerGetAllocationsBySecurityId = <ThrowOnError extends boolean = false>(options: Options<ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdData, ThrowOnError>) => (options.client ?? client).get<ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-security-allocations/security/{securityId}',
    ...options
});

/**
 * Get allocations available IP for security
 */
export const programmeSecurityAllocationsControllerGetAllocationMipListBySecurityId = <ThrowOnError extends boolean = false>(options: Options<ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdData, ThrowOnError>) => (options.client ?? client).get<ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-security-allocations/security/{securityId}/mip-list',
    ...options
});

/**
 * Create MIP security allocation
 */
export const programmeSecurityAllocationsControllerCreateAllocation = <ThrowOnError extends boolean = false>(options: Options<ProgrammeSecurityAllocationsControllerCreateAllocationData, ThrowOnError>) => (options.client ?? client).post<ProgrammeSecurityAllocationsControllerCreateAllocationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-security-allocations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete MIP security allocation
 */
export const programmeSecurityAllocationsControllerDeleteAllocation = <ThrowOnError extends boolean = false>(options: Options<ProgrammeSecurityAllocationsControllerDeleteAllocationData, ThrowOnError>) => (options.client ?? client).delete<ProgrammeSecurityAllocationsControllerDeleteAllocationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-security-allocations/{allocationId}',
    ...options
});

/**
 * Update MIP security allocation
 */
export const programmeSecurityAllocationsControllerUpdateAllocation = <ThrowOnError extends boolean = false>(options: Options<ProgrammeSecurityAllocationsControllerUpdateAllocationData, ThrowOnError>) => (options.client ?? client).put<ProgrammeSecurityAllocationsControllerUpdateAllocationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/programme-security-allocations/{allocationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend email delivery event
 */
export const resendControllerEmailEvent = <ThrowOnError extends boolean = false>(options: Options<ResendControllerEmailEventData, ThrowOnError>) => (options.client ?? client).post<ResendControllerEmailEventResponses, unknown, ThrowOnError>({ url: '/resend/webhooks/email-event', ...options });

/**
 * Get all articles
 */
export const helpBlogControllerGetArticles = <ThrowOnError extends boolean = false>(options: Options<HelpBlogControllerGetArticlesData, ThrowOnError>) => (options.client ?? client).get<HelpBlogControllerGetArticlesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/help-blog/{dataset}/articles',
    ...options
});

/**
 * Get all articles with entrypoint data
 */
export const helpBlogControllerGetEntrypointArticles = <ThrowOnError extends boolean = false>(options: Options<HelpBlogControllerGetEntrypointArticlesData, ThrowOnError>) => (options.client ?? client).get<HelpBlogControllerGetEntrypointArticlesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/help-blog/{dataset}/articles/entrypoints',
    ...options
});

/**
 * Get article by slug
 */
export const helpBlogControllerGetSlugArticle = <ThrowOnError extends boolean = false>(options: Options<HelpBlogControllerGetSlugArticleData, ThrowOnError>) => (options.client ?? client).get<HelpBlogControllerGetSlugArticleResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/help-blog/{dataset}/articles/{slug}',
    ...options
});

/**
 * Get all categories
 */
export const helpBlogControllerGetCategories = <ThrowOnError extends boolean = false>(options: Options<HelpBlogControllerGetCategoriesData, ThrowOnError>) => (options.client ?? client).get<HelpBlogControllerGetCategoriesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/help-blog/{dataset}/categories',
    ...options
});

/**
 * Get all authors
 */
export const helpBlogControllerGetAuthors = <ThrowOnError extends boolean = false>(options: Options<HelpBlogControllerGetAuthorsData, ThrowOnError>) => (options.client ?? client).get<HelpBlogControllerGetAuthorsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/help-blog/{dataset}/authors',
    ...options
});

/**
 * Get category by slug
 */
export const helpBlogControllerGetSlugCategory = <ThrowOnError extends boolean = false>(options: Options<HelpBlogControllerGetSlugCategoryData, ThrowOnError>) => (options.client ?? client).get<HelpBlogControllerGetSlugCategoryResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/help-blog/{dataset}/categories/{slug}',
    ...options
});

/**
 * Get author by slug
 */
export const helpBlogControllerGetSlugAuthor = <ThrowOnError extends boolean = false>(options: Options<HelpBlogControllerGetSlugAuthorData, ThrowOnError>) => (options.client ?? client).get<HelpBlogControllerGetSlugAuthorResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/help-blog/{dataset}/author/{slug}',
    ...options
});

/**
 * Get investors data for filter
 */
export const simpleDocumentWorkflowControllerGetInvestorsFilteringData = <ThrowOnError extends boolean = false>(options?: Options<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataData, ThrowOnError>) => (options?.client ?? client).get<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/simple-document-workflow/document-files',
    ...options
});

/**
 * Add document file to MIP
 */
export const simpleDocumentWorkflowControllerAddFileToMip = <ThrowOnError extends boolean = false>(options: Options<SimpleDocumentWorkflowControllerAddFileToMipData, ThrowOnError>) => (options.client ?? client).post<SimpleDocumentWorkflowControllerAddFileToMipResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/simple-document-workflow/document-file',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create documents and initiate submission generation
 */
export const simpleDocumentWorkflowControllerCreateDocuments = <ThrowOnError extends boolean = false>(options: Options<SimpleDocumentWorkflowControllerCreateDocumentsData, ThrowOnError>) => (options.client ?? client).post<SimpleDocumentWorkflowControllerCreateDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/simple-document-workflow/create-documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send master documents to investors
 */
export const simpleDocumentWorkflowControllerSendMasterDocuments = <ThrowOnError extends boolean = false>(options: Options<SimpleDocumentWorkflowControllerSendMasterDocumentsData, ThrowOnError>) => (options.client ?? client).post<SimpleDocumentWorkflowControllerSendMasterDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/simple-document-workflow/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove document file
 */
export const simpleDocumentWorkflowControllerRemoveDocumentFile = <ThrowOnError extends boolean = false>(options: Options<SimpleDocumentWorkflowControllerRemoveDocumentFileData, ThrowOnError>) => (options.client ?? client).delete<SimpleDocumentWorkflowControllerRemoveDocumentFileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/mip/simple-document-workflow/remove/{documentWorkflowFileId}',
    ...options
});

/**
 * Get person ranks
 */
export const securityRankDefinitionControllerGetPersonRanks = <ThrowOnError extends boolean = false>(options: Options<SecurityRankDefinitionControllerGetPersonRanksData, ThrowOnError>) => (options.client ?? client).get<SecurityRankDefinitionControllerGetPersonRanksResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/securityRankDefinition/{personId}',
    ...options
});

/**
 * Create rank
 */
export const securityRankDefinitionControllerCreateRank = <ThrowOnError extends boolean = false>(options: Options<SecurityRankDefinitionControllerCreateRankData, ThrowOnError>) => (options.client ?? client).post<SecurityRankDefinitionControllerCreateRankResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/securityRankDefinition',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft delete rank
 */
export const securityRankDefinitionControllerSoftDeleteRank = <ThrowOnError extends boolean = false>(options: Options<SecurityRankDefinitionControllerSoftDeleteRankData, ThrowOnError>) => (options.client ?? client).delete<SecurityRankDefinitionControllerSoftDeleteRankResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/securityRankDefinition/{rankId}',
    ...options
});

/**
 * Update rank
 */
export const securityRankDefinitionControllerUpdateRank = <ThrowOnError extends boolean = false>(options: Options<SecurityRankDefinitionControllerUpdateRankData, ThrowOnError>) => (options.client ?? client).put<SecurityRankDefinitionControllerUpdateRankResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/securityRankDefinition/{rankId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upsert security rank
 */
export const securityRankControllerUpsertSecurityRank = <ThrowOnError extends boolean = false>(options: Options<SecurityRankControllerUpsertSecurityRankData, ThrowOnError>) => (options.client ?? client).post<SecurityRankControllerUpsertSecurityRankResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security-rank',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upsert security income ranks
 */
export const securityRankControllerUpsertSecurityIncomeRanks = <ThrowOnError extends boolean = false>(options: Options<SecurityRankControllerUpsertSecurityIncomeRanksData, ThrowOnError>) => (options.client ?? client).post<SecurityRankControllerUpsertSecurityIncomeRanksResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security-rank/income',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete security rank
 */
export const securityRankControllerDeleteSecurityRank = <ThrowOnError extends boolean = false>(options: Options<SecurityRankControllerDeleteSecurityRankData, ThrowOnError>) => (options.client ?? client).delete<SecurityRankControllerDeleteSecurityRankResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security-rank/{id}',
    ...options
});

/**
 * Delete security income ranks
 */
export const securityRankControllerDeleteSecurityIncomeRanks = <ThrowOnError extends boolean = false>(options: Options<SecurityRankControllerDeleteSecurityIncomeRanksData, ThrowOnError>) => (options.client ?? client).delete<SecurityRankControllerDeleteSecurityIncomeRanksResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security-rank/income/{securityId}',
    ...options
});

/**
 * Delete ratchet schedule for a security
 */
export const securityRatchetControllerDeleteSchedule = <ThrowOnError extends boolean = false>(options: Options<SecurityRatchetControllerDeleteScheduleData, ThrowOnError>) => (options.client ?? client).delete<SecurityRatchetControllerDeleteScheduleResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security-ratchet/{securityId}',
    ...options
});

/**
 * Get ratchet schedule for a security
 */
export const securityRatchetControllerGetSchedule = <ThrowOnError extends boolean = false>(options: Options<SecurityRatchetControllerGetScheduleData, ThrowOnError>) => (options.client ?? client).get<SecurityRatchetControllerGetScheduleResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security-ratchet/{securityId}',
    ...options
});

/**
 * Create or update ratchet schedule for a security
 */
export const securityRatchetControllerUpsertSchedule = <ThrowOnError extends boolean = false>(options: Options<SecurityRatchetControllerUpsertScheduleData, ThrowOnError>) => (options.client ?? client).post<SecurityRatchetControllerUpsertScheduleResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/security-ratchet/{securityId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List email schedule configs for a programme (one per handler type)
 */
export const emailSchedulerControllerListConfigs = <ThrowOnError extends boolean = false>(options: Options<EmailSchedulerControllerListConfigsData, ThrowOnError>) => (options.client ?? client).get<EmailSchedulerControllerListConfigsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/config',
    ...options
});

/**
 * Create or update an email schedule config for a programme
 */
export const emailSchedulerControllerUpsertConfig = <ThrowOnError extends boolean = false>(options: Options<EmailSchedulerControllerUpsertConfigData, ThrowOnError>) => (options.client ?? client).put<EmailSchedulerControllerUpsertConfigResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List scheduled emails for a programme, optionally filtered by status and/or documentWorkflowInstanceId
 */
export const emailSchedulerControllerListSchedules = <ThrowOnError extends boolean = false>(options: Options<EmailSchedulerControllerListSchedulesData, ThrowOnError>) => (options.client ?? client).get<EmailSchedulerControllerListSchedulesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules',
    ...options
});

/**
 * Create (start) a signing-reminder schedule for a document workflow instance
 */
export const emailSchedulerControllerCreateSchedule = <ThrowOnError extends boolean = false>(options: Options<EmailSchedulerControllerCreateScheduleData, ThrowOnError>) => (options.client ?? client).post<EmailSchedulerControllerCreateScheduleResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel a scheduled email
 */
export const emailSchedulerControllerCancel = <ThrowOnError extends boolean = false>(options: Options<EmailSchedulerControllerCancelData, ThrowOnError>) => (options.client ?? client).post<EmailSchedulerControllerCancelResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules/{id}/cancel',
    ...options
});

/**
 * Reschedule a scheduled email to a new fire time
 */
export const emailSchedulerControllerReschedule = <ThrowOnError extends boolean = false>(options: Options<EmailSchedulerControllerRescheduleData, ThrowOnError>) => (options.client ?? client).post<EmailSchedulerControllerRescheduleResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules/{id}/reschedule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Re-activate a terminated scheduled email
 */
export const emailSchedulerControllerRestart = <ThrowOnError extends boolean = false>(options: Options<EmailSchedulerControllerRestartData, ThrowOnError>) => (options.client ?? client).post<EmailSchedulerControllerRestartResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules/{id}/restart',
    ...options
});

/**
 * Fire a scheduled email immediately, out of band
 */
export const emailSchedulerControllerSendNow = <ThrowOnError extends boolean = false>(options: Options<EmailSchedulerControllerSendNowData, ThrowOnError>) => (options.client ?? client).post<EmailSchedulerControllerSendNowResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules/{id}/send-now',
    ...options
});

/**
 * Set or clear a scheduled email's end date
 */
export const emailSchedulerControllerSetEndDate = <ThrowOnError extends boolean = false>(options: Options<EmailSchedulerControllerSetEndDateData, ThrowOnError>) => (options.client ?? client).put<EmailSchedulerControllerSetEndDateResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'connect.sid',
            type: 'apiKey'
        }],
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules/{id}/end-date',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
